export const data = {
  "0": "\u0030",
  "1": "\u0031",
  "2": "\u0032",
  "3": "\u0033",
  "4": "\u0034",
  "5": "\u0035",
  "6": "\u0036",
  "7": "\u0037",
  "8": "\u0038",
  "9": "\u0039",
  "00": "\ue467",
  "360-degrees": "\ue2dc",
  "42-group": "\ue080",
  "500px": "\uf26e",
  a: "\u0041",
  abacus: "\uf640",
  "accent-grave": "\u0060",
  "accessible-icon": "\uf368",
  accusoft: "\uf369",
  acorn: "\uf6ae",
  "address-book": "\uf2b9",
  "address-card": "\uf2bb",
  adn: "\uf170",
  adversal: "\uf36a",
  affiliatetheme: "\uf36b",
  "air-conditioner": "\uf8f4",
  airbnb: "\uf834",
  airplay: "\ue089",
  "alarm-clock": "\uf34e",
  "alarm-exclamation": "\uf843",
  "alarm-plus": "\uf844",
  "alarm-snooze": "\uf845",
  album: "\uf89f",
  "album-circle-plus": "\ue48c",
  "album-circle-user": "\ue48d",
  "album-collection": "\uf8a0",
  "album-collection-circle-plus": "\ue48e",
  "album-collection-circle-user": "\ue48f",
  algolia: "\uf36c",
  alicorn: "\uf6b0",
  alien: "\uf8f5",
  "alien-8bit": "\uf8f6",
  "align-center": "\uf037",
  "align-justify": "\uf039",
  "align-left": "\uf036",
  "align-right": "\uf038",
  "align-slash": "\uf846",
  alipay: "\uf642",
  alt: "\ue08a",
  amazon: "\uf270",
  "amazon-pay": "\uf42c",
  amilia: "\uf36d",
  "amp-guitar": "\uf8a1",
  ampersand: "\u0026",
  anchor: "\uf13d",
  "anchor-circle-check": "\ue4aa",
  "anchor-circle-exclamation": "\ue4ab",
  "anchor-circle-xmark": "\ue4ac",
  "anchor-lock": "\ue4ad",
  android: "\uf17b",
  angel: "\uf779",
  angellist: "\uf209",
  angle: "\ue08c",
  "angle-90": "\ue08d",
  "angle-down": "\uf107",
  "angle-left": "\uf104",
  "angle-right": "\uf105",
  "angle-up": "\uf106",
  "angles-down": "\uf103",
  "angles-left": "\uf100",
  "angles-right": "\uf101",
  "angles-up": "\uf102",
  angrycreative: "\uf36e",
  angular: "\uf420",
  ankh: "\uf644",
  apartment: "\ue468",
  aperture: "\ue2df",
  apostrophe: "\u0027",
  "app-store": "\uf36f",
  "app-store-ios": "\uf370",
  apper: "\uf371",
  apple: "\uf179",
  "apple-core": "\ue08f",
  "apple-pay": "\uf415",
  "apple-whole": "\uf5d1",
  archway: "\uf557",
  "arrow-down": "\uf063",
  "arrow-down-1-9": "\uf162",
  "arrow-down-9-1": "\uf886",
  "arrow-down-a-z": "\uf15d",
  "arrow-down-arrow-up": "\uf883",
  "arrow-down-big-small": "\uf88c",
  "arrow-down-from-dotted-line": "\ue090",
  "arrow-down-from-line": "\uf345",
  "arrow-down-left": "\ue091",
  "arrow-down-left-and-arrow-up-right-to-center": "\ue092",
  "arrow-down-long": "\uf175",
  "arrow-down-right": "\ue093",
  "arrow-down-short-wide": "\uf884",
  "arrow-down-small-big": "\uf88d",
  "arrow-down-square-triangle": "\uf889",
  "arrow-down-to-arc": "\ue4ae",
  "arrow-down-to-bracket": "\ue094",
  "arrow-down-to-dotted-line": "\ue095",
  "arrow-down-to-line": "\uf33d",
  "arrow-down-to-square": "\ue096",
  "arrow-down-triangle-square": "\uf888",
  "arrow-down-up-across-line": "\ue4af",
  "arrow-down-up-lock": "\ue4b0",
  "arrow-down-wide-short": "\uf160",
  "arrow-down-z-a": "\uf881",
  "arrow-left": "\uf060",
  "arrow-left-from-line": "\uf344",
  "arrow-left-long": "\uf177",
  "arrow-left-long-to-line": "\ue3d4",
  "arrow-left-to-line": "\uf33e",
  "arrow-pointer": "\uf245",
  "arrow-right": "\uf061",
  "arrow-right-arrow-left": "\uf0ec",
  "arrow-right-from-arc": "\ue4b1",
  "arrow-right-from-bracket": "\uf08b",
  "arrow-right-from-line": "\uf343",
  "arrow-right-long": "\uf178",
  "arrow-right-long-to-line": "\ue3d5",
  "arrow-right-to-arc": "\ue4b2",
  "arrow-right-to-bracket": "\uf090",
  "arrow-right-to-city": "\ue4b3",
  "arrow-right-to-line": "\uf340",
  "arrow-rotate-left": "\uf0e2",
  "arrow-rotate-right": "\uf01e",
  "arrow-trend-down": "\ue097",
  "arrow-trend-up": "\ue098",
  "arrow-turn-down": "\uf149",
  "arrow-turn-down-left": "\ue2e1",
  "arrow-turn-down-right": "\ue3d6",
  "arrow-turn-up": "\uf148",
  "arrow-up": "\uf062",
  "arrow-up-1-9": "\uf163",
  "arrow-up-9-1": "\uf887",
  "arrow-up-a-z": "\uf15e",
  "arrow-up-arrow-down": "\ue099",
  "arrow-up-big-small": "\uf88e",
  "arrow-up-from-arc": "\ue4b4",
  "arrow-up-from-bracket": "\ue09a",
  "arrow-up-from-dotted-line": "\ue09b",
  "arrow-up-from-ground-water": "\ue4b5",
  "arrow-up-from-line": "\uf342",
  "arrow-up-from-square": "\ue09c",
  "arrow-up-from-water-pump": "\ue4b6",
  "arrow-up-left": "\ue09d",
  "arrow-up-left-from-circle": "\ue09e",
  "arrow-up-long": "\uf176",
  "arrow-up-right": "\ue09f",
  "arrow-up-right-and-arrow-down-left-from-center": "\ue0a0",
  "arrow-up-right-dots": "\ue4b7",
  "arrow-up-right-from-square": "\uf08e",
  "arrow-up-short-wide": "\uf885",
  "arrow-up-small-big": "\uf88f",
  "arrow-up-square-triangle": "\uf88b",
  "arrow-up-to-dotted-line": "\ue0a1",
  "arrow-up-to-line": "\uf341",
  "arrow-up-triangle-square": "\uf88a",
  "arrow-up-wide-short": "\uf161",
  "arrow-up-z-a": "\uf882",
  "arrows-cross": "\ue0a2",
  "arrows-down-to-line": "\ue4b8",
  "arrows-down-to-people": "\ue4b9",
  "arrows-from-dotted-line": "\ue0a3",
  "arrows-from-line": "\ue0a4",
  "arrows-left-right": "\uf07e",
  "arrows-left-right-to-line": "\ue4ba",
  "arrows-maximize": "\uf31d",
  "arrows-minimize": "\ue0a5",
  "arrows-repeat": "\uf364",
  "arrows-repeat-1": "\uf366",
  "arrows-retweet": "\uf361",
  "arrows-rotate": "\uf021",
  "arrows-spin": "\ue4bb",
  "arrows-split-up-and-left": "\ue4bc",
  "arrows-to-circle": "\ue4bd",
  "arrows-to-dot": "\ue4be",
  "arrows-to-dotted-line": "\ue0a6",
  "arrows-to-eye": "\ue4bf",
  "arrows-to-line": "\ue0a7",
  "arrows-turn-right": "\ue4c0",
  "arrows-turn-to-dots": "\ue4c1",
  "arrows-up-down": "\uf07d",
  "arrows-up-down-left-right": "\uf047",
  "arrows-up-to-line": "\ue4c2",
  artstation: "\uf77a",
  asterisk: "\u002a",
  asymmetrik: "\uf372",
  at: "\u0040",
  atlassian: "\uf77b",
  atom: "\uf5d2",
  "atom-simple": "\uf5d3",
  audible: "\uf373",
  "audio-description": "\uf29e",
  "audio-description-slash": "\ue0a8",
  "austral-sign": "\ue0a9",
  autoprefixer: "\uf41c",
  avianex: "\uf374",
  aviato: "\uf421",
  avocado: "\ue0aa",
  award: "\uf559",
  "award-simple": "\ue0ab",
  aws: "\uf375",
  axe: "\uf6b2",
  "axe-battle": "\uf6b3",
  b: "\u0042",
  baby: "\uf77c",
  "baby-carriage": "\uf77d",
  backpack: "\uf5d4",
  backward: "\uf04a",
  "backward-fast": "\uf049",
  "backward-step": "\uf048",
  bacon: "\uf7e5",
  bacteria: "\ue059",
  bacterium: "\ue05a",
  badge: "\uf335",
  "badge-check": "\uf336",
  "badge-dollar": "\uf645",
  "badge-percent": "\uf646",
  "badge-sheriff": "\uf8a2",
  "badger-honey": "\uf6b4",
  badminton: "\ue33a",
  "bag-shopping": "\uf290",
  bagel: "\ue3d7",
  "bags-shopping": "\uf847",
  baguette: "\ue3d8",
  bahai: "\uf666",
  "baht-sign": "\ue0ac",
  "ball-pile": "\uf77e",
  balloon: "\ue2e3",
  balloons: "\ue2e4",
  ballot: "\uf732",
  "ballot-check": "\uf733",
  ban: "\uf05e",
  "ban-bug": "\uf7f9",
  "ban-parking": "\uf616",
  "ban-smoking": "\uf54d",
  banana: "\ue2e5",
  bandage: "\uf462",
  bandcamp: "\uf2d5",
  "bangladeshi-taka-sign": "\ue2e6",
  banjo: "\uf8a3",
  barcode: "\uf02a",
  "barcode-read": "\uf464",
  "barcode-scan": "\uf465",
  bars: "\uf0c9",
  "bars-filter": "\ue0ad",
  "bars-progress": "\uf828",
  "bars-sort": "\ue0ae",
  "bars-staggered": "\uf550",
  baseball: "\uf433",
  "baseball-bat-ball": "\uf432",
  "basket-shopping": "\uf291",
  "basket-shopping-simple": "\ue0af",
  basketball: "\uf434",
  "basketball-hoop": "\uf435",
  bat: "\uf6b5",
  bath: "\uf2cd",
  "battery-bolt": "\uf376",
  "battery-empty": "\uf244",
  "battery-exclamation": "\ue0b0",
  "battery-full": "\uf240",
  "battery-half": "\uf242",
  "battery-low": "\ue0b1",
  "battery-quarter": "\uf243",
  "battery-slash": "\uf377",
  "battery-three-quarters": "\uf241",
  "battle-net": "\uf835",
  bed: "\uf236",
  "bed-bunk": "\uf8f8",
  "bed-empty": "\uf8f9",
  "bed-front": "\uf8f7",
  "bed-pulse": "\uf487",
  bee: "\ue0b2",
  "beer-mug": "\ue0b3",
  "beer-mug-empty": "\uf0fc",
  behance: "\uf1b4",
  "behance-square": "\uf1b5",
  bell: "\uf0f3",
  "bell-concierge": "\uf562",
  "bell-exclamation": "\uf848",
  "bell-on": "\uf8fa",
  "bell-plus": "\uf849",
  "bell-school": "\uf5d5",
  "bell-school-slash": "\uf5d6",
  "bell-slash": "\uf1f6",
  bells: "\uf77f",
  "bench-tree": "\ue2e7",
  "bezier-curve": "\uf55b",
  bicycle: "\uf206",
  bilibili: "\ue3d9",
  bimobject: "\uf378",
  binary: "\ue33b",
  "binary-circle-check": "\ue33c",
  "binary-lock": "\ue33d",
  "binary-slash": "\ue33e",
  binoculars: "\uf1e5",
  biohazard: "\uf780",
  bird: "\ue469",
  bitbucket: "\uf171",
  bitcoin: "\uf379",
  "bitcoin-sign": "\ue0b4",
  bity: "\uf37a",
  "black-tie": "\uf27e",
  blackberry: "\uf37b",
  blanket: "\uf498",
  "blanket-fire": "\ue3da",
  blender: "\uf517",
  "blender-phone": "\uf6b6",
  blinds: "\uf8fb",
  "blinds-open": "\uf8fc",
  "blinds-raised": "\uf8fd",
  block: "\ue46a",
  "block-brick": "\ue3db",
  "block-brick-fire": "\ue3dc",
  "block-question": "\ue3dd",
  "block-quote": "\ue0b5",
  blog: "\uf781",
  blogger: "\uf37c",
  "blogger-b": "\uf37d",
  blueberries: "\ue2e8",
  bluetooth: "\uf293",
  "bluetooth-b": "\uf294",
  bold: "\uf032",
  bolt: "\uf0e7",
  "bolt-auto": "\ue0b6",
  "bolt-lightning": "\ue0b7",
  "bolt-slash": "\ue0b8",
  bomb: "\uf1e2",
  bone: "\uf5d7",
  "bone-break": "\uf5d8",
  bong: "\uf55c",
  book: "\uf02d",
  "book-arrow-right": "\ue0b9",
  "book-arrow-up": "\ue0ba",
  "book-atlas": "\uf558",
  "book-bible": "\uf647",
  "book-blank": "\uf5d9",
  "book-bookmark": "\ue0bb",
  "book-circle-arrow-right": "\ue0bc",
  "book-circle-arrow-up": "\ue0bd",
  "book-copy": "\ue0be",
  "book-font": "\ue0bf",
  "book-heart": "\uf499",
  "book-journal-whills": "\uf66a",
  "book-medical": "\uf7e6",
  "book-open": "\uf518",
  "book-open-cover": "\ue0c0",
  "book-open-reader": "\uf5da",
  "book-quran": "\uf687",
  "book-section": "\ue0c1",
  "book-skull": "\uf6b7",
  "book-sparkles": "\uf6b8",
  "book-tanakh": "\uf827",
  "book-user": "\uf7e7",
  bookmark: "\uf02e",
  "bookmark-slash": "\ue0c2",
  books: "\uf5db",
  "books-medical": "\uf7e8",
  boombox: "\uf8a5",
  boot: "\uf782",
  "boot-heeled": "\ue33f",
  "booth-curtain": "\uf734",
  bootstrap: "\uf836",
  "border-all": "\uf84c",
  "border-bottom": "\uf84d",
  "border-bottom-right": "\uf854",
  "border-center-h": "\uf89c",
  "border-center-v": "\uf89d",
  "border-inner": "\uf84e",
  "border-left": "\uf84f",
  "border-none": "\uf850",
  "border-outer": "\uf851",
  "border-right": "\uf852",
  "border-top": "\uf855",
  "border-top-left": "\uf853",
  "bore-hole": "\ue4c3",
  bots: "\ue340",
  "bottle-droplet": "\ue4c4",
  "bottle-water": "\ue4c5",
  "bow-arrow": "\uf6b9",
  "bowl-chopsticks": "\ue2e9",
  "bowl-chopsticks-noodles": "\ue2ea",
  "bowl-food": "\ue4c6",
  "bowl-hot": "\uf823",
  "bowl-rice": "\ue2eb",
  "bowl-scoop": "\ue3de",
  "bowl-scoops": "\ue3df",
  "bowl-soft-serve": "\ue46b",
  "bowl-spoon": "\ue3e0",
  "bowling-ball": "\uf436",
  "bowling-ball-pin": "\ue0c3",
  "bowling-pins": "\uf437",
  box: "\uf466",
  "box-archive": "\uf187",
  "box-ballot": "\uf735",
  "box-check": "\uf467",
  "box-circle-check": "\ue0c4",
  "box-dollar": "\uf4a0",
  "box-heart": "\uf49d",
  "box-open": "\uf49e",
  "box-open-full": "\uf49c",
  "box-taped": "\uf49a",
  "box-tissue": "\ue05b",
  "boxes-packing": "\ue4c7",
  "boxes-stacked": "\uf468",
  "boxing-glove": "\uf438",
  "bracket-curly": "\u007b",
  "bracket-curly-right": "\u007d",
  "bracket-round": "\u0028",
  "bracket-round-right": "\u0029",
  "bracket-square": "\u005b",
  "bracket-square-right": "\u005d",
  "brackets-curly": "\uf7ea",
  "brackets-round": "\ue0c5",
  "brackets-square": "\uf7e9",
  braille: "\uf2a1",
  brain: "\uf5dc",
  "brain-arrow-curved-right": "\uf677",
  "brain-circuit": "\ue0c6",
  "brake-warning": "\ue0c7",
  "brazilian-real-sign": "\ue46c",
  "bread-loaf": "\uf7eb",
  "bread-slice": "\uf7ec",
  "bread-slice-butter": "\ue3e1",
  bridge: "\ue4c8",
  "bridge-circle-check": "\ue4c9",
  "bridge-circle-exclamation": "\ue4ca",
  "bridge-circle-xmark": "\ue4cb",
  "bridge-lock": "\ue4cc",
  "bridge-suspension": "\ue4cd",
  "bridge-water": "\ue4ce",
  briefcase: "\uf0b1",
  "briefcase-arrow-right": "\ue2f2",
  "briefcase-blank": "\ue0c8",
  "briefcase-medical": "\uf469",
  brightness: "\ue0c9",
  "brightness-low": "\ue0ca",
  "bring-forward": "\uf856",
  "bring-front": "\uf857",
  broccoli: "\ue3e2",
  broom: "\uf51a",
  "broom-ball": "\uf458",
  browser: "\uf37e",
  browsers: "\ue0cb",
  brush: "\uf55d",
  btc: "\uf15a",
  bucket: "\ue4cf",
  buffer: "\uf837",
  bug: "\uf188",
  "bug-slash": "\ue490",
  bugs: "\ue4d0",
  building: "\uf1ad",
  "building-circle-arrow-right": "\ue4d1",
  "building-circle-check": "\ue4d2",
  "building-circle-exclamation": "\ue4d3",
  "building-circle-xmark": "\ue4d4",
  "building-columns": "\uf19c",
  "building-flag": "\ue4d5",
  "building-lock": "\ue4d6",
  "building-ngo": "\ue4d7",
  "building-shield": "\ue4d8",
  "building-un": "\ue4d9",
  "building-user": "\ue4da",
  "building-wheat": "\ue4db",
  buildings: "\ue0cc",
  bullhorn: "\uf0a1",
  bullseye: "\uf140",
  "bullseye-arrow": "\uf648",
  "bullseye-pointer": "\uf649",
  burger: "\uf805",
  "burger-cheese": "\uf7f1",
  "burger-fries": "\ue0cd",
  "burger-glass": "\ue0ce",
  "burger-lettuce": "\ue3e3",
  "burger-soda": "\uf858",
  buromobelexperte: "\uf37f",
  burrito: "\uf7ed",
  burst: "\ue4dc",
  bus: "\uf207",
  "bus-school": "\uf5dd",
  "bus-simple": "\uf55e",
  "business-time": "\uf64a",
  butter: "\ue3e4",
  "buy-n-large": "\uf8a6",
  buysellads: "\uf20d",
  c: "\u0043",
  cabin: "\ue46d",
  "cabinet-filing": "\uf64b",
  "cable-car": "\ue0cf",
  cactus: "\uf8a7",
  "cake-candles": "\uf1fd",
  "cake-slice": "\ue3e5",
  calculator: "\uf1ec",
  "calculator-simple": "\uf64c",
  calendar: "\uf133",
  "calendar-arrow-down": "\ue0d0",
  "calendar-arrow-up": "\ue0d1",
  "calendar-check": "\uf274",
  "calendar-circle-exclamation": "\ue46e",
  "calendar-circle-minus": "\ue46f",
  "calendar-circle-plus": "\ue470",
  "calendar-circle-user": "\ue471",
  "calendar-clock": "\ue0d2",
  "calendar-day": "\uf783",
  "calendar-days": "\uf073",
  "calendar-exclamation": "\uf334",
  "calendar-heart": "\ue0d3",
  "calendar-image": "\ue0d4",
  "calendar-lines": "\ue0d5",
  "calendar-lines-pen": "\ue472",
  "calendar-minus": "\uf272",
  "calendar-pen": "\uf333",
  "calendar-plus": "\uf271",
  "calendar-range": "\ue0d6",
  "calendar-star": "\uf736",
  "calendar-week": "\uf784",
  "calendar-xmark": "\uf273",
  calendars: "\ue0d7",
  camcorder: "\uf8a8",
  camera: "\uf030",
  "camera-cctv": "\uf8ac",
  "camera-movie": "\uf8a9",
  "camera-polaroid": "\uf8aa",
  "camera-retro": "\uf083",
  "camera-rotate": "\ue0d8",
  "camera-security": "\uf8fe",
  "camera-slash": "\ue0d9",
  "camera-viewfinder": "\ue0da",
  "camera-web": "\uf832",
  "camera-web-slash": "\uf833",
  campfire: "\uf6ba",
  campground: "\uf6bb",
  "can-food": "\ue3e6",
  "canadian-maple-leaf": "\uf785",
  "candle-holder": "\uf6bc",
  candy: "\ue3e7",
  "candy-bar": "\ue3e8",
  "candy-cane": "\uf786",
  "candy-corn": "\uf6bd",
  cannabis: "\uf55f",
  capsules: "\uf46b",
  car: "\uf1b9",
  "car-battery": "\uf5df",
  "car-bolt": "\ue341",
  "car-building": "\uf859",
  "car-bump": "\uf5e0",
  "car-burst": "\uf5e1",
  "car-bus": "\uf85a",
  "car-circle-bolt": "\ue342",
  "car-garage": "\uf5e2",
  "car-mirrors": "\ue343",
  "car-on": "\ue4dd",
  "car-rear": "\uf5de",
  "car-side": "\uf5e4",
  "car-side-bolt": "\ue344",
  "car-tilt": "\uf5e5",
  "car-tunnel": "\ue4de",
  "car-wash": "\uf5e6",
  "car-wrench": "\uf5e3",
  caravan: "\uf8ff",
  "caravan-simple": "\ue000",
  "card-club": "\ue3e9",
  "card-diamond": "\ue3ea",
  "card-heart": "\ue3eb",
  "card-spade": "\ue3ec",
  cards: "\ue3ed",
  "cards-blank": "\ue4df",
  "caret-down": "\uf0d7",
  "caret-left": "\uf0d9",
  "caret-right": "\uf0da",
  "caret-up": "\uf0d8",
  carrot: "\uf787",
  cars: "\uf85b",
  "cart-arrow-down": "\uf218",
  "cart-arrow-up": "\ue3ee",
  "cart-circle-arrow-down": "\ue3ef",
  "cart-circle-arrow-up": "\ue3f0",
  "cart-circle-check": "\ue3f1",
  "cart-circle-exclamation": "\ue3f2",
  "cart-circle-plus": "\ue3f3",
  "cart-circle-xmark": "\ue3f4",
  "cart-flatbed": "\uf474",
  "cart-flatbed-boxes": "\uf475",
  "cart-flatbed-empty": "\uf476",
  "cart-flatbed-suitcase": "\uf59d",
  "cart-minus": "\ue0db",
  "cart-plus": "\uf217",
  "cart-shopping": "\uf07a",
  "cart-shopping-fast": "\ue0dc",
  "cart-xmark": "\ue0dd",
  "cash-register": "\uf788",
  "cassette-betamax": "\uf8a4",
  "cassette-tape": "\uf8ab",
  "cassette-vhs": "\uf8ec",
  castle: "\ue0de",
  cat: "\uf6be",
  "cat-space": "\ue001",
  cauldron: "\uf6bf",
  "cc-amazon-pay": "\uf42d",
  "cc-amex": "\uf1f3",
  "cc-apple-pay": "\uf416",
  "cc-diners-club": "\uf24c",
  "cc-discover": "\uf1f2",
  "cc-jcb": "\uf24b",
  "cc-mastercard": "\uf1f1",
  "cc-paypal": "\uf1f4",
  "cc-stripe": "\uf1f5",
  "cc-visa": "\uf1f0",
  "cedi-sign": "\ue0df",
  "cent-sign": "\ue3f5",
  centercode: "\uf380",
  centos: "\uf789",
  certificate: "\uf0a3",
  chair: "\uf6c0",
  "chair-office": "\uf6c1",
  chalkboard: "\uf51b",
  "chalkboard-user": "\uf51c",
  "champagne-glass": "\uf79e",
  "champagne-glasses": "\uf79f",
  "charging-station": "\uf5e7",
  "chart-area": "\uf1fe",
  "chart-bar": "\uf080",
  "chart-bullet": "\ue0e1",
  "chart-candlestick": "\ue0e2",
  "chart-column": "\ue0e3",
  "chart-gantt": "\ue0e4",
  "chart-line": "\uf201",
  "chart-line-down": "\uf64d",
  "chart-line-up": "\ue0e5",
  "chart-mixed": "\uf643",
  "chart-network": "\uf78a",
  "chart-pie": "\uf200",
  "chart-pie-simple": "\uf64e",
  "chart-pyramid": "\ue0e6",
  "chart-radar": "\ue0e7",
  "chart-scatter": "\uf7ee",
  "chart-scatter-3d": "\ue0e8",
  "chart-scatter-bubble": "\ue0e9",
  "chart-simple": "\ue473",
  "chart-simple-horizontal": "\ue474",
  "chart-tree-map": "\ue0ea",
  "chart-user": "\uf6a3",
  "chart-waterfall": "\ue0eb",
  check: "\uf00c",
  "check-double": "\uf560",
  "check-to-slot": "\uf772",
  cheese: "\uf7ef",
  "cheese-swiss": "\uf7f0",
  cherries: "\ue0ec",
  chess: "\uf439",
  "chess-bishop": "\uf43a",
  "chess-bishop-piece": "\uf43b",
  "chess-board": "\uf43c",
  "chess-clock": "\uf43d",
  "chess-clock-flip": "\uf43e",
  "chess-king": "\uf43f",
  "chess-king-piece": "\uf440",
  "chess-knight": "\uf441",
  "chess-knight-piece": "\uf442",
  "chess-pawn": "\uf443",
  "chess-pawn-piece": "\uf444",
  "chess-queen": "\uf445",
  "chess-queen-piece": "\uf446",
  "chess-rook": "\uf447",
  "chess-rook-piece": "\uf448",
  chestnut: "\ue3f6",
  "chevron-down": "\uf078",
  "chevron-left": "\uf053",
  "chevron-right": "\uf054",
  "chevron-up": "\uf077",
  "chevrons-down": "\uf322",
  "chevrons-left": "\uf323",
  "chevrons-right": "\uf324",
  "chevrons-up": "\uf325",
  child: "\uf1ae",
  "child-dress": "\ue59c",
  "child-reaching": "\ue59d",
  "child-rifle": "\ue4e0",
  children: "\ue4e1",
  chimney: "\uf78b",
  chopsticks: "\ue3f7",
  chrome: "\uf268",
  chromecast: "\uf838",
  church: "\uf51d",
  circle: "\uf111",
  "circle-0": "\ue0ed",
  "circle-1": "\ue0ee",
  "circle-2": "\ue0ef",
  "circle-3": "\ue0f0",
  "circle-4": "\ue0f1",
  "circle-5": "\ue0f2",
  "circle-6": "\ue0f3",
  "circle-7": "\ue0f4",
  "circle-8": "\ue0f5",
  "circle-9": "\ue0f6",
  "circle-a": "\ue0f7",
  "circle-ampersand": "\ue0f8",
  "circle-arrow-down": "\uf0ab",
  "circle-arrow-down-left": "\ue0f9",
  "circle-arrow-down-right": "\ue0fa",
  "circle-arrow-left": "\uf0a8",
  "circle-arrow-right": "\uf0a9",
  "circle-arrow-up": "\uf0aa",
  "circle-arrow-up-left": "\ue0fb",
  "circle-arrow-up-right": "\ue0fc",
  "circle-b": "\ue0fd",
  "circle-bolt": "\ue0fe",
  "circle-book-open": "\ue0ff",
  "circle-bookmark": "\ue100",
  "circle-c": "\ue101",
  "circle-calendar": "\ue102",
  "circle-camera": "\ue103",
  "circle-caret-down": "\uf32d",
  "circle-caret-left": "\uf32e",
  "circle-caret-right": "\uf330",
  "circle-caret-up": "\uf331",
  "circle-check": "\uf058",
  "circle-chevron-down": "\uf13a",
  "circle-chevron-left": "\uf137",
  "circle-chevron-right": "\uf138",
  "circle-chevron-up": "\uf139",
  "circle-d": "\ue104",
  "circle-dashed": "\ue105",
  "circle-divide": "\ue106",
  "circle-dollar": "\uf2e8",
  "circle-dollar-to-slot": "\uf4b9",
  "circle-dot": "\uf192",
  "circle-down": "\uf358",
  "circle-down-left": "\ue107",
  "circle-down-right": "\ue108",
  "circle-e": "\ue109",
  "circle-ellipsis": "\ue10a",
  "circle-ellipsis-vertical": "\ue10b",
  "circle-envelope": "\ue10c",
  "circle-exclamation": "\uf06a",
  "circle-exclamation-check": "\ue10d",
  "circle-f": "\ue10e",
  "circle-g": "\ue10f",
  "circle-h": "\uf47e",
  "circle-half": "\ue110",
  "circle-half-stroke": "\uf042",
  "circle-heart": "\uf4c7",
  "circle-i": "\ue111",
  "circle-info": "\uf05a",
  "circle-j": "\ue112",
  "circle-k": "\ue113",
  "circle-l": "\ue114",
  "circle-left": "\uf359",
  "circle-location-arrow": "\uf602",
  "circle-m": "\ue115",
  "circle-microphone": "\ue116",
  "circle-microphone-lines": "\ue117",
  "circle-minus": "\uf056",
  "circle-n": "\ue118",
  "circle-nodes": "\ue4e2",
  "circle-notch": "\uf1ce",
  "circle-o": "\ue119",
  "circle-p": "\ue11a",
  "circle-parking": "\uf615",
  "circle-pause": "\uf28b",
  "circle-phone": "\ue11b",
  "circle-phone-flip": "\ue11c",
  "circle-phone-hangup": "\ue11d",
  "circle-play": "\uf144",
  "circle-plus": "\uf055",
  "circle-q": "\ue11e",
  "circle-quarter": "\ue11f",
  "circle-quarters": "\ue3f8",
  "circle-question": "\uf059",
  "circle-r": "\ue120",
  "circle-radiation": "\uf7ba",
  "circle-right": "\uf35a",
  "circle-s": "\ue121",
  "circle-small": "\ue122",
  "circle-sort": "\ue030",
  "circle-sort-down": "\ue031",
  "circle-sort-up": "\ue032",
  "circle-star": "\ue123",
  "circle-stop": "\uf28d",
  "circle-t": "\ue124",
  "circle-three-quarters": "\ue125",
  "circle-trash": "\ue126",
  "circle-u": "\ue127",
  "circle-up": "\uf35b",
  "circle-up-left": "\ue128",
  "circle-up-right": "\ue129",
  "circle-user": "\uf2bd",
  "circle-v": "\ue12a",
  "circle-video": "\ue12b",
  "circle-w": "\ue12c",
  "circle-waveform-lines": "\ue12d",
  "circle-x": "\ue12e",
  "circle-xmark": "\uf057",
  "circle-y": "\ue12f",
  "circle-z": "\ue130",
  citrus: "\ue2f4",
  "citrus-slice": "\ue2f5",
  city: "\uf64f",
  clapperboard: "\ue131",
  "clapperboard-play": "\ue132",
  clarinet: "\uf8ad",
  "claw-marks": "\uf6c2",
  clipboard: "\uf328",
  "clipboard-check": "\uf46c",
  "clipboard-list": "\uf46d",
  "clipboard-list-check": "\uf737",
  "clipboard-medical": "\ue133",
  "clipboard-prescription": "\uf5e8",
  "clipboard-question": "\ue4e3",
  "clipboard-user": "\uf7f3",
  clock: "\uf017",
  "clock-desk": "\ue134",
  "clock-eight": "\ue345",
  "clock-eight-thirty": "\ue346",
  "clock-eleven": "\ue347",
  "clock-eleven-thirty": "\ue348",
  "clock-five": "\ue349",
  "clock-five-thirty": "\ue34a",
  "clock-four-thirty": "\ue34b",
  "clock-nine": "\ue34c",
  "clock-nine-thirty": "\ue34d",
  "clock-one": "\ue34e",
  "clock-one-thirty": "\ue34f",
  "clock-rotate-left": "\uf1da",
  "clock-seven": "\ue350",
  "clock-seven-thirty": "\ue351",
  "clock-six": "\ue352",
  "clock-six-thirty": "\ue353",
  "clock-ten": "\ue354",
  "clock-ten-thirty": "\ue355",
  "clock-three": "\ue356",
  "clock-three-thirty": "\ue357",
  "clock-twelve": "\ue358",
  "clock-twelve-thirty": "\ue359",
  "clock-two": "\ue35a",
  "clock-two-thirty": "\ue35b",
  clone: "\uf24d",
  "closed-captioning": "\uf20a",
  "closed-captioning-slash": "\ue135",
  "clothes-hanger": "\ue136",
  cloud: "\uf0c2",
  "cloud-arrow-down": "\uf0ed",
  "cloud-arrow-up": "\uf0ee",
  "cloud-bolt": "\uf76c",
  "cloud-bolt-moon": "\uf76d",
  "cloud-bolt-sun": "\uf76e",
  "cloud-check": "\ue35c",
  "cloud-drizzle": "\uf738",
  "cloud-exclamation": "\ue491",
  "cloud-fog": "\uf74e",
  "cloud-hail": "\uf739",
  "cloud-hail-mixed": "\uf73a",
  "cloud-meatball": "\uf73b",
  "cloud-minus": "\ue35d",
  "cloud-moon": "\uf6c3",
  "cloud-moon-rain": "\uf73c",
  "cloud-music": "\uf8ae",
  "cloud-plus": "\ue35e",
  "cloud-question": "\ue492",
  "cloud-rain": "\uf73d",
  "cloud-rainbow": "\uf73e",
  "cloud-showers": "\uf73f",
  "cloud-showers-heavy": "\uf740",
  "cloud-showers-water": "\ue4e4",
  "cloud-slash": "\ue137",
  "cloud-sleet": "\uf741",
  "cloud-snow": "\uf742",
  "cloud-sun": "\uf6c4",
  "cloud-sun-rain": "\uf743",
  "cloud-word": "\ue138",
  "cloud-xmark": "\ue35f",
  cloudflare: "\ue07d",
  clouds: "\uf744",
  "clouds-moon": "\uf745",
  "clouds-sun": "\uf746",
  cloudscale: "\uf383",
  cloudsmith: "\uf384",
  cloudversify: "\uf385",
  clover: "\ue139",
  club: "\uf327",
  cmplid: "\ue360",
  coconut: "\ue2f6",
  code: "\uf121",
  "code-branch": "\uf126",
  "code-commit": "\uf386",
  "code-compare": "\ue13a",
  "code-fork": "\ue13b",
  "code-merge": "\uf387",
  "code-pull-request": "\ue13c",
  "code-pull-request-closed": "\ue3f9",
  "code-pull-request-draft": "\ue3fa",
  "code-simple": "\ue13d",
  codepen: "\uf1cb",
  codiepie: "\uf284",
  "coffee-bean": "\ue13e",
  "coffee-beans": "\ue13f",
  "coffee-pot": "\ue002",
  coffin: "\uf6c6",
  "coffin-cross": "\ue051",
  coin: "\uf85c",
  "coin-blank": "\ue3fb",
  "coin-front": "\ue3fc",
  "coin-vertical": "\ue3fd",
  coins: "\uf51e",
  colon: "\u003a",
  "colon-sign": "\ue140",
  "columns-3": "\ue361",
  comet: "\ue003",
  comma: "\u002c",
  command: "\ue142",
  comment: "\uf075",
  "comment-arrow-down": "\ue143",
  "comment-arrow-up": "\ue144",
  "comment-arrow-up-right": "\ue145",
  "comment-captions": "\ue146",
  "comment-check": "\uf4ac",
  "comment-code": "\ue147",
  "comment-dollar": "\uf651",
  "comment-dots": "\uf4ad",
  "comment-exclamation": "\uf4af",
  "comment-image": "\ue148",
  "comment-lines": "\uf4b0",
  "comment-medical": "\uf7f5",
  "comment-middle": "\ue149",
  "comment-middle-top": "\ue14a",
  "comment-minus": "\uf4b1",
  "comment-music": "\uf8b0",
  "comment-pen": "\uf4ae",
  "comment-plus": "\uf4b2",
  "comment-question": "\ue14b",
  "comment-quote": "\ue14c",
  "comment-slash": "\uf4b3",
  "comment-smile": "\uf4b4",
  "comment-sms": "\uf7cd",
  "comment-text": "\ue14d",
  "comment-xmark": "\uf4b5",
  comments: "\uf086",
  "comments-dollar": "\uf653",
  "comments-question": "\ue14e",
  "comments-question-check": "\ue14f",
  "compact-disc": "\uf51f",
  compass: "\uf14e",
  "compass-drafting": "\uf568",
  "compass-slash": "\uf5e9",
  compress: "\uf066",
  "compress-wide": "\uf326",
  computer: "\ue4e5",
  "computer-classic": "\uf8b1",
  "computer-mouse": "\uf8cc",
  "computer-mouse-scrollwheel": "\uf8cd",
  "computer-speaker": "\uf8b2",
  confluence: "\uf78d",
  connectdevelop: "\uf20e",
  "container-storage": "\uf4b7",
  contao: "\uf26d",
  "conveyor-belt": "\uf46e",
  "conveyor-belt-boxes": "\uf46f",
  "conveyor-belt-empty": "\ue150",
  cookie: "\uf563",
  "cookie-bite": "\uf564",
  copy: "\uf0c5",
  copyright: "\uf1f9",
  corn: "\uf6c7",
  corner: "\ue3fe",
  "cotton-bureau": "\uf89e",
  couch: "\uf4b8",
  cow: "\uf6c8",
  cowbell: "\uf8b3",
  "cowbell-circle-plus": "\uf8b4",
  cpanel: "\uf388",
  crab: "\ue3ff",
  "crate-apple": "\uf6b1",
  "crate-empty": "\ue151",
  "creative-commons": "\uf25e",
  "creative-commons-by": "\uf4e7",
  "creative-commons-nc": "\uf4e8",
  "creative-commons-nc-eu": "\uf4e9",
  "creative-commons-nc-jp": "\uf4ea",
  "creative-commons-nd": "\uf4eb",
  "creative-commons-pd": "\uf4ec",
  "creative-commons-pd-alt": "\uf4ed",
  "creative-commons-remix": "\uf4ee",
  "creative-commons-sa": "\uf4ef",
  "creative-commons-sampling": "\uf4f0",
  "creative-commons-sampling-plus": "\uf4f1",
  "creative-commons-share": "\uf4f2",
  "creative-commons-zero": "\uf4f3",
  "credit-card": "\uf09d",
  "credit-card-blank": "\uf389",
  "credit-card-front": "\uf38a",
  "cricket-bat-ball": "\uf449",
  "critical-role": "\uf6c9",
  croissant: "\uf7f6",
  crop: "\uf125",
  "crop-simple": "\uf565",
  cross: "\uf654",
  crosshairs: "\uf05b",
  crow: "\uf520",
  crown: "\uf521",
  crutch: "\uf7f7",
  crutches: "\uf7f8",
  "cruzeiro-sign": "\ue152",
  "crystal-ball": "\ue362",
  css3: "\uf13c",
  "css3-alt": "\uf38b",
  cube: "\uf1b2",
  cubes: "\uf1b3",
  "cubes-stacked": "\ue4e6",
  cucumber: "\ue401",
  "cup-straw": "\ue363",
  "cup-straw-swoosh": "\ue364",
  "cup-togo": "\uf6c5",
  cupcake: "\ue402",
  "curling-stone": "\uf44a",
  custard: "\ue403",
  cuttlefish: "\uf38c",
  d: "\u0044",
  "d-and-d": "\uf38d",
  "d-and-d-beyond": "\uf6ca",
  dagger: "\uf6cb",
  dailymotion: "\ue052",
  dash: "\ue404",
  dashcube: "\uf210",
  database: "\uf1c0",
  deer: "\uf78e",
  "deer-rudolph": "\uf78f",
  deezer: "\ue077",
  "delete-left": "\uf55a",
  "delete-right": "\ue154",
  delicious: "\uf1a5",
  democrat: "\uf747",
  deploydog: "\uf38e",
  deskpro: "\uf38f",
  desktop: "\uf390",
  "desktop-arrow-down": "\ue155",
  dev: "\uf6cc",
  deviantart: "\uf1bd",
  dharmachakra: "\uf655",
  dhl: "\uf790",
  "diagram-cells": "\ue475",
  "diagram-lean-canvas": "\ue156",
  "diagram-nested": "\ue157",
  "diagram-next": "\ue476",
  "diagram-predecessor": "\ue477",
  "diagram-previous": "\ue478",
  "diagram-project": "\uf542",
  "diagram-sankey": "\ue158",
  "diagram-subtask": "\ue479",
  "diagram-successor": "\ue47a",
  "diagram-venn": "\ue15a",
  dial: "\ue15b",
  "dial-high": "\ue15c",
  "dial-low": "\ue15d",
  "dial-max": "\ue15e",
  "dial-med": "\ue15f",
  "dial-med-low": "\ue160",
  "dial-min": "\ue161",
  "dial-off": "\ue162",
  diamond: "\uf219",
  "diamond-exclamation": "\ue405",
  "diamond-turn-right": "\uf5eb",
  diaspora: "\uf791",
  dice: "\uf522",
  "dice-d10": "\uf6cd",
  "dice-d12": "\uf6ce",
  "dice-d20": "\uf6cf",
  "dice-d4": "\uf6d0",
  "dice-d6": "\uf6d1",
  "dice-d8": "\uf6d2",
  "dice-five": "\uf523",
  "dice-four": "\uf524",
  "dice-one": "\uf525",
  "dice-six": "\uf526",
  "dice-three": "\uf527",
  "dice-two": "\uf528",
  digg: "\uf1a6",
  "digital-ocean": "\uf391",
  diploma: "\uf5ea",
  "disc-drive": "\uf8b5",
  discord: "\uf392",
  discourse: "\uf393",
  disease: "\uf7fa",
  display: "\ue163",
  "display-arrow-down": "\ue164",
  "display-code": "\ue165",
  "display-medical": "\ue166",
  "display-slash": "\ue2fa",
  "distribute-spacing-horizontal": "\ue365",
  "distribute-spacing-vertical": "\ue366",
  ditto: "\u0022",
  divide: "\uf529",
  dna: "\uf471",
  "do-not-enter": "\uf5ec",
  dochub: "\uf394",
  docker: "\uf395",
  dog: "\uf6d3",
  "dog-leashed": "\uf6d4",
  "dollar-sign": "\u0024",
  dolly: "\uf472",
  "dolly-empty": "\uf473",
  dolphin: "\ue168",
  "dong-sign": "\ue169",
  donut: "\ue406",
  "door-closed": "\uf52a",
  "door-open": "\uf52b",
  dove: "\uf4ba",
  down: "\uf354",
  "down-from-dotted-line": "\ue407",
  "down-from-line": "\uf349",
  "down-left": "\ue16a",
  "down-left-and-up-right-to-center": "\uf422",
  "down-long": "\uf309",
  "down-right": "\ue16b",
  "down-to-bracket": "\ue4e7",
  "down-to-dotted-line": "\ue408",
  "down-to-line": "\uf34a",
  download: "\uf019",
  draft2digital: "\uf396",
  dragon: "\uf6d5",
  "draw-circle": "\uf5ed",
  "draw-polygon": "\uf5ee",
  "draw-square": "\uf5ef",
  dreidel: "\uf792",
  dribbble: "\uf17d",
  "dribbble-square": "\uf397",
  drone: "\uf85f",
  "drone-front": "\uf860",
  dropbox: "\uf16b",
  droplet: "\uf043",
  "droplet-degree": "\uf748",
  "droplet-percent": "\uf750",
  "droplet-slash": "\uf5c7",
  drum: "\uf569",
  "drum-steelpan": "\uf56a",
  drumstick: "\uf6d6",
  "drumstick-bite": "\uf6d7",
  drupal: "\uf1a9",
  dryer: "\uf861",
  "dryer-heat": "\uf862",
  duck: "\uf6d8",
  dumbbell: "\uf44b",
  dumpster: "\uf793",
  "dumpster-fire": "\uf794",
  dungeon: "\uf6d9",
  dyalog: "\uf399",
  e: "\u0045",
  ear: "\uf5f0",
  "ear-deaf": "\uf2a4",
  "ear-listen": "\uf2a2",
  "ear-muffs": "\uf795",
  earlybirds: "\uf39a",
  "earth-africa": "\uf57c",
  "earth-americas": "\uf57d",
  "earth-asia": "\uf57e",
  "earth-europe": "\uf7a2",
  "earth-oceania": "\ue47b",
  ebay: "\uf4f4",
  eclipse: "\uf749",
  edge: "\uf282",
  "edge-legacy": "\ue078",
  egg: "\uf7fb",
  "egg-fried": "\uf7fc",
  eggplant: "\ue16c",
  eject: "\uf052",
  elementor: "\uf430",
  elephant: "\uf6da",
  elevator: "\ue16d",
  ellipsis: "\uf141",
  "ellipsis-stroke": "\uf39b",
  "ellipsis-stroke-vertical": "\uf39c",
  "ellipsis-vertical": "\uf142",
  ello: "\uf5f1",
  ember: "\uf423",
  empire: "\uf1d1",
  "empty-set": "\uf656",
  engine: "\ue16e",
  "engine-warning": "\uf5f2",
  envelope: "\uf0e0",
  "envelope-circle-check": "\ue4e8",
  "envelope-dot": "\ue16f",
  "envelope-open": "\uf2b6",
  "envelope-open-dollar": "\uf657",
  "envelope-open-text": "\uf658",
  envelopes: "\ue170",
  "envelopes-bulk": "\uf674",
  envira: "\uf299",
  equals: "\u003d",
  eraser: "\uf12d",
  erlang: "\uf39d",
  escalator: "\ue171",
  ethereum: "\uf42e",
  ethernet: "\uf796",
  etsy: "\uf2d7",
  "euro-sign": "\uf153",
  evernote: "\uf839",
  exclamation: "\u0021",
  expand: "\uf065",
  "expand-wide": "\uf320",
  expeditedssl: "\uf23e",
  explosion: "\ue4e9",
  eye: "\uf06e",
  "eye-dropper": "\uf1fb",
  "eye-dropper-full": "\ue172",
  "eye-dropper-half": "\ue173",
  "eye-evil": "\uf6db",
  "eye-low-vision": "\uf2a8",
  "eye-slash": "\uf070",
  eyes: "\ue367",
  f: "\u0046",
  "face-angry": "\uf556",
  "face-angry-horns": "\ue368",
  "face-anguished": "\ue369",
  "face-anxious-sweat": "\ue36a",
  "face-astonished": "\ue36b",
  "face-awesome": "\ue409",
  "face-beam-hand-over-mouth": "\ue47c",
  "face-clouds": "\ue47d",
  "face-confounded": "\ue36c",
  "face-confused": "\ue36d",
  "face-cowboy-hat": "\ue36e",
  "face-diagonal-mouth": "\ue47e",
  "face-disappointed": "\ue36f",
  "face-disguise": "\ue370",
  "face-dizzy": "\uf567",
  "face-dotted": "\ue47f",
  "face-downcast-sweat": "\ue371",
  "face-drooling": "\ue372",
  "face-exhaling": "\ue480",
  "face-explode": "\ue2fe",
  "face-expressionless": "\ue373",
  "face-eyes-xmarks": "\ue374",
  "face-fearful": "\ue375",
  "face-flushed": "\uf579",
  "face-frown": "\uf119",
  "face-frown-open": "\uf57a",
  "face-frown-slight": "\ue376",
  "face-glasses": "\ue377",
  "face-grimace": "\uf57f",
  "face-grin": "\uf580",
  "face-grin-beam": "\uf582",
  "face-grin-beam-sweat": "\uf583",
  "face-grin-hearts": "\uf584",
  "face-grin-squint": "\uf585",
  "face-grin-squint-tears": "\uf586",
  "face-grin-stars": "\uf587",
  "face-grin-tears": "\uf588",
  "face-grin-tongue": "\uf589",
  "face-grin-tongue-squint": "\uf58a",
  "face-grin-tongue-wink": "\uf58b",
  "face-grin-wide": "\uf581",
  "face-grin-wink": "\uf58c",
  "face-hand-over-mouth": "\ue378",
  "face-hand-peeking": "\ue481",
  "face-hand-yawn": "\ue379",
  "face-head-bandage": "\ue37a",
  "face-holding-back-tears": "\ue482",
  "face-hushed": "\ue37b",
  "face-icicles": "\ue37c",
  "face-kiss": "\uf596",
  "face-kiss-beam": "\uf597",
  "face-kiss-closed-eyes": "\ue37d",
  "face-kiss-wink-heart": "\uf598",
  "face-laugh": "\uf599",
  "face-laugh-beam": "\uf59a",
  "face-laugh-squint": "\uf59b",
  "face-laugh-wink": "\uf59c",
  "face-lying": "\ue37e",
  "face-mask": "\ue37f",
  "face-meh": "\uf11a",
  "face-meh-blank": "\uf5a4",
  "face-melting": "\ue483",
  "face-monocle": "\ue380",
  "face-nauseated": "\ue381",
  "face-nose-steam": "\ue382",
  "face-party": "\ue383",
  "face-pensive": "\ue384",
  "face-persevering": "\ue385",
  "face-pleading": "\ue386",
  "face-pouting": "\ue387",
  "face-raised-eyebrow": "\ue388",
  "face-relieved": "\ue389",
  "face-rolling-eyes": "\uf5a5",
  "face-sad-cry": "\uf5b3",
  "face-sad-sweat": "\ue38a",
  "face-sad-tear": "\uf5b4",
  "face-saluting": "\ue484",
  "face-scream": "\ue38b",
  "face-shush": "\ue38c",
  "face-sleeping": "\ue38d",
  "face-sleepy": "\ue38e",
  "face-smile": "\uf118",
  "face-smile-beam": "\uf5b8",
  "face-smile-halo": "\ue38f",
  "face-smile-hearts": "\ue390",
  "face-smile-horns": "\ue391",
  "face-smile-plus": "\uf5b9",
  "face-smile-relaxed": "\ue392",
  "face-smile-tear": "\ue393",
  "face-smile-tongue": "\ue394",
  "face-smile-upside-down": "\ue395",
  "face-smile-wink": "\uf4da",
  "face-smiling-hands": "\ue396",
  "face-smirking": "\ue397",
  "face-spiral-eyes": "\ue485",
  "face-sunglasses": "\ue398",
  "face-surprise": "\uf5c2",
  "face-swear": "\ue399",
  "face-thermometer": "\ue39a",
  "face-thinking": "\ue39b",
  "face-tired": "\uf5c8",
  "face-tissue": "\ue39c",
  "face-tongue-money": "\ue39d",
  "face-tongue-sweat": "\ue39e",
  "face-unamused": "\ue39f",
  "face-viewfinder": "\ue2ff",
  "face-vomit": "\ue3a0",
  "face-weary": "\ue3a1",
  "face-woozy": "\ue3a2",
  "face-worried": "\ue3a3",
  "face-zany": "\ue3a4",
  "face-zipper": "\ue3a5",
  facebook: "\uf09a",
  "facebook-f": "\uf39e",
  "facebook-messenger": "\uf39f",
  "facebook-square": "\uf082",
  falafel: "\ue40a",
  family: "\ue300",
  "family-dress": "\ue301",
  "family-pants": "\ue302",
  fan: "\uf863",
  "fan-table": "\ue004",
  "fantasy-flight-games": "\uf6dc",
  farm: "\uf864",
  faucet: "\ue005",
  "faucet-drip": "\ue006",
  fax: "\uf1ac",
  feather: "\uf52d",
  "feather-pointed": "\uf56b",
  fedex: "\uf797",
  fedora: "\uf798",
  fence: "\ue303",
  "ferris-wheel": "\ue174",
  ferry: "\ue4ea",
  "field-hockey-stick-ball": "\uf44c",
  figma: "\uf799",
  file: "\uf15b",
  "file-arrow-down": "\uf56d",
  "file-arrow-up": "\uf574",
  "file-audio": "\uf1c7",
  "file-binary": "\ue175",
  "file-certificate": "\uf5f3",
  "file-chart-column": "\uf659",
  "file-chart-pie": "\uf65a",
  "file-check": "\uf316",
  "file-circle-check": "\ue493",
  "file-circle-exclamation": "\ue4eb",
  "file-circle-info": "\ue4ec",
  "file-circle-minus": "\ue4ed",
  "file-circle-plus": "\ue4ee",
  "file-circle-question": "\ue4ef",
  "file-circle-xmark": "\ue494",
  "file-code": "\uf1c9",
  "file-contract": "\uf56c",
  "file-csv": "\uf6dd",
  "file-dashed-line": "\uf877",
  "file-excel": "\uf1c3",
  "file-exclamation": "\uf31a",
  "file-export": "\uf56e",
  "file-heart": "\ue176",
  "file-image": "\uf1c5",
  "file-import": "\uf56f",
  "file-invoice": "\uf570",
  "file-invoice-dollar": "\uf571",
  "file-lines": "\uf15c",
  "file-lock": "\ue3a6",
  "file-magnifying-glass": "\uf865",
  "file-medical": "\uf477",
  "file-minus": "\uf318",
  "file-music": "\uf8b6",
  "file-pdf": "\uf1c1",
  "file-pen": "\uf31c",
  "file-plus": "\uf319",
  "file-plus-minus": "\ue177",
  "file-powerpoint": "\uf1c4",
  "file-prescription": "\uf572",
  "file-shield": "\ue4f0",
  "file-signature": "\uf573",
  "file-slash": "\ue3a7",
  "file-spreadsheet": "\uf65b",
  "file-user": "\uf65c",
  "file-video": "\uf1c8",
  "file-waveform": "\uf478",
  "file-word": "\uf1c2",
  "file-xmark": "\uf317",
  "file-zipper": "\uf1c6",
  files: "\ue178",
  "files-medical": "\uf7fd",
  fill: "\uf575",
  "fill-drip": "\uf576",
  film: "\uf008",
  "film-canister": "\uf8b7",
  "film-simple": "\uf3a0",
  "film-slash": "\ue179",
  films: "\ue17a",
  filter: "\uf0b0",
  "filter-circle-dollar": "\uf662",
  "filter-circle-xmark": "\ue17b",
  "filter-list": "\ue17c",
  "filter-slash": "\ue17d",
  filters: "\ue17e",
  fingerprint: "\uf577",
  fire: "\uf06d",
  "fire-burner": "\ue4f1",
  "fire-extinguisher": "\uf134",
  "fire-flame": "\uf6df",
  "fire-flame-curved": "\uf7e4",
  "fire-flame-simple": "\uf46a",
  "fire-hydrant": "\ue17f",
  "fire-smoke": "\uf74b",
  firefox: "\uf269",
  "firefox-browser": "\ue007",
  fireplace: "\uf79a",
  "first-order": "\uf2b0",
  "first-order-alt": "\uf50a",
  firstdraft: "\uf3a1",
  fish: "\uf578",
  "fish-bones": "\ue304",
  "fish-cooked": "\uf7fe",
  "fish-fins": "\ue4f2",
  "fishing-rod": "\ue3a8",
  flag: "\uf024",
  "flag-checkered": "\uf11e",
  "flag-pennant": "\uf456",
  "flag-swallowtail": "\uf74c",
  "flag-usa": "\uf74d",
  flashlight: "\uf8b8",
  flask: "\uf0c3",
  "flask-round-poison": "\uf6e0",
  "flask-round-potion": "\uf6e1",
  "flask-vial": "\ue4f3",
  flatbread: "\ue40b",
  "flatbread-stuffed": "\ue40c",
  flickr: "\uf16e",
  flipboard: "\uf44d",
  "floppy-disk": "\uf0c7",
  "floppy-disk-circle-arrow-right": "\ue180",
  "floppy-disk-circle-xmark": "\ue181",
  "floppy-disk-pen": "\ue182",
  "floppy-disks": "\ue183",
  "florin-sign": "\ue184",
  flower: "\uf7ff",
  "flower-daffodil": "\uf800",
  "flower-tulip": "\uf801",
  flute: "\uf8b9",
  "flux-capacitor": "\uf8ba",
  fly: "\uf417",
  "flying-disc": "\ue3a9",
  folder: "\uf07b",
  "folder-arrow-down": "\ue053",
  "folder-arrow-up": "\ue054",
  "folder-bookmark": "\ue186",
  "folder-closed": "\ue185",
  "folder-gear": "\ue187",
  "folder-grid": "\ue188",
  "folder-heart": "\ue189",
  "folder-image": "\ue18a",
  "folder-magnifying-glass": "\ue18b",
  "folder-medical": "\ue18c",
  "folder-minus": "\uf65d",
  "folder-music": "\ue18d",
  "folder-open": "\uf07c",
  "folder-plus": "\uf65e",
  "folder-tree": "\uf802",
  "folder-user": "\ue18e",
  "folder-xmark": "\uf65f",
  folders: "\uf660",
  "fondue-pot": "\ue40d",
  font: "\uf031",
  "font-awesome": "\uf2b4",
  "font-case": "\uf866",
  fonticons: "\uf280",
  "fonticons-fi": "\uf3a2",
  football: "\uf44e",
  "football-helmet": "\uf44f",
  fork: "\uf2e3",
  "fork-knife": "\uf2e6",
  forklift: "\uf47a",
  fort: "\ue486",
  "fort-awesome": "\uf286",
  "fort-awesome-alt": "\uf3a3",
  forumbee: "\uf211",
  forward: "\uf04e",
  "forward-fast": "\uf050",
  "forward-step": "\uf051",
  foursquare: "\uf180",
  frame: "\ue495",
  "franc-sign": "\ue18f",
  "free-code-camp": "\uf2c5",
  freebsd: "\uf3a4",
  "french-fries": "\uf803",
  frog: "\uf52e",
  fulcrum: "\uf50b",
  function: "\uf661",
  futbol: "\uf1e3",
  g: "\u0047",
  "galactic-republic": "\uf50c",
  "galactic-senate": "\uf50d",
  galaxy: "\ue008",
  "gallery-thumbnails": "\ue3aa",
  "game-board": "\uf867",
  "game-board-simple": "\uf868",
  "game-console-handheld": "\uf8bb",
  gamepad: "\uf11b",
  "gamepad-modern": "\uf8bc",
  garage: "\ue009",
  "garage-car": "\ue00a",
  "garage-open": "\ue00b",
  garlic: "\ue40e",
  "gas-pump": "\uf52f",
  "gas-pump-slash": "\uf5f4",
  gauge: "\uf624",
  "gauge-circle-bolt": "\ue496",
  "gauge-circle-minus": "\ue497",
  "gauge-circle-plus": "\ue498",
  "gauge-high": "\uf625",
  "gauge-low": "\uf627",
  "gauge-max": "\uf626",
  "gauge-min": "\uf628",
  "gauge-simple": "\uf629",
  "gauge-simple-high": "\uf62a",
  "gauge-simple-low": "\uf62c",
  "gauge-simple-max": "\uf62b",
  "gauge-simple-min": "\uf62d",
  gavel: "\uf0e3",
  gear: "\uf013",
  gears: "\uf085",
  gem: "\uf3a5",
  genderless: "\uf22d",
  "get-pocket": "\uf265",
  gg: "\uf260",
  "gg-circle": "\uf261",
  ghost: "\uf6e2",
  gif: "\ue190",
  gift: "\uf06b",
  "gift-card": "\uf663",
  gifts: "\uf79c",
  "gingerbread-man": "\uf79d",
  git: "\uf1d3",
  "git-alt": "\uf841",
  "git-square": "\uf1d2",
  github: "\uf09b",
  "github-alt": "\uf113",
  "github-square": "\uf092",
  gitkraken: "\uf3a6",
  gitlab: "\uf296",
  gitter: "\uf426",
  glass: "\uf804",
  "glass-citrus": "\uf869",
  "glass-empty": "\ue191",
  "glass-half": "\ue192",
  "glass-water": "\ue4f4",
  "glass-water-droplet": "\ue4f5",
  glasses: "\uf530",
  "glasses-round": "\uf5f5",
  glide: "\uf2a5",
  "glide-g": "\uf2a6",
  globe: "\uf0ac",
  "globe-snow": "\uf7a3",
  "globe-stand": "\uf5f6",
  "goal-net": "\ue3ab",
  gofore: "\uf3a7",
  golang: "\ue40f",
  "golf-ball-tee": "\uf450",
  "golf-club": "\uf451",
  "golf-flag-hole": "\ue3ac",
  goodreads: "\uf3a8",
  "goodreads-g": "\uf3a9",
  google: "\uf1a0",
  "google-drive": "\uf3aa",
  "google-pay": "\ue079",
  "google-play": "\uf3ab",
  "google-plus": "\uf2b3",
  "google-plus-g": "\uf0d5",
  "google-plus-square": "\uf0d4",
  "google-wallet": "\uf1ee",
  gopuram: "\uf664",
  "graduation-cap": "\uf19d",
  gramophone: "\uf8bd",
  grapes: "\ue306",
  grate: "\ue193",
  "grate-droplet": "\ue194",
  gratipay: "\uf184",
  grav: "\uf2d6",
  "greater-than": "\u003e",
  "greater-than-equal": "\uf532",
  grid: "\ue195",
  "grid-2": "\ue196",
  "grid-2-plus": "\ue197",
  "grid-4": "\ue198",
  "grid-5": "\ue199",
  "grid-dividers": "\ue3ad",
  "grid-horizontal": "\ue307",
  grip: "\uf58d",
  "grip-dots": "\ue410",
  "grip-dots-vertical": "\ue411",
  "grip-lines": "\uf7a4",
  "grip-lines-vertical": "\uf7a5",
  "grip-vertical": "\uf58e",
  gripfire: "\uf3ac",
  "group-arrows-rotate": "\ue4f6",
  grunt: "\uf3ad",
  "guarani-sign": "\ue19a",
  guilded: "\ue07e",
  guitar: "\uf7a6",
  "guitar-electric": "\uf8be",
  guitars: "\uf8bf",
  gulp: "\uf3ae",
  gun: "\ue19b",
  "gun-slash": "\ue19c",
  "gun-squirt": "\ue19d",
  h: "\u0048",
  h1: "\uf313",
  h2: "\uf314",
  h3: "\uf315",
  h4: "\uf86a",
  h5: "\ue412",
  h6: "\ue413",
  "hacker-news": "\uf1d4",
  "hacker-news-square": "\uf3af",
  hackerrank: "\uf5f7",
  hammer: "\uf6e3",
  "hammer-crash": "\ue414",
  "hammer-war": "\uf6e4",
  hamsa: "\uf665",
  hand: "\uf256",
  "hand-back-fist": "\uf255",
  "hand-back-point-down": "\ue19e",
  "hand-back-point-left": "\ue19f",
  "hand-back-point-ribbon": "\ue1a0",
  "hand-back-point-right": "\ue1a1",
  "hand-back-point-up": "\ue1a2",
  "hand-dots": "\uf461",
  "hand-fingers-crossed": "\ue1a3",
  "hand-fist": "\uf6de",
  "hand-heart": "\uf4bc",
  "hand-holding": "\uf4bd",
  "hand-holding-box": "\uf47b",
  "hand-holding-dollar": "\uf4c0",
  "hand-holding-droplet": "\uf4c1",
  "hand-holding-hand": "\ue4f7",
  "hand-holding-heart": "\uf4be",
  "hand-holding-magic": "\uf6e5",
  "hand-holding-medical": "\ue05c",
  "hand-holding-seedling": "\uf4bf",
  "hand-holding-skull": "\ue1a4",
  "hand-horns": "\ue1a9",
  "hand-lizard": "\uf258",
  "hand-love": "\ue1a5",
  "hand-middle-finger": "\uf806",
  "hand-peace": "\uf25b",
  "hand-point-down": "\uf0a7",
  "hand-point-left": "\uf0a5",
  "hand-point-ribbon": "\ue1a6",
  "hand-point-right": "\uf0a4",
  "hand-point-up": "\uf0a6",
  "hand-pointer": "\uf25a",
  "hand-scissors": "\uf257",
  "hand-sparkles": "\ue05d",
  "hand-spock": "\uf259",
  "hand-wave": "\ue1a7",
  handcuffs: "\ue4f8",
  hands: "\uf2a7",
  "hands-asl-interpreting": "\uf2a3",
  "hands-bound": "\ue4f9",
  "hands-bubbles": "\ue05e",
  "hands-clapping": "\ue1a8",
  "hands-holding": "\uf4c2",
  "hands-holding-child": "\ue4fa",
  "hands-holding-circle": "\ue4fb",
  "hands-holding-diamond": "\uf47c",
  "hands-holding-dollar": "\uf4c5",
  "hands-holding-heart": "\uf4c3",
  "hands-praying": "\uf684",
  handshake: "\uf2b5",
  "handshake-angle": "\uf4c4",
  "handshake-simple": "\uf4c6",
  "handshake-simple-slash": "\ue05f",
  "handshake-slash": "\ue060",
  hanukiah: "\uf6e6",
  "hard-drive": "\uf0a0",
  hashnode: "\ue499",
  hashtag: "\u0023",
  "hashtag-lock": "\ue415",
  "hat-chef": "\uf86b",
  "hat-cowboy": "\uf8c0",
  "hat-cowboy-side": "\uf8c1",
  "hat-santa": "\uf7a7",
  "hat-winter": "\uf7a8",
  "hat-witch": "\uf6e7",
  "hat-wizard": "\uf6e8",
  "head-side": "\uf6e9",
  "head-side-brain": "\uf808",
  "head-side-cough": "\ue061",
  "head-side-cough-slash": "\ue062",
  "head-side-goggles": "\uf6ea",
  "head-side-headphones": "\uf8c2",
  "head-side-heart": "\ue1aa",
  "head-side-mask": "\ue063",
  "head-side-medical": "\uf809",
  "head-side-virus": "\ue064",
  heading: "\uf1dc",
  headphones: "\uf025",
  "headphones-simple": "\uf58f",
  headset: "\uf590",
  heart: "\uf004",
  "heart-circle-bolt": "\ue4fc",
  "heart-circle-check": "\ue4fd",
  "heart-circle-exclamation": "\ue4fe",
  "heart-circle-minus": "\ue4ff",
  "heart-circle-plus": "\ue500",
  "heart-circle-xmark": "\ue501",
  "heart-crack": "\uf7a9",
  "heart-half": "\ue1ab",
  "heart-half-stroke": "\ue1ac",
  "heart-pulse": "\uf21e",
  heat: "\ue00c",
  helicopter: "\uf533",
  "helicopter-symbol": "\ue502",
  "helmet-battle": "\uf6eb",
  "helmet-safety": "\uf807",
  "helmet-un": "\ue503",
  hexagon: "\uf312",
  "hexagon-check": "\ue416",
  "hexagon-divide": "\ue1ad",
  "hexagon-exclamation": "\ue417",
  "hexagon-image": "\ue504",
  "hexagon-minus": "\uf307",
  "hexagon-plus": "\uf300",
  "hexagon-vertical-nft": "\ue505",
  "hexagon-vertical-nft-slanted": "\ue506",
  "hexagon-xmark": "\uf2ee",
  "high-definition": "\ue1ae",
  highlighter: "\uf591",
  "highlighter-line": "\ue1af",
  "hill-avalanche": "\ue507",
  "hill-rockslide": "\ue508",
  hippo: "\uf6ed",
  hips: "\uf452",
  "hire-a-helper": "\uf3b0",
  hive: "\ue07f",
  "hockey-mask": "\uf6ee",
  "hockey-puck": "\uf453",
  "hockey-stick-puck": "\ue3ae",
  "hockey-sticks": "\uf454",
  "holly-berry": "\uf7aa",
  "honey-pot": "\ue418",
  "hood-cloak": "\uf6ef",
  hooli: "\uf427",
  "horizontal-rule": "\uf86c",
  hornbill: "\uf592",
  horse: "\uf6f0",
  "horse-head": "\uf7ab",
  "horse-saddle": "\uf8c3",
  hose: "\ue419",
  "hose-reel": "\ue41a",
  hospital: "\uf0f8",
  "hospital-user": "\uf80d",
  hospitals: "\uf80e",
  "hot-tub-person": "\uf593",
  hotdog: "\uf80f",
  hotel: "\uf594",
  hotjar: "\uf3b1",
  hourglass: "\uf254",
  "hourglass-clock": "\ue41b",
  "hourglass-empty": "\uf252",
  "hourglass-end": "\uf253",
  "hourglass-start": "\uf251",
  house: "\uf015",
  "house-blank": "\ue487",
  "house-building": "\ue1b1",
  "house-chimney": "\ue3af",
  "house-chimney-blank": "\ue3b0",
  "house-chimney-crack": "\uf6f1",
  "house-chimney-heart": "\ue1b2",
  "house-chimney-medical": "\uf7f2",
  "house-chimney-user": "\ue065",
  "house-chimney-window": "\ue00d",
  "house-circle-check": "\ue509",
  "house-circle-exclamation": "\ue50a",
  "house-circle-xmark": "\ue50b",
  "house-crack": "\ue3b1",
  "house-day": "\ue00e",
  "house-fire": "\ue50c",
  "house-flag": "\ue50d",
  "house-flood-water": "\ue50e",
  "house-flood-water-circle-arrow-right": "\ue50f",
  "house-heart": "\uf4c9",
  "house-laptop": "\ue066",
  "house-lock": "\ue510",
  "house-medical": "\ue3b2",
  "house-medical-circle-check": "\ue511",
  "house-medical-circle-exclamation": "\ue512",
  "house-medical-circle-xmark": "\ue513",
  "house-medical-flag": "\ue514",
  "house-night": "\ue010",
  "house-person-leave": "\ue00f",
  "house-person-return": "\ue011",
  "house-signal": "\ue012",
  "house-tree": "\ue1b3",
  "house-tsunami": "\ue515",
  "house-turret": "\ue1b4",
  "house-user": "\ue1b0",
  "house-water": "\uf74f",
  "house-window": "\ue3b3",
  houzz: "\uf27c",
  "hryvnia-sign": "\uf6f2",
  html5: "\uf13b",
  hubspot: "\uf3b2",
  "hundred-points": "\ue41c",
  hurricane: "\uf751",
  hyphen: "\u002d",
  i: "\u0049",
  "i-cursor": "\uf246",
  "ice-cream": "\uf810",
  "ice-skate": "\uf7ac",
  icicles: "\uf7ad",
  icons: "\uf86d",
  "id-badge": "\uf2c1",
  "id-card": "\uf2c2",
  "id-card-clip": "\uf47f",
  ideal: "\ue013",
  igloo: "\uf7ae",
  image: "\uf03e",
  "image-landscape": "\ue1b5",
  "image-polaroid": "\uf8c4",
  "image-polaroid-user": "\ue1b6",
  "image-portrait": "\uf3e0",
  "image-slash": "\ue1b7",
  "image-user": "\ue1b8",
  images: "\uf302",
  "images-user": "\ue1b9",
  imdb: "\uf2d8",
  inbox: "\uf01c",
  "inbox-full": "\ue1ba",
  "inbox-in": "\uf310",
  "inbox-out": "\uf311",
  inboxes: "\ue1bb",
  indent: "\uf03c",
  "indian-rupee-sign": "\ue1bc",
  industry: "\uf275",
  "industry-windows": "\uf3b3",
  infinity: "\uf534",
  info: "\uf129",
  inhaler: "\uf5f9",
  "input-numeric": "\ue1bd",
  "input-pipe": "\ue1be",
  "input-text": "\ue1bf",
  instagram: "\uf16d",
  "instagram-square": "\ue055",
  instalod: "\ue081",
  integral: "\uf667",
  intercom: "\uf7af",
  "internet-explorer": "\uf26b",
  intersection: "\uf668",
  invision: "\uf7b0",
  ioxhost: "\uf208",
  "island-tropical": "\uf811",
  italic: "\uf033",
  "itch-io": "\uf83a",
  itunes: "\uf3b4",
  "itunes-note": "\uf3b5",
  j: "\u004a",
  "jack-o-lantern": "\uf30e",
  jar: "\ue516",
  "jar-wheat": "\ue517",
  java: "\uf4e4",
  jedi: "\uf669",
  "jedi-order": "\uf50e",
  jenkins: "\uf3b6",
  "jet-fighter": "\uf0fb",
  "jet-fighter-up": "\ue518",
  jira: "\uf7b1",
  joget: "\uf3b7",
  joint: "\uf595",
  joomla: "\uf1aa",
  joystick: "\uf8c5",
  js: "\uf3b8",
  "js-square": "\uf3b9",
  jsfiddle: "\uf1cc",
  jug: "\uf8c6",
  "jug-detergent": "\ue519",
  k: "\u004b",
  kaaba: "\uf66b",
  kaggle: "\uf5fa",
  kazoo: "\uf8c7",
  kerning: "\uf86f",
  key: "\uf084",
  "key-skeleton": "\uf6f3",
  "key-skeleton-left-right": "\ue3b4",
  keybase: "\uf4f5",
  keyboard: "\uf11c",
  "keyboard-brightness": "\ue1c0",
  "keyboard-brightness-low": "\ue1c1",
  "keyboard-down": "\ue1c2",
  "keyboard-left": "\ue1c3",
  keycdn: "\uf3ba",
  keynote: "\uf66c",
  khanda: "\uf66d",
  kickstarter: "\uf3bb",
  "kickstarter-k": "\uf3bc",
  kidneys: "\uf5fb",
  "kip-sign": "\ue1c4",
  "kit-medical": "\uf479",
  "kitchen-set": "\ue51a",
  kite: "\uf6f4",
  "kiwi-bird": "\uf535",
  "kiwi-fruit": "\ue30c",
  knife: "\uf2e4",
  "knife-kitchen": "\uf6f5",
  korvue: "\uf42f",
  l: "\u004c",
  "lacrosse-stick": "\ue3b5",
  "lacrosse-stick-ball": "\ue3b6",
  lambda: "\uf66e",
  lamp: "\uf4ca",
  "lamp-desk": "\ue014",
  "lamp-floor": "\ue015",
  "lamp-street": "\ue1c5",
  "land-mine-on": "\ue51b",
  landmark: "\uf66f",
  "landmark-dome": "\uf752",
  "landmark-flag": "\ue51c",
  language: "\uf1ab",
  laptop: "\uf109",
  "laptop-arrow-down": "\ue1c6",
  "laptop-code": "\uf5fc",
  "laptop-file": "\ue51d",
  "laptop-medical": "\uf812",
  "laptop-mobile": "\uf87a",
  "laptop-slash": "\ue1c7",
  laravel: "\uf3bd",
  "lari-sign": "\ue1c8",
  lasso: "\uf8c8",
  "lasso-sparkles": "\ue1c9",
  lastfm: "\uf202",
  "lastfm-square": "\uf203",
  "layer-group": "\uf5fd",
  "layer-minus": "\uf5fe",
  "layer-plus": "\uf5ff",
  leaf: "\uf06c",
  "leaf-heart": "\uf4cb",
  "leaf-maple": "\uf6f6",
  "leaf-oak": "\uf6f7",
  "leafy-green": "\ue41d",
  leanpub: "\uf212",
  left: "\uf355",
  "left-from-line": "\uf348",
  "left-long": "\uf30a",
  "left-long-to-line": "\ue41e",
  "left-right": "\uf337",
  "left-to-line": "\uf34b",
  lemon: "\uf094",
  less: "\uf41d",
  "less-than": "\u003c",
  "less-than-equal": "\uf537",
  "life-ring": "\uf1cd",
  "light-ceiling": "\ue016",
  "light-emergency": "\ue41f",
  "light-emergency-on": "\ue420",
  "light-switch": "\ue017",
  "light-switch-off": "\ue018",
  "light-switch-on": "\ue019",
  lightbulb: "\uf0eb",
  "lightbulb-dollar": "\uf670",
  "lightbulb-exclamation": "\uf671",
  "lightbulb-exclamation-on": "\ue1ca",
  "lightbulb-on": "\uf672",
  "lightbulb-slash": "\uf673",
  "lights-holiday": "\uf7b2",
  line: "\uf3c0",
  "line-columns": "\uf870",
  "line-height": "\uf871",
  "lines-leaning": "\ue51e",
  link: "\uf0c1",
  "link-horizontal": "\ue1cb",
  "link-horizontal-slash": "\ue1cc",
  "link-simple": "\ue1cd",
  "link-simple-slash": "\ue1ce",
  "link-slash": "\uf127",
  linkedin: "\uf08c",
  "linkedin-in": "\uf0e1",
  linode: "\uf2b8",
  linux: "\uf17c",
  lips: "\uf600",
  "lira-sign": "\uf195",
  list: "\uf03a",
  "list-check": "\uf0ae",
  "list-dropdown": "\ue1cf",
  "list-music": "\uf8c9",
  "list-ol": "\uf0cb",
  "list-radio": "\ue1d0",
  "list-timeline": "\ue1d1",
  "list-tree": "\ue1d2",
  "list-ul": "\uf0ca",
  "litecoin-sign": "\ue1d3",
  loader: "\ue1d4",
  lobster: "\ue421",
  "location-arrow": "\uf124",
  "location-check": "\uf606",
  "location-crosshairs": "\uf601",
  "location-crosshairs-slash": "\uf603",
  "location-dot": "\uf3c5",
  "location-dot-slash": "\uf605",
  "location-exclamation": "\uf608",
  "location-minus": "\uf609",
  "location-pen": "\uf607",
  "location-pin": "\uf041",
  "location-pin-lock": "\ue51f",
  "location-pin-slash": "\uf60c",
  "location-plus": "\uf60a",
  "location-question": "\uf60b",
  "location-smile": "\uf60d",
  "location-xmark": "\uf60e",
  lock: "\uf023",
  "lock-a": "\ue422",
  "lock-hashtag": "\ue423",
  "lock-keyhole": "\uf30d",
  "lock-keyhole-open": "\uf3c2",
  "lock-open": "\uf3c1",
  locust: "\ue520",
  lollipop: "\ue424",
  loveseat: "\uf4cc",
  "luchador-mask": "\uf455",
  lungs: "\uf604",
  "lungs-virus": "\ue067",
  lyft: "\uf3c3",
  m: "\u004d",
  mace: "\uf6f8",
  magento: "\uf3c4",
  magnet: "\uf076",
  "magnifying-glass": "\uf002",
  "magnifying-glass-arrow-right": "\ue521",
  "magnifying-glass-chart": "\ue522",
  "magnifying-glass-dollar": "\uf688",
  "magnifying-glass-location": "\uf689",
  "magnifying-glass-minus": "\uf010",
  "magnifying-glass-plus": "\uf00e",
  mailbox: "\uf813",
  mailchimp: "\uf59e",
  "manat-sign": "\ue1d5",
  mandalorian: "\uf50f",
  mandolin: "\uf6f9",
  mango: "\ue30f",
  manhole: "\ue1d6",
  map: "\uf279",
  "map-location": "\uf59f",
  "map-location-dot": "\uf5a0",
  "map-pin": "\uf276",
  markdown: "\uf60f",
  marker: "\uf5a1",
  mars: "\uf222",
  "mars-and-venus": "\uf224",
  "mars-and-venus-burst": "\ue523",
  "mars-double": "\uf227",
  "mars-stroke": "\uf229",
  "mars-stroke-right": "\uf22b",
  "mars-stroke-up": "\uf22a",
  "martini-glass": "\uf57b",
  "martini-glass-citrus": "\uf561",
  "martini-glass-empty": "\uf000",
  mask: "\uf6fa",
  "mask-face": "\ue1d7",
  "mask-snorkel": "\ue3b7",
  "mask-ventilator": "\ue524",
  "masks-theater": "\uf630",
  mastodon: "\uf4f6",
  "mattress-pillow": "\ue525",
  maxcdn: "\uf136",
  maximize: "\uf31e",
  mdb: "\uf8ca",
  meat: "\uf814",
  medal: "\uf5a2",
  medapps: "\uf3c6",
  medium: "\uf23a",
  medrt: "\uf3c8",
  meetup: "\uf2e0",
  megaphone: "\uf675",
  megaport: "\uf5a3",
  melon: "\ue310",
  "melon-slice": "\ue311",
  memo: "\ue1d8",
  "memo-circle-check": "\ue1d9",
  "memo-circle-info": "\ue49a",
  "memo-pad": "\ue1da",
  memory: "\uf538",
  mendeley: "\uf7b3",
  menorah: "\uf676",
  mercury: "\uf223",
  merge: "\ue526",
  message: "\uf27a",
  "message-arrow-down": "\ue1db",
  "message-arrow-up": "\ue1dc",
  "message-arrow-up-right": "\ue1dd",
  "message-bot": "\ue3b8",
  "message-captions": "\ue1de",
  "message-check": "\uf4a2",
  "message-code": "\ue1df",
  "message-dollar": "\uf650",
  "message-dots": "\uf4a3",
  "message-exclamation": "\uf4a5",
  "message-image": "\ue1e0",
  "message-lines": "\uf4a6",
  "message-medical": "\uf7f4",
  "message-middle": "\ue1e1",
  "message-middle-top": "\ue1e2",
  "message-minus": "\uf4a7",
  "message-music": "\uf8af",
  "message-pen": "\uf4a4",
  "message-plus": "\uf4a8",
  "message-question": "\ue1e3",
  "message-quote": "\ue1e4",
  "message-slash": "\uf4a9",
  "message-smile": "\uf4aa",
  "message-sms": "\ue1e5",
  "message-text": "\ue1e6",
  "message-xmark": "\uf4ab",
  messages: "\uf4b6",
  "messages-dollar": "\uf652",
  "messages-question": "\ue1e7",
  meta: "\ue49b",
  meteor: "\uf753",
  meter: "\ue1e8",
  "meter-bolt": "\ue1e9",
  "meter-droplet": "\ue1ea",
  "meter-fire": "\ue1eb",
  microblog: "\ue01a",
  microchip: "\uf2db",
  "microchip-ai": "\ue1ec",
  microphone: "\uf130",
  "microphone-lines": "\uf3c9",
  "microphone-lines-slash": "\uf539",
  "microphone-slash": "\uf131",
  "microphone-stand": "\uf8cb",
  microscope: "\uf610",
  microsoft: "\uf3ca",
  microwave: "\ue01b",
  "mill-sign": "\ue1ed",
  minimize: "\uf78c",
  minus: "\uf068",
  mistletoe: "\uf7b4",
  mitten: "\uf7b5",
  mix: "\uf3cb",
  mixcloud: "\uf289",
  mixer: "\ue056",
  mizuni: "\uf3cc",
  mobile: "\uf3ce",
  "mobile-button": "\uf10b",
  "mobile-notch": "\ue1ee",
  "mobile-retro": "\ue527",
  "mobile-screen": "\uf3cf",
  "mobile-screen-button": "\uf3cd",
  "mobile-signal": "\ue1ef",
  "mobile-signal-out": "\ue1f0",
  modx: "\uf285",
  monero: "\uf3d0",
  "money-bill": "\uf0d6",
  "money-bill-1": "\uf3d1",
  "money-bill-1-wave": "\uf53b",
  "money-bill-simple": "\ue1f1",
  "money-bill-simple-wave": "\ue1f2",
  "money-bill-transfer": "\ue528",
  "money-bill-trend-up": "\ue529",
  "money-bill-wave": "\uf53a",
  "money-bill-wheat": "\ue52a",
  "money-bills": "\ue1f3",
  "money-bills-simple": "\ue1f4",
  "money-check": "\uf53c",
  "money-check-dollar": "\uf53d",
  "money-check-dollar-pen": "\uf873",
  "money-check-pen": "\uf872",
  "money-from-bracket": "\ue312",
  "money-simple-from-bracket": "\ue313",
  "monitor-waveform": "\uf611",
  monkey: "\uf6fb",
  monument: "\uf5a6",
  moon: "\uf186",
  "moon-cloud": "\uf754",
  "moon-over-sun": "\uf74a",
  "moon-stars": "\uf755",
  moped: "\ue3b9",
  "mortar-pestle": "\uf5a7",
  mosque: "\uf678",
  mosquito: "\ue52b",
  "mosquito-net": "\ue52c",
  motorcycle: "\uf21c",
  mound: "\ue52d",
  mountain: "\uf6fc",
  "mountain-city": "\ue52e",
  "mountain-sun": "\ue52f",
  mountains: "\uf6fd",
  "mp3-player": "\uf8ce",
  mug: "\uf874",
  "mug-hot": "\uf7b6",
  "mug-marshmallows": "\uf7b7",
  "mug-saucer": "\uf0f4",
  "mug-tea": "\uf875",
  "mug-tea-saucer": "\ue1f5",
  mushroom: "\ue425",
  music: "\uf001",
  "music-note": "\uf8cf",
  "music-note-slash": "\uf8d0",
  "music-slash": "\uf8d1",
  n: "\u004e",
  "naira-sign": "\ue1f6",
  napster: "\uf3d2",
  narwhal: "\uf6fe",
  neos: "\uf612",
  "nesting-dolls": "\ue3ba",
  "network-wired": "\uf6ff",
  neuter: "\uf22c",
  newspaper: "\uf1ea",
  nfc: "\ue1f7",
  "nfc-directional": "\ue530",
  "nfc-lock": "\ue1f8",
  "nfc-magnifying-glass": "\ue1f9",
  "nfc-pen": "\ue1fa",
  "nfc-signal": "\ue1fb",
  "nfc-slash": "\ue1fc",
  "nfc-symbol": "\ue531",
  "nfc-trash": "\ue1fd",
  nimblr: "\uf5a8",
  node: "\uf419",
  "node-js": "\uf3d3",
  "not-equal": "\uf53e",
  notdef: "\ue1fe",
  note: "\ue1ff",
  "note-medical": "\ue200",
  "note-sticky": "\uf249",
  notebook: "\ue201",
  notes: "\ue202",
  "notes-medical": "\uf481",
  npm: "\uf3d4",
  ns8: "\uf3d5",
  nutritionix: "\uf3d6",
  o: "\u004f",
  "object-exclude": "\ue49c",
  "object-group": "\uf247",
  "object-intersect": "\ue49d",
  "object-subtract": "\ue49e",
  "object-ungroup": "\uf248",
  "object-union": "\ue49f",
  "objects-align-bottom": "\ue3bb",
  "objects-align-center-horizontal": "\ue3bc",
  "objects-align-center-vertical": "\ue3bd",
  "objects-align-left": "\ue3be",
  "objects-align-right": "\ue3bf",
  "objects-align-top": "\ue3c0",
  "objects-column": "\ue3c1",
  octagon: "\uf306",
  "octagon-check": "\ue426",
  "octagon-divide": "\ue203",
  "octagon-exclamation": "\ue204",
  "octagon-minus": "\uf308",
  "octagon-plus": "\uf301",
  "octagon-xmark": "\uf2f0",
  "octopus-deploy": "\ue082",
  odnoklassniki: "\uf263",
  "odnoklassniki-square": "\uf264",
  "oil-can": "\uf613",
  "oil-can-drip": "\ue205",
  "oil-temperature": "\uf614",
  "oil-well": "\ue532",
  "old-republic": "\uf510",
  olive: "\ue316",
  "olive-branch": "\ue317",
  om: "\uf679",
  omega: "\uf67a",
  onion: "\ue427",
  opencart: "\uf23d",
  openid: "\uf19b",
  opera: "\uf26a",
  "optin-monster": "\uf23c",
  option: "\ue318",
  orcid: "\uf8d2",
  ornament: "\uf7b8",
  osi: "\uf41a",
  otter: "\uf700",
  outdent: "\uf03b",
  outlet: "\ue01c",
  oven: "\ue01d",
  overline: "\uf876",
  p: "\u0050",
  padlet: "\ue4a0",
  page: "\ue428",
  "page-caret-down": "\ue429",
  "page-caret-up": "\ue42a",
  page4: "\uf3d7",
  pagelines: "\uf18c",
  pager: "\uf815",
  "paint-roller": "\uf5aa",
  paintbrush: "\uf1fc",
  "paintbrush-fine": "\uf5a9",
  "paintbrush-pencil": "\ue206",
  palette: "\uf53f",
  palfed: "\uf3d8",
  pallet: "\uf482",
  "pallet-box": "\ue208",
  "pallet-boxes": "\uf483",
  "pan-food": "\ue42b",
  "pan-frying": "\ue42c",
  pancakes: "\ue42d",
  "panel-ews": "\ue42e",
  "panel-fire": "\ue42f",
  panorama: "\ue209",
  "paper-plane": "\uf1d8",
  "paper-plane-top": "\ue20a",
  paperclip: "\uf0c6",
  "paperclip-vertical": "\ue3c2",
  "parachute-box": "\uf4cd",
  paragraph: "\uf1dd",
  "paragraph-left": "\uf878",
  "party-bell": "\ue31a",
  "party-horn": "\ue31b",
  passport: "\uf5ab",
  paste: "\uf0ea",
  patreon: "\uf3d9",
  pause: "\uf04c",
  paw: "\uf1b0",
  "paw-claws": "\uf702",
  "paw-simple": "\uf701",
  paypal: "\uf1ed",
  peace: "\uf67c",
  peach: "\ue20b",
  peanut: "\ue430",
  peanuts: "\ue431",
  peapod: "\ue31c",
  pear: "\ue20c",
  pedestal: "\ue20d",
  pegasus: "\uf703",
  pen: "\uf304",
  "pen-circle": "\ue20e",
  "pen-clip": "\uf305",
  "pen-clip-slash": "\ue20f",
  "pen-fancy": "\uf5ac",
  "pen-fancy-slash": "\ue210",
  "pen-field": "\ue211",
  "pen-line": "\ue212",
  "pen-nib": "\uf5ad",
  "pen-nib-slash": "\ue4a1",
  "pen-paintbrush": "\uf618",
  "pen-ruler": "\uf5ae",
  "pen-slash": "\ue213",
  "pen-swirl": "\ue214",
  "pen-to-square": "\uf044",
  pencil: "\uf303",
  "pencil-slash": "\ue215",
  people: "\ue216",
  "people-arrows-left-right": "\ue068",
  "people-carry-box": "\uf4ce",
  "people-dress": "\ue217",
  "people-dress-simple": "\ue218",
  "people-group": "\ue533",
  "people-line": "\ue534",
  "people-pants": "\ue219",
  "people-pants-simple": "\ue21a",
  "people-pulling": "\ue535",
  "people-robbery": "\ue536",
  "people-roof": "\ue537",
  "people-simple": "\ue21b",
  pepper: "\ue432",
  "pepper-hot": "\uf816",
  perbyte: "\ue083",
  percent: "\u0025",
  period: "\u002e",
  periscope: "\uf3da",
  person: "\uf183",
  "person-arrow-down-to-line": "\ue538",
  "person-arrow-up-from-line": "\ue539",
  "person-biking": "\uf84a",
  "person-biking-mountain": "\uf84b",
  "person-booth": "\uf756",
  "person-breastfeeding": "\ue53a",
  "person-burst": "\ue53b",
  "person-cane": "\ue53c",
  "person-carry-box": "\uf4cf",
  "person-chalkboard": "\ue53d",
  "person-circle-check": "\ue53e",
  "person-circle-exclamation": "\ue53f",
  "person-circle-minus": "\ue540",
  "person-circle-plus": "\ue541",
  "person-circle-question": "\ue542",
  "person-circle-xmark": "\ue543",
  "person-digging": "\uf85e",
  "person-dolly": "\uf4d0",
  "person-dolly-empty": "\uf4d1",
  "person-dots-from-line": "\uf470",
  "person-dress": "\uf182",
  "person-dress-burst": "\ue544",
  "person-dress-simple": "\ue21c",
  "person-drowning": "\ue545",
  "person-falling": "\ue546",
  "person-falling-burst": "\ue547",
  "person-from-portal": "\ue023",
  "person-half-dress": "\ue548",
  "person-harassing": "\ue549",
  "person-hiking": "\uf6ec",
  "person-military-pointing": "\ue54a",
  "person-military-rifle": "\ue54b",
  "person-military-to-person": "\ue54c",
  "person-pinball": "\ue21d",
  "person-praying": "\uf683",
  "person-pregnant": "\ue31e",
  "person-rays": "\ue54d",
  "person-rifle": "\ue54e",
  "person-running": "\uf70c",
  "person-seat": "\ue21e",
  "person-seat-reclined": "\ue21f",
  "person-shelter": "\ue54f",
  "person-sign": "\uf757",
  "person-simple": "\ue220",
  "person-skating": "\uf7c5",
  "person-ski-jumping": "\uf7c7",
  "person-ski-lift": "\uf7c8",
  "person-skiing": "\uf7c9",
  "person-skiing-nordic": "\uf7ca",
  "person-sledding": "\uf7cb",
  "person-snowboarding": "\uf7ce",
  "person-snowmobiling": "\uf7d1",
  "person-swimming": "\uf5c4",
  "person-through-window": "\ue433",
  "person-to-door": "\ue550",
  "person-to-portal": "\ue022",
  "person-walking": "\uf554",
  "person-walking-arrow-loop-left": "\ue551",
  "person-walking-arrow-right": "\ue552",
  "person-walking-dashed-line-arrow-right": "\ue553",
  "person-walking-luggage": "\ue554",
  "person-walking-with-cane": "\uf29d",
  "peseta-sign": "\ue221",
  "peso-sign": "\ue222",
  phabricator: "\uf3db",
  "phoenix-framework": "\uf3dc",
  "phoenix-squadron": "\uf511",
  phone: "\uf095",
  "phone-arrow-down-left": "\ue223",
  "phone-arrow-up-right": "\ue224",
  "phone-flip": "\uf879",
  "phone-hangup": "\ue225",
  "phone-intercom": "\ue434",
  "phone-missed": "\ue226",
  "phone-office": "\uf67d",
  "phone-plus": "\uf4d2",
  "phone-rotary": "\uf8d3",
  "phone-slash": "\uf3dd",
  "phone-volume": "\uf2a0",
  "phone-xmark": "\ue227",
  "photo-film": "\uf87c",
  "photo-film-music": "\ue228",
  php: "\uf457",
  pi: "\uf67e",
  piano: "\uf8d4",
  "piano-keyboard": "\uf8d5",
  pickleball: "\ue435",
  pie: "\uf705",
  "pied-piper": "\uf2ae",
  "pied-piper-alt": "\uf1a8",
  "pied-piper-hat": "\uf4e5",
  "pied-piper-pp": "\uf1a7",
  "pied-piper-square": "\ue01e",
  pig: "\uf706",
  "piggy-bank": "\uf4d3",
  pills: "\uf484",
  pinata: "\ue3c3",
  pinball: "\ue229",
  pineapple: "\ue31f",
  pinterest: "\uf0d2",
  "pinterest-p": "\uf231",
  "pinterest-square": "\uf0d3",
  pipe: "\u007c",
  "pipe-circle-check": "\ue436",
  "pipe-collar": "\ue437",
  "pipe-section": "\ue438",
  "pipe-smoking": "\ue3c4",
  "pipe-valve": "\ue439",
  pix: "\ue43a",
  pizza: "\uf817",
  "pizza-slice": "\uf818",
  "place-of-worship": "\uf67f",
  plane: "\uf072",
  "plane-arrival": "\uf5af",
  "plane-circle-check": "\ue555",
  "plane-circle-exclamation": "\ue556",
  "plane-circle-xmark": "\ue557",
  "plane-departure": "\uf5b0",
  "plane-engines": "\uf3de",
  "plane-lock": "\ue558",
  "plane-prop": "\ue22b",
  "plane-slash": "\ue069",
  "plane-tail": "\ue22c",
  "plane-up": "\ue22d",
  "plane-up-slash": "\ue22e",
  "planet-moon": "\ue01f",
  "planet-ringed": "\ue020",
  "plant-wilt": "\ue43b",
  "plate-utensils": "\ue559",
  "plate-wheat": "\ue55a",
  play: "\uf04b",
  "play-pause": "\ue22f",
  playstation: "\uf3df",
  plug: "\uf1e6",
  "plug-circle-bolt": "\ue55b",
  "plug-circle-check": "\ue55c",
  "plug-circle-exclamation": "\ue55d",
  "plug-circle-minus": "\ue55e",
  "plug-circle-plus": "\ue55f",
  "plug-circle-xmark": "\ue560",
  plus: "\u002b",
  "plus-large": "\ue59e",
  "plus-minus": "\ue43c",
  podcast: "\uf2ce",
  podium: "\uf680",
  "podium-star": "\uf758",
  "police-box": "\ue021",
  "poll-people": "\uf759",
  pompebled: "\ue43d",
  poo: "\uf2fe",
  "poo-storm": "\uf75a",
  "pool-8-ball": "\ue3c5",
  poop: "\uf619",
  popcorn: "\uf819",
  popsicle: "\ue43e",
  "pot-food": "\ue43f",
  potato: "\ue440",
  "power-off": "\uf011",
  prescription: "\uf5b1",
  "prescription-bottle": "\uf485",
  "prescription-bottle-medical": "\uf486",
  "presentation-screen": "\uf685",
  pretzel: "\ue441",
  print: "\uf02f",
  "print-magnifying-glass": "\uf81a",
  "print-slash": "\uf686",
  "product-hunt": "\uf288",
  projector: "\uf8d6",
  pump: "\ue442",
  "pump-medical": "\ue06a",
  "pump-soap": "\ue06b",
  pumpkin: "\uf707",
  pushed: "\uf3e1",
  puzzle: "\ue443",
  "puzzle-piece": "\uf12e",
  "puzzle-piece-simple": "\ue231",
  python: "\uf3e2",
  q: "\u0051",
  qq: "\uf1d6",
  qrcode: "\uf029",
  question: "\u003f",
  quinscape: "\uf459",
  quora: "\uf2c4",
  "quote-left": "\uf10d",
  "quote-right": "\uf10e",
  quotes: "\ue234",
  r: "\u0052",
  "r-project": "\uf4f7",
  rabbit: "\uf708",
  "rabbit-running": "\uf709",
  racquet: "\uf45a",
  radar: "\ue024",
  radiation: "\uf7b9",
  radio: "\uf8d7",
  "radio-tuner": "\uf8d8",
  rainbow: "\uf75b",
  raindrops: "\uf75c",
  ram: "\uf70a",
  "ramp-loading": "\uf4d4",
  "ranking-star": "\ue561",
  "raspberry-pi": "\uf7bb",
  ravelry: "\uf2d9",
  raygun: "\ue025",
  react: "\uf41b",
  reacteurope: "\uf75d",
  readme: "\uf4d5",
  rebel: "\uf1d0",
  receipt: "\uf543",
  "record-vinyl": "\uf8d9",
  rectangle: "\uf2fa",
  "rectangle-ad": "\uf641",
  "rectangle-barcode": "\uf463",
  "rectangle-code": "\ue322",
  "rectangle-history": "\ue4a2",
  "rectangle-history-circle-plus": "\ue4a3",
  "rectangle-history-circle-user": "\ue4a4",
  "rectangle-list": "\uf022",
  "rectangle-pro": "\ue235",
  "rectangle-terminal": "\ue236",
  "rectangle-vertical": "\uf2fb",
  "rectangle-vertical-history": "\ue237",
  "rectangle-wide": "\uf2fc",
  "rectangle-xmark": "\uf410",
  "rectangles-mixed": "\ue323",
  recycle: "\uf1b8",
  "red-river": "\uf3e3",
  reddit: "\uf1a1",
  "reddit-alien": "\uf281",
  "reddit-square": "\uf1a2",
  redhat: "\uf7bc",
  reel: "\ue238",
  refrigerator: "\ue026",
  registered: "\uf25d",
  renren: "\uf18b",
  repeat: "\uf363",
  "repeat-1": "\uf365",
  reply: "\uf3e5",
  "reply-all": "\uf122",
  "reply-clock": "\ue239",
  replyd: "\uf3e6",
  republican: "\uf75e",
  researchgate: "\uf4f8",
  resolving: "\uf3e7",
  restroom: "\uf7bd",
  "restroom-simple": "\ue23a",
  retweet: "\uf079",
  rev: "\uf5b2",
  rhombus: "\ue23b",
  ribbon: "\uf4d6",
  right: "\uf356",
  "right-from-bracket": "\uf2f5",
  "right-from-line": "\uf347",
  "right-left": "\uf362",
  "right-long": "\uf30b",
  "right-long-to-line": "\ue444",
  "right-to-bracket": "\uf2f6",
  "right-to-line": "\uf34c",
  ring: "\uf70b",
  "rings-wedding": "\uf81b",
  road: "\uf018",
  "road-barrier": "\ue562",
  "road-bridge": "\ue563",
  "road-circle-check": "\ue564",
  "road-circle-exclamation": "\ue565",
  "road-circle-xmark": "\ue566",
  "road-lock": "\ue567",
  "road-spikes": "\ue568",
  robot: "\uf544",
  "robot-astromech": "\ue2d2",
  rocket: "\uf135",
  "rocket-launch": "\ue027",
  rocketchat: "\uf3e8",
  rockrms: "\uf3e9",
  "roller-coaster": "\ue324",
  rotate: "\uf2f1",
  "rotate-exclamation": "\ue23c",
  "rotate-left": "\uf2ea",
  "rotate-right": "\uf2f9",
  route: "\uf4d7",
  "route-highway": "\uf61a",
  "route-interstate": "\uf61b",
  router: "\uf8da",
  rss: "\uf09e",
  "ruble-sign": "\uf158",
  rug: "\ue569",
  "rugby-ball": "\ue3c6",
  ruler: "\uf545",
  "ruler-combined": "\uf546",
  "ruler-horizontal": "\uf547",
  "ruler-triangle": "\uf61c",
  "ruler-vertical": "\uf548",
  "rupee-sign": "\uf156",
  "rupiah-sign": "\ue23d",
  rust: "\ue07a",
  rv: "\uf7be",
  s: "\u0053",
  sack: "\uf81c",
  "sack-dollar": "\uf81d",
  "sack-xmark": "\ue56a",
  safari: "\uf267",
  sailboat: "\ue445",
  salad: "\uf81e",
  salesforce: "\uf83b",
  "salt-shaker": "\ue446",
  sandwich: "\uf81f",
  sass: "\uf41e",
  satellite: "\uf7bf",
  "satellite-dish": "\uf7c0",
  sausage: "\uf820",
  saxophone: "\uf8dc",
  "saxophone-fire": "\uf8db",
  "scale-balanced": "\uf24e",
  "scale-unbalanced": "\uf515",
  "scale-unbalanced-flip": "\uf516",
  scalpel: "\uf61d",
  "scalpel-line-dashed": "\uf61e",
  scanner: "\uf8f3",
  "scanner-gun": "\uf488",
  "scanner-keyboard": "\uf489",
  "scanner-touchscreen": "\uf48a",
  scarecrow: "\uf70d",
  scarf: "\uf7c1",
  schlix: "\uf3ea",
  school: "\uf549",
  "school-circle-check": "\ue56b",
  "school-circle-exclamation": "\ue56c",
  "school-circle-xmark": "\ue56d",
  "school-flag": "\ue56e",
  "school-lock": "\ue56f",
  scissors: "\uf0c4",
  "screen-users": "\uf63d",
  screencast: "\ue23e",
  screenpal: "\ue570",
  screwdriver: "\uf54a",
  "screwdriver-wrench": "\uf7d9",
  scribble: "\ue23f",
  scribd: "\uf28a",
  scroll: "\uf70e",
  "scroll-old": "\uf70f",
  "scroll-torah": "\uf6a0",
  scrubber: "\uf2f8",
  scythe: "\uf710",
  "sd-card": "\uf7c2",
  "sd-cards": "\ue240",
  seal: "\ue241",
  "seal-exclamation": "\ue242",
  "seal-question": "\ue243",
  searchengin: "\uf3eb",
  "seat-airline": "\ue244",
  section: "\ue447",
  seedling: "\uf4d8",
  sellcast: "\uf2da",
  sellsy: "\uf213",
  semicolon: "\u003b",
  "send-back": "\uf87e",
  "send-backward": "\uf87f",
  sensor: "\ue028",
  "sensor-cloud": "\ue02c",
  "sensor-fire": "\ue02a",
  "sensor-on": "\ue02b",
  "sensor-triangle-exclamation": "\ue029",
  server: "\uf233",
  servicestack: "\uf3ec",
  shapes: "\uf61f",
  share: "\uf064",
  "share-all": "\uf367",
  "share-from-square": "\uf14d",
  "share-nodes": "\uf1e0",
  sheep: "\uf711",
  "sheet-plastic": "\ue571",
  "shekel-sign": "\uf20b",
  shelves: "\uf480",
  "shelves-empty": "\ue246",
  shield: "\uf132",
  "shield-cat": "\ue572",
  "shield-check": "\uf2f7",
  "shield-cross": "\uf712",
  "shield-dog": "\ue573",
  "shield-exclamation": "\ue247",
  "shield-halved": "\uf3ed",
  "shield-heart": "\ue574",
  "shield-keyhole": "\ue248",
  "shield-minus": "\ue249",
  "shield-plus": "\ue24a",
  "shield-quartered": "\ue575",
  "shield-slash": "\ue24b",
  "shield-virus": "\ue06c",
  "shield-xmark": "\ue24c",
  ship: "\uf21a",
  shirt: "\uf553",
  "shirt-long-sleeve": "\ue3c7",
  "shirt-running": "\ue3c8",
  "shirt-tank-top": "\ue3c9",
  shirtsinbulk: "\uf214",
  "shish-kebab": "\uf821",
  "shoe-prints": "\uf54b",
  shop: "\uf54f",
  "shop-lock": "\ue4a5",
  "shop-slash": "\ue070",
  shopify: "\ue057",
  shopware: "\uf5b5",
  shovel: "\uf713",
  "shovel-snow": "\uf7c3",
  shower: "\uf2cc",
  "shower-down": "\ue24d",
  shredder: "\uf68a",
  shrimp: "\ue448",
  shuffle: "\uf074",
  shutters: "\ue449",
  "shuttle-space": "\uf197",
  shuttlecock: "\uf45b",
  sickle: "\uf822",
  sidebar: "\ue24e",
  "sidebar-flip": "\ue24f",
  sigma: "\uf68b",
  "sign-hanging": "\uf4d9",
  signal: "\uf012",
  "signal-bars": "\uf690",
  "signal-bars-fair": "\uf692",
  "signal-bars-good": "\uf693",
  "signal-bars-slash": "\uf694",
  "signal-bars-weak": "\uf691",
  "signal-fair": "\uf68d",
  "signal-good": "\uf68e",
  "signal-slash": "\uf695",
  "signal-stream": "\uf8dd",
  "signal-stream-slash": "\ue250",
  "signal-strong": "\uf68f",
  "signal-weak": "\uf68c",
  signature: "\uf5b7",
  "signature-lock": "\ue3ca",
  "signature-slash": "\ue3cb",
  "signs-post": "\uf277",
  "sim-card": "\uf7c4",
  "sim-cards": "\ue251",
  simplybuilt: "\uf215",
  sink: "\ue06d",
  siren: "\ue02d",
  "siren-on": "\ue02e",
  sistrix: "\uf3ee",
  sitemap: "\uf0e8",
  sith: "\uf512",
  sitrox: "\ue44a",
  skeleton: "\uf620",
  sketch: "\uf7c6",
  "ski-boot": "\ue3cc",
  "ski-boot-ski": "\ue3cd",
  skull: "\uf54c",
  "skull-cow": "\uf8de",
  "skull-crossbones": "\uf714",
  skyatlas: "\uf216",
  skype: "\uf17e",
  slack: "\uf198",
  slash: "\uf715",
  "slash-back": "\u005c",
  "slash-forward": "\u002f",
  sleigh: "\uf7cc",
  slider: "\ue252",
  sliders: "\uf1de",
  "sliders-simple": "\ue253",
  "sliders-up": "\uf3f1",
  slideshare: "\uf1e7",
  "slot-machine": "\ue3ce",
  smog: "\uf75f",
  smoke: "\uf760",
  smoking: "\uf48d",
  snake: "\uf716",
  snapchat: "\uf2ab",
  "snapchat-square": "\uf2ad",
  snooze: "\uf880",
  "snow-blowing": "\uf761",
  snowflake: "\uf2dc",
  snowflakes: "\uf7cf",
  snowman: "\uf7d0",
  "snowman-head": "\uf79b",
  snowplow: "\uf7d2",
  soap: "\ue06e",
  socks: "\uf696",
  "soft-serve": "\ue400",
  "solar-panel": "\uf5ba",
  "solar-system": "\ue02f",
  sort: "\uf0dc",
  "sort-down": "\uf0dd",
  "sort-up": "\uf0de",
  soundcloud: "\uf1be",
  sourcetree: "\uf7d3",
  spa: "\uf5bb",
  "space-station-moon": "\ue033",
  "space-station-moon-construction": "\ue034",
  spade: "\uf2f4",
  "spaghetti-monster-flying": "\uf67b",
  sparkles: "\uf890",
  speakap: "\uf3f3",
  speaker: "\uf8df",
  "speaker-deck": "\uf83c",
  speakers: "\uf8e0",
  "spell-check": "\uf891",
  spider: "\uf717",
  "spider-black-widow": "\uf718",
  "spider-web": "\uf719",
  spinner: "\uf110",
  "spinner-third": "\uf3f4",
  split: "\ue254",
  splotch: "\uf5bc",
  spoon: "\uf2e5",
  sportsball: "\ue44b",
  spotify: "\uf1bc",
  "spray-can": "\uf5bd",
  "spray-can-sparkles": "\uf5d0",
  sprinkler: "\ue035",
  "sprinkler-ceiling": "\ue44c",
  square: "\uf0c8",
  "square-0": "\ue255",
  "square-1": "\ue256",
  "square-2": "\ue257",
  "square-3": "\ue258",
  "square-4": "\ue259",
  "square-5": "\ue25a",
  "square-6": "\ue25b",
  "square-7": "\ue25c",
  "square-8": "\ue25d",
  "square-9": "\ue25e",
  "square-a": "\ue25f",
  "square-a-lock": "\ue44d",
  "square-ampersand": "\ue260",
  "square-arrow-down": "\uf339",
  "square-arrow-down-left": "\ue261",
  "square-arrow-down-right": "\ue262",
  "square-arrow-left": "\uf33a",
  "square-arrow-right": "\uf33b",
  "square-arrow-up": "\uf33c",
  "square-arrow-up-left": "\ue263",
  "square-arrow-up-right": "\uf14c",
  "square-b": "\ue264",
  "square-bolt": "\ue265",
  "square-c": "\ue266",
  "square-caret-down": "\uf150",
  "square-caret-left": "\uf191",
  "square-caret-right": "\uf152",
  "square-caret-up": "\uf151",
  "square-check": "\uf14a",
  "square-chevron-down": "\uf329",
  "square-chevron-left": "\uf32a",
  "square-chevron-right": "\uf32b",
  "square-chevron-up": "\uf32c",
  "square-code": "\ue267",
  "square-d": "\ue268",
  "square-dashed": "\ue269",
  "square-divide": "\ue26a",
  "square-dollar": "\uf2e9",
  "square-down": "\uf350",
  "square-down-left": "\ue26b",
  "square-down-right": "\ue26c",
  "square-e": "\ue26d",
  "square-ellipsis": "\ue26e",
  "square-ellipsis-vertical": "\ue26f",
  "square-envelope": "\uf199",
  "square-exclamation": "\uf321",
  "square-f": "\ue270",
  "square-font-awesome": "\uf425",
  "square-font-awesome-stroke": "\uf35c",
  "square-fragile": "\uf49b",
  "square-full": "\uf45c",
  "square-g": "\ue271",
  "square-h": "\uf0fd",
  "square-heart": "\uf4c8",
  "square-i": "\ue272",
  "square-info": "\uf30f",
  "square-j": "\ue273",
  "square-k": "\ue274",
  "square-kanban": "\ue488",
  "square-l": "\ue275",
  "square-left": "\uf351",
  "square-list": "\ue489",
  "square-m": "\ue276",
  "square-minus": "\uf146",
  "square-n": "\ue277",
  "square-nfi": "\ue576",
  "square-o": "\ue278",
  "square-p": "\ue279",
  "square-parking": "\uf540",
  "square-parking-slash": "\uf617",
  "square-pen": "\uf14b",
  "square-person-confined": "\ue577",
  "square-phone": "\uf098",
  "square-phone-flip": "\uf87b",
  "square-phone-hangup": "\ue27a",
  "square-plus": "\uf0fe",
  "square-poll-horizontal": "\uf682",
  "square-poll-vertical": "\uf681",
  "square-q": "\ue27b",
  "square-quarters": "\ue44e",
  "square-question": "\uf2fd",
  "square-quote": "\ue329",
  "square-r": "\ue27c",
  "square-right": "\uf352",
  "square-ring": "\ue44f",
  "square-root": "\uf697",
  "square-root-variable": "\uf698",
  "square-rss": "\uf143",
  "square-s": "\ue27d",
  "square-share-nodes": "\uf1e1",
  "square-sliders": "\uf3f0",
  "square-sliders-vertical": "\uf3f2",
  "square-small": "\ue27e",
  "square-star": "\ue27f",
  "square-t": "\ue280",
  "square-terminal": "\ue32a",
  "square-this-way-up": "\uf49f",
  "square-u": "\ue281",
  "square-up": "\uf353",
  "square-up-left": "\ue282",
  "square-up-right": "\uf360",
  "square-user": "\ue283",
  "square-v": "\ue284",
  "square-virus": "\ue578",
  "square-w": "\ue285",
  "square-x": "\ue286",
  "square-xmark": "\uf2d3",
  "square-y": "\ue287",
  "square-z": "\ue288",
  squarespace: "\uf5be",
  squid: "\ue450",
  squirrel: "\uf71a",
  "stack-exchange": "\uf18d",
  "stack-overflow": "\uf16c",
  stackpath: "\uf842",
  staff: "\uf71b",
  "staff-aesculapius": "\ue579",
  stairs: "\ue289",
  stamp: "\uf5bf",
  "standard-definition": "\ue28a",
  star: "\uf005",
  "star-and-crescent": "\uf699",
  "star-christmas": "\uf7d4",
  "star-exclamation": "\uf2f3",
  "star-half": "\uf089",
  "star-half-stroke": "\uf5c0",
  "star-of-david": "\uf69a",
  "star-of-life": "\uf621",
  "star-sharp": "\ue28b",
  "star-sharp-half": "\ue28c",
  "star-sharp-half-stroke": "\ue28d",
  "star-shooting": "\ue036",
  starfighter: "\ue037",
  "starfighter-twin-ion-engine": "\ue038",
  "starfighter-twin-ion-engine-advanced": "\ue28e",
  stars: "\uf762",
  starship: "\ue039",
  "starship-freighter": "\ue03a",
  staylinked: "\uf3f5",
  steak: "\uf824",
  steam: "\uf1b6",
  "steam-square": "\uf1b7",
  "steam-symbol": "\uf3f6",
  "steering-wheel": "\uf622",
  "sterling-sign": "\uf154",
  stethoscope: "\uf0f1",
  "sticker-mule": "\uf3f7",
  stocking: "\uf7d5",
  stomach: "\uf623",
  stop: "\uf04d",
  stopwatch: "\uf2f2",
  "stopwatch-20": "\ue06f",
  store: "\uf54e",
  "store-lock": "\ue4a6",
  "store-slash": "\ue071",
  strava: "\uf428",
  strawberry: "\ue32b",
  "street-view": "\uf21d",
  stretcher: "\uf825",
  strikethrough: "\uf0cc",
  stripe: "\uf429",
  "stripe-s": "\uf42a",
  stroopwafel: "\uf551",
  studiovinari: "\uf3f8",
  stumbleupon: "\uf1a4",
  "stumbleupon-circle": "\uf1a3",
  subscript: "\uf12c",
  suitcase: "\uf0f2",
  "suitcase-medical": "\uf0fa",
  "suitcase-rolling": "\uf5c1",
  sun: "\uf185",
  "sun-bright": "\ue28f",
  "sun-cloud": "\uf763",
  "sun-dust": "\uf764",
  "sun-haze": "\uf765",
  "sun-plant-wilt": "\ue57a",
  sunglasses: "\uf892",
  sunrise: "\uf766",
  sunset: "\uf767",
  superpowers: "\uf2dd",
  superscript: "\uf12b",
  supple: "\uf3f9",
  suse: "\uf7d6",
  sushi: "\ue48a",
  "sushi-roll": "\ue48b",
  swatchbook: "\uf5c3",
  swift: "\uf8e1",
  sword: "\uf71c",
  "sword-laser": "\ue03b",
  "sword-laser-alt": "\ue03c",
  swords: "\uf71d",
  "swords-laser": "\ue03d",
  symbols: "\uf86e",
  symfony: "\uf83d",
  synagogue: "\uf69b",
  syringe: "\uf48e",
  t: "\u0054",
  table: "\uf0ce",
  "table-cells": "\uf00a",
  "table-cells-large": "\uf009",
  "table-columns": "\uf0db",
  "table-layout": "\ue290",
  "table-list": "\uf00b",
  "table-picnic": "\ue32d",
  "table-pivot": "\ue291",
  "table-rows": "\ue292",
  "table-tennis-paddle-ball": "\uf45d",
  "table-tree": "\ue293",
  tablet: "\uf3fb",
  "tablet-button": "\uf10a",
  "tablet-rugged": "\uf48f",
  "tablet-screen": "\uf3fc",
  "tablet-screen-button": "\uf3fa",
  tablets: "\uf490",
  "tachograph-digital": "\uf566",
  taco: "\uf826",
  tag: "\uf02b",
  tags: "\uf02c",
  tally: "\uf69c",
  "tally-1": "\ue294",
  "tally-2": "\ue295",
  "tally-3": "\ue296",
  "tally-4": "\ue297",
  tamale: "\ue451",
  "tank-water": "\ue452",
  tape: "\uf4db",
  tarp: "\ue57b",
  "tarp-droplet": "\ue57c",
  taxi: "\uf1ba",
  "taxi-bus": "\ue298",
  teamspeak: "\uf4f9",
  "teddy-bear": "\ue3cf",
  teeth: "\uf62e",
  "teeth-open": "\uf62f",
  telegram: "\uf2c6",
  telescope: "\ue03e",
  "temperature-arrow-down": "\ue03f",
  "temperature-arrow-up": "\ue040",
  "temperature-empty": "\uf2cb",
  "temperature-full": "\uf2c7",
  "temperature-half": "\uf2c9",
  "temperature-high": "\uf769",
  "temperature-list": "\ue299",
  "temperature-low": "\uf76b",
  "temperature-quarter": "\uf2ca",
  "temperature-snow": "\uf768",
  "temperature-sun": "\uf76a",
  "temperature-three-quarters": "\uf2c8",
  "tencent-weibo": "\uf1d5",
  "tenge-sign": "\uf7d7",
  "tennis-ball": "\uf45e",
  tent: "\ue57d",
  "tent-arrow-down-to-line": "\ue57e",
  "tent-arrow-left-right": "\ue57f",
  "tent-arrow-turn-left": "\ue580",
  "tent-arrows-down": "\ue581",
  tents: "\ue582",
  terminal: "\uf120",
  text: "\uf893",
  "text-height": "\uf034",
  "text-size": "\uf894",
  "text-slash": "\uf87d",
  "text-width": "\uf035",
  "the-red-yeti": "\uf69d",
  themeco: "\uf5c6",
  themeisle: "\uf2b2",
  thermometer: "\uf491",
  theta: "\uf69e",
  "think-peaks": "\uf731",
  "thought-bubble": "\ue32e",
  "thumbs-down": "\uf165",
  "thumbs-up": "\uf164",
  thumbtack: "\uf08d",
  tick: "\ue32f",
  ticket: "\uf145",
  "ticket-airline": "\ue29a",
  "ticket-simple": "\uf3ff",
  "tickets-airline": "\ue29b",
  tiktok: "\ue07b",
  tilde: "\u007e",
  timeline: "\ue29c",
  "timeline-arrow": "\ue29d",
  timer: "\ue29e",
  tire: "\uf631",
  "tire-flat": "\uf632",
  "tire-pressure-warning": "\uf633",
  "tire-rugged": "\uf634",
  "toggle-off": "\uf204",
  "toggle-on": "\uf205",
  toilet: "\uf7d8",
  "toilet-paper": "\uf71e",
  "toilet-paper-blank": "\uf71f",
  "toilet-paper-blank-under": "\ue29f",
  "toilet-paper-slash": "\ue072",
  "toilet-paper-under": "\ue2a0",
  "toilet-paper-under-slash": "\ue2a1",
  "toilet-portable": "\ue583",
  "toilets-portable": "\ue584",
  tomato: "\ue330",
  tombstone: "\uf720",
  "tombstone-blank": "\uf721",
  toolbox: "\uf552",
  tooth: "\uf5c9",
  toothbrush: "\uf635",
  "torii-gate": "\uf6a1",
  tornado: "\uf76f",
  "tower-broadcast": "\uf519",
  "tower-cell": "\ue585",
  "tower-control": "\ue2a2",
  "tower-observation": "\ue586",
  tractor: "\uf722",
  "trade-federation": "\uf513",
  trademark: "\uf25c",
  "traffic-cone": "\uf636",
  "traffic-light": "\uf637",
  "traffic-light-go": "\uf638",
  "traffic-light-slow": "\uf639",
  "traffic-light-stop": "\uf63a",
  trailer: "\ue041",
  train: "\uf238",
  "train-subway": "\uf239",
  "train-subway-tunnel": "\ue2a3",
  "train-track": "\ue453",
  "train-tram": "\uf7da",
  "train-tunnel": "\ue454",
  "transformer-bolt": "\ue2a4",
  transgender: "\uf225",
  transporter: "\ue042",
  "transporter-1": "\ue043",
  "transporter-2": "\ue044",
  "transporter-3": "\ue045",
  "transporter-4": "\ue2a5",
  "transporter-5": "\ue2a6",
  "transporter-6": "\ue2a7",
  "transporter-7": "\ue2a8",
  "transporter-empty": "\ue046",
  trash: "\uf1f8",
  "trash-arrow-up": "\uf829",
  "trash-can": "\uf2ed",
  "trash-can-arrow-up": "\uf82a",
  "trash-can-check": "\ue2a9",
  "trash-can-clock": "\ue2aa",
  "trash-can-list": "\ue2ab",
  "trash-can-plus": "\ue2ac",
  "trash-can-slash": "\ue2ad",
  "trash-can-undo": "\uf896",
  "trash-can-xmark": "\ue2ae",
  "trash-check": "\ue2af",
  "trash-clock": "\ue2b0",
  "trash-list": "\ue2b1",
  "trash-plus": "\ue2b2",
  "trash-slash": "\ue2b3",
  "trash-undo": "\uf895",
  "trash-xmark": "\ue2b4",
  "treasure-chest": "\uf723",
  tree: "\uf1bb",
  "tree-christmas": "\uf7db",
  "tree-city": "\ue587",
  "tree-deciduous": "\uf400",
  "tree-decorated": "\uf7dc",
  "tree-large": "\uf7dd",
  "tree-palm": "\uf82b",
  trees: "\uf724",
  trello: "\uf181",
  triangle: "\uf2ec",
  "triangle-exclamation": "\uf071",
  "triangle-instrument": "\uf8e2",
  "triangle-person-digging": "\uf85d",
  trillium: "\ue588",
  trophy: "\uf091",
  "trophy-star": "\uf2eb",
  trowel: "\ue589",
  "trowel-bricks": "\ue58a",
  truck: "\uf0d1",
  "truck-arrow-right": "\ue58b",
  "truck-bolt": "\ue3d0",
  "truck-clock": "\uf48c",
  "truck-container": "\uf4dc",
  "truck-container-empty": "\ue2b5",
  "truck-droplet": "\ue58c",
  "truck-fast": "\uf48b",
  "truck-field": "\ue58d",
  "truck-field-un": "\ue58e",
  "truck-flatbed": "\ue2b6",
  "truck-front": "\ue2b7",
  "truck-medical": "\uf0f9",
  "truck-monster": "\uf63b",
  "truck-moving": "\uf4df",
  "truck-pickup": "\uf63c",
  "truck-plane": "\ue58f",
  "truck-plow": "\uf7de",
  "truck-ramp": "\uf4e0",
  "truck-ramp-box": "\uf4de",
  "truck-ramp-couch": "\uf4dd",
  "truck-tow": "\ue2b8",
  trumpet: "\uf8e3",
  tty: "\uf1e4",
  "tty-answer": "\ue2b9",
  "tugrik-sign": "\ue2ba",
  tumblr: "\uf173",
  "tumblr-square": "\uf174",
  turkey: "\uf725",
  "turkish-lira-sign": "\ue2bb",
  "turn-down": "\uf3be",
  "turn-down-left": "\ue331",
  "turn-down-right": "\ue455",
  "turn-up": "\uf3bf",
  turntable: "\uf8e4",
  turtle: "\uf726",
  tv: "\uf26c",
  "tv-music": "\uf8e6",
  "tv-retro": "\uf401",
  twitch: "\uf1e8",
  twitter: "\uf099",
  "twitter-square": "\uf081",
  typewriter: "\uf8e7",
  typo3: "\uf42b",
  u: "\u0055",
  uber: "\uf402",
  ubuntu: "\uf7df",
  ufo: "\ue047",
  "ufo-beam": "\ue048",
  uikit: "\uf403",
  umbraco: "\uf8e8",
  umbrella: "\uf0e9",
  "umbrella-beach": "\uf5ca",
  "umbrella-simple": "\ue2bc",
  uncharted: "\ue084",
  underline: "\uf0cd",
  unicorn: "\uf727",
  "uniform-martial-arts": "\ue3d1",
  union: "\uf6a2",
  uniregistry: "\uf404",
  unity: "\ue049",
  "universal-access": "\uf29a",
  unlock: "\uf09c",
  "unlock-keyhole": "\uf13e",
  unsplash: "\ue07c",
  untappd: "\uf405",
  up: "\uf357",
  "up-down": "\uf338",
  "up-down-left-right": "\uf0b2",
  "up-from-bracket": "\ue590",
  "up-from-dotted-line": "\ue456",
  "up-from-line": "\uf346",
  "up-left": "\ue2bd",
  "up-long": "\uf30c",
  "up-right": "\ue2be",
  "up-right-and-down-left-from-center": "\uf424",
  "up-right-from-square": "\uf35d",
  "up-to-dotted-line": "\ue457",
  "up-to-line": "\uf34d",
  upload: "\uf093",
  ups: "\uf7e0",
  usb: "\uf287",
  "usb-drive": "\uf8e9",
  user: "\uf007",
  "user-alien": "\ue04a",
  "user-astronaut": "\uf4fb",
  "user-bounty-hunter": "\ue2bf",
  "user-check": "\uf4fc",
  "user-chef": "\ue3d2",
  "user-clock": "\uf4fd",
  "user-cowboy": "\uf8ea",
  "user-crown": "\uf6a4",
  "user-doctor": "\uf0f0",
  "user-doctor-hair": "\ue458",
  "user-doctor-hair-long": "\ue459",
  "user-doctor-message": "\uf82e",
  "user-gear": "\uf4fe",
  "user-graduate": "\uf501",
  "user-group": "\uf500",
  "user-group-crown": "\uf6a5",
  "user-hair": "\ue45a",
  "user-hair-buns": "\ue3d3",
  "user-hair-long": "\ue45b",
  "user-hair-mullet": "\ue45c",
  "user-headset": "\uf82d",
  "user-helmet-safety": "\uf82c",
  "user-injured": "\uf728",
  "user-large": "\uf406",
  "user-large-slash": "\uf4fa",
  "user-lock": "\uf502",
  "user-minus": "\uf503",
  "user-music": "\uf8eb",
  "user-ninja": "\uf504",
  "user-nurse": "\uf82f",
  "user-nurse-hair": "\ue45d",
  "user-nurse-hair-long": "\ue45e",
  "user-pen": "\uf4ff",
  "user-pilot": "\ue2c0",
  "user-pilot-tie": "\ue2c1",
  "user-plus": "\uf234",
  "user-police": "\ue333",
  "user-police-tie": "\ue334",
  "user-robot": "\ue04b",
  "user-robot-xmarks": "\ue4a7",
  "user-secret": "\uf21b",
  "user-shakespeare": "\ue2c2",
  "user-shield": "\uf505",
  "user-slash": "\uf506",
  "user-tag": "\uf507",
  "user-tie": "\uf508",
  "user-tie-hair": "\ue45f",
  "user-tie-hair-long": "\ue460",
  "user-unlock": "\ue058",
  "user-visor": "\ue04c",
  "user-vneck": "\ue461",
  "user-vneck-hair": "\ue462",
  "user-vneck-hair-long": "\ue463",
  "user-xmark": "\uf235",
  users: "\uf0c0",
  "users-between-lines": "\ue591",
  "users-gear": "\uf509",
  "users-line": "\ue592",
  "users-medical": "\uf830",
  "users-rays": "\ue593",
  "users-rectangle": "\ue594",
  "users-slash": "\ue073",
  "users-viewfinder": "\ue595",
  usps: "\uf7e1",
  ussunnah: "\uf407",
  utensils: "\uf2e7",
  "utensils-slash": "\ue464",
  "utility-pole": "\ue2c3",
  "utility-pole-double": "\ue2c4",
  v: "\u0056",
  vaadin: "\uf408",
  vacuum: "\ue04d",
  "vacuum-robot": "\ue04e",
  "value-absolute": "\uf6a6",
  "van-shuttle": "\uf5b6",
  vault: "\ue2c5",
  "vector-circle": "\ue2c6",
  "vector-polygon": "\ue2c7",
  "vector-square": "\uf5cb",
  "vent-damper": "\ue465",
  venus: "\uf221",
  "venus-double": "\uf226",
  "venus-mars": "\uf228",
  vest: "\ue085",
  "vest-patches": "\ue086",
  viacoin: "\uf237",
  viadeo: "\uf2a9",
  "viadeo-square": "\uf2aa",
  vial: "\uf492",
  "vial-circle-check": "\ue596",
  "vial-virus": "\ue597",
  vials: "\uf493",
  viber: "\uf409",
  video: "\uf03d",
  "video-arrow-down-left": "\ue2c8",
  "video-arrow-up-right": "\ue2c9",
  "video-plus": "\uf4e1",
  "video-slash": "\uf4e2",
  vihara: "\uf6a7",
  vimeo: "\uf40a",
  "vimeo-square": "\uf194",
  "vimeo-v": "\uf27d",
  vine: "\uf1ca",
  violin: "\uf8ed",
  virus: "\ue074",
  "virus-covid": "\ue4a8",
  "virus-covid-slash": "\ue4a9",
  "virus-slash": "\ue075",
  viruses: "\ue076",
  vk: "\uf189",
  vnv: "\uf40b",
  voicemail: "\uf897",
  volcano: "\uf770",
  volleyball: "\uf45f",
  volume: "\uf6a8",
  "volume-high": "\uf028",
  "volume-low": "\uf027",
  "volume-off": "\uf026",
  "volume-slash": "\uf2e2",
  "volume-xmark": "\uf6a9",
  "vr-cardboard": "\uf729",
  vuejs: "\uf41f",
  w: "\u0057",
  waffle: "\ue466",
  "wagon-covered": "\uf8ee",
  walker: "\uf831",
  "walkie-talkie": "\uf8ef",
  wallet: "\uf555",
  wand: "\uf72a",
  "wand-magic": "\uf0d0",
  "wand-magic-sparkles": "\ue2ca",
  "wand-sparkles": "\uf72b",
  warehouse: "\uf494",
  "warehouse-full": "\uf495",
  "washing-machine": "\uf898",
  watch: "\uf2e1",
  "watch-apple": "\ue2cb",
  "watch-calculator": "\uf8f0",
  "watch-fitness": "\uf63e",
  "watch-smart": "\ue2cc",
  "watchman-monitoring": "\ue087",
  water: "\uf773",
  "water-arrow-down": "\uf774",
  "water-arrow-up": "\uf775",
  "water-ladder": "\uf5c5",
  "watermelon-slice": "\ue337",
  "wave-pulse": "\uf5f8",
  "wave-sine": "\uf899",
  "wave-square": "\uf83e",
  "wave-triangle": "\uf89a",
  waveform: "\uf8f1",
  "waveform-lines": "\uf8f2",
  waze: "\uf83f",
  weebly: "\uf5cc",
  weibo: "\uf18a",
  "weight-hanging": "\uf5cd",
  "weight-scale": "\uf496",
  weixin: "\uf1d7",
  whale: "\uf72c",
  whatsapp: "\uf232",
  "whatsapp-square": "\uf40c",
  wheat: "\uf72d",
  "wheat-awn": "\ue2cd",
  "wheat-awn-circle-exclamation": "\ue598",
  "wheat-awn-slash": "\ue338",
  "wheat-slash": "\ue339",
  wheelchair: "\uf193",
  "wheelchair-move": "\ue2ce",
  "whiskey-glass": "\uf7a0",
  "whiskey-glass-ice": "\uf7a1",
  whistle: "\uf460",
  whmcs: "\uf40d",
  wifi: "\uf1eb",
  "wifi-exclamation": "\ue2cf",
  "wifi-fair": "\uf6ab",
  "wifi-slash": "\uf6ac",
  "wifi-weak": "\uf6aa",
  "wikipedia-w": "\uf266",
  wind: "\uf72e",
  "wind-turbine": "\uf89b",
  "wind-warning": "\uf776",
  window: "\uf40e",
  "window-flip": "\uf40f",
  "window-frame": "\ue04f",
  "window-frame-open": "\ue050",
  "window-maximize": "\uf2d0",
  "window-minimize": "\uf2d1",
  "window-restore": "\uf2d2",
  windows: "\uf17a",
  windsock: "\uf777",
  "wine-bottle": "\uf72f",
  "wine-glass": "\uf4e3",
  "wine-glass-crack": "\uf4bb",
  "wine-glass-empty": "\uf5ce",
  wirsindhandwerk: "\ue2d0",
  wix: "\uf5cf",
  "wizards-of-the-coast": "\uf730",
  wodu: "\ue088",
  "wolf-pack-battalion": "\uf514",
  "won-sign": "\uf159",
  wordpress: "\uf19a",
  "wordpress-simple": "\uf411",
  worm: "\ue599",
  wpbeginner: "\uf297",
  wpexplorer: "\uf2de",
  wpforms: "\uf298",
  wpressr: "\uf3e4",
  wreath: "\uf7e2",
  wrench: "\uf0ad",
  "wrench-simple": "\ue2d1",
  x: "\u0058",
  "x-ray": "\uf497",
  xbox: "\uf412",
  xing: "\uf168",
  "xing-square": "\uf169",
  xmark: "\uf00d",
  "xmark-large": "\ue59b",
  "xmark-to-slot": "\uf771",
  "xmarks-lines": "\ue59a",
  y: "\u0059",
  "y-combinator": "\uf23b",
  yahoo: "\uf19e",
  yammer: "\uf840",
  yandex: "\uf413",
  "yandex-international": "\uf414",
  yarn: "\uf7e3",
  yelp: "\uf1e9",
  "yen-sign": "\uf157",
  "yin-yang": "\uf6ad",
  yoast: "\uf2b1",
  youtube: "\uf167",
  "youtube-square": "\uf431",
  z: "\u005a",
  zhihu: "\uf63f",
};
export type Icon =
  | { icon: "0"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "1"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "2"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "3"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "4"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "5"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "6"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "7"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "8"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "9"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "00"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "360-degrees";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "42-group"; type: "brands" }
  | { icon: "500px"; type: "brands" }
  | { icon: "a"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "abacus"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "accent-grave";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "accessible-icon"; type: "brands" }
  | { icon: "accusoft"; type: "brands" }
  | { icon: "acorn"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "address-book";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "address-card";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "adn"; type: "brands" }
  | { icon: "adversal"; type: "brands" }
  | { icon: "affiliatetheme"; type: "brands" }
  | {
      icon: "air-conditioner";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "airbnb"; type: "brands" }
  | {
      icon: "airplay";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "alarm-clock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "alarm-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "alarm-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "alarm-snooze";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "album"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "album-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "album-circle-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "album-collection";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "album-collection-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "album-collection-circle-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "algolia"; type: "brands" }
  | {
      icon: "alicorn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "alien"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "alien-8bit";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "align-center";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "align-justify";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "align-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "align-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "align-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "alipay"; type: "brands" }
  | { icon: "alt"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "amazon"; type: "brands" }
  | { icon: "amazon-pay"; type: "brands" }
  | { icon: "amilia"; type: "brands" }
  | {
      icon: "amp-guitar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ampersand";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "anchor"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "anchor-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "anchor-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "anchor-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "anchor-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "android"; type: "brands" }
  | { icon: "angel"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "angellist"; type: "brands" }
  | { icon: "angle"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "angle-90";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "angle-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "angle-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "angle-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "angle-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "angles-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "angles-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "angles-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "angles-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "angrycreative"; type: "brands" }
  | { icon: "angular"; type: "brands" }
  | { icon: "ankh"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "apartment";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "aperture";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "apostrophe";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "app-store"; type: "brands" }
  | { icon: "app-store-ios"; type: "brands" }
  | { icon: "apper"; type: "brands" }
  | { icon: "apple"; type: "brands" }
  | {
      icon: "apple-core";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "apple-pay"; type: "brands" }
  | {
      icon: "apple-whole";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "archway";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-1-9";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-9-1";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-a-z";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-big-small";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-from-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-left-and-arrow-up-right-to-center";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-short-wide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-small-big";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-square-triangle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-to-arc";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-to-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-to-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-to-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-triangle-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-up-across-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-up-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-wide-short";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-down-z-a";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-left-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-left-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-left-long-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-left-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-pointer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-arrow-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-from-arc";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-from-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-long-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-to-arc";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-to-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-to-city";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-right-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-rotate-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-rotate-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-trend-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-trend-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-turn-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-turn-down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-turn-down-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-turn-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-1-9";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-9-1";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-a-z";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-big-small";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-from-arc";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-from-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-from-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-from-ground-water";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-from-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-from-water-pump";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-left-from-circle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-right-and-arrow-down-left-from-center";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-right-dots";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-right-from-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-short-wide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-small-big";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-square-triangle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-to-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-triangle-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-wide-short";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrow-up-z-a";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-cross";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-down-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-down-to-people";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-from-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-left-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-left-right-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-maximize";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-minimize";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-repeat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-repeat-1";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-retweet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-rotate";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-spin";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-split-up-and-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-to-circle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-to-dot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-to-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-to-eye";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-turn-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-turn-to-dots";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-up-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-up-down-left-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "arrows-up-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "artstation"; type: "brands" }
  | {
      icon: "asterisk";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "asymmetrik"; type: "brands" }
  | { icon: "at"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "atlassian"; type: "brands" }
  | { icon: "atom"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "atom-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "audible"; type: "brands" }
  | {
      icon: "audio-description";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "audio-description-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "austral-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "autoprefixer"; type: "brands" }
  | { icon: "avianex"; type: "brands" }
  | { icon: "aviato"; type: "brands" }
  | {
      icon: "avocado";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "award"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "award-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "aws"; type: "brands" }
  | { icon: "axe"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "axe-battle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "b"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "baby"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "baby-carriage";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "backpack";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "backward";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "backward-fast";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "backward-step";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bacon"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bacteria";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bacterium";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "badge"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "badge-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "badge-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "badge-percent";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "badge-sheriff";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "badger-honey";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "badminton";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bag-shopping";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bagel"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bags-shopping";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "baguette";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bahai"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "baht-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ball-pile";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "balloon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "balloons";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ballot"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "ballot-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ban"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "ban-bug";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ban-parking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ban-smoking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "banana"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bandage";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bandcamp"; type: "brands" }
  | {
      icon: "bangladeshi-taka-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "banjo"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "barcode";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "barcode-read";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "barcode-scan";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bars"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bars-filter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bars-progress";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bars-sort";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bars-staggered";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "baseball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "baseball-bat-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "basket-shopping";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "basket-shopping-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "basketball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "basketball-hoop";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bat"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "bath"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "battery-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "battery-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "battery-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "battery-full";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "battery-half";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "battery-low";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "battery-quarter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "battery-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "battery-three-quarters";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "battle-net"; type: "brands" }
  | { icon: "bed"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bed-bunk";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bed-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bed-front";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bed-pulse";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bee"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "beer-mug";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "beer-mug-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "behance"; type: "brands" }
  | { icon: "behance-square"; type: "brands" }
  | { icon: "bell"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bell-concierge";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bell-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bell-on";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bell-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bell-school";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bell-school-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bell-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bells"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bench-tree";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bezier-curve";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bicycle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bilibili"; type: "brands" }
  | { icon: "bimobject"; type: "brands" }
  | { icon: "binary"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "binary-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "binary-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "binary-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "binoculars";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "biohazard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bird"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "bitbucket"; type: "brands" }
  | { icon: "bitcoin"; type: "brands" }
  | {
      icon: "bitcoin-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bity"; type: "brands" }
  | { icon: "black-tie"; type: "brands" }
  | { icon: "blackberry"; type: "brands" }
  | {
      icon: "blanket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "blanket-fire";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "blender";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "blender-phone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "blinds"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "blinds-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "blinds-raised";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "block"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "block-brick";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "block-brick-fire";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "block-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "block-quote";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "blog"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "blogger"; type: "brands" }
  | { icon: "blogger-b"; type: "brands" }
  | {
      icon: "blueberries";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bluetooth";
      type: "solid" | "regular" | "light" | "thin" | "duotone" | "brands";
    }
  | { icon: "bluetooth-b"; type: "brands" }
  | { icon: "bold"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "bolt"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bolt-auto";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bolt-lightning";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bolt-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bomb"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "bone"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bone-break";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bong"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "book"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "book-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-atlas";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-bible";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-bookmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-circle-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-circle-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-copy";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-font";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-journal-whills";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-open-cover";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-open-reader";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-quran";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-section";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-skull";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-sparkles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-tanakh";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "book-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bookmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bookmark-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "books"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "books-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "boombox";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "boot"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "boot-heeled";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "booth-curtain";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bootstrap"; type: "brands" }
  | {
      icon: "border-all";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-bottom";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-bottom-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-center-h";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-center-v";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-inner";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-none";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-outer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-top";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "border-top-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bore-hole";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bots"; type: "brands" }
  | {
      icon: "bottle-droplet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bottle-water";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bow-arrow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowl-chopsticks";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowl-chopsticks-noodles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowl-food";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowl-hot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowl-rice";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowl-scoop";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowl-scoops";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowl-soft-serve";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowl-spoon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowling-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowling-ball-pin";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bowling-pins";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "box"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "box-archive";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "box-ballot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "box-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "box-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "box-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "box-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "box-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "box-open-full";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "box-taped";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "box-tissue";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "boxes-packing";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "boxes-stacked";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "boxing-glove";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bracket-curly";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bracket-curly-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bracket-round";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bracket-round-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bracket-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bracket-square-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "brackets-curly";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "brackets-round";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "brackets-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "braille";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "brain"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "brain-arrow-curved-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "brain-circuit";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "brake-warning";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "brazilian-real-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bread-loaf";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bread-slice";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bread-slice-butter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bridge"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bridge-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bridge-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bridge-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bridge-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bridge-suspension";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bridge-water";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "briefcase";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "briefcase-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "briefcase-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "briefcase-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "brightness";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "brightness-low";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bring-forward";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bring-front";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "broccoli";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "broom"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "broom-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "browser";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "browsers";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "brush"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "btc"; type: "brands" }
  | { icon: "bucket"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "buffer"; type: "brands" }
  | { icon: "bug"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bug-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "bugs"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "building";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-circle-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-columns";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-flag";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-ngo";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-shield";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-un";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "building-wheat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "buildings";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bullhorn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bullseye";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bullseye-arrow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bullseye-pointer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "burger"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "burger-cheese";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "burger-fries";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "burger-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "burger-lettuce";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "burger-soda";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "buromobelexperte"; type: "brands" }
  | {
      icon: "burrito";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "burst"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "bus"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "bus-school";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "bus-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "business-time";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "butter"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "buy-n-large"; type: "brands" }
  | { icon: "buysellads"; type: "brands" }
  | { icon: "c"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "cabin"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cabinet-filing";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cable-car";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cactus"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cake-candles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cake-slice";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calculator";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calculator-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-circle-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-circle-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-clock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-day";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-days";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-image";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-lines-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-range";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-star";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-week";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendar-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "calendars";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camcorder";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "camera"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "camera-cctv";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camera-movie";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camera-polaroid";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camera-retro";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camera-rotate";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camera-security";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camera-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camera-viewfinder";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camera-web";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "camera-web-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "campfire";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "campground";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "can-food";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "canadian-maple-leaf"; type: "brands" }
  | {
      icon: "candle-holder";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "candy"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "candy-bar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "candy-cane";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "candy-corn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cannabis";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "capsules";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "car"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "car-battery";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-building";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-bump";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-burst";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-bus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-circle-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-garage";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-mirrors";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "car-on"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "car-rear";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-side";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-side-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-tilt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-tunnel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-wash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "car-wrench";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "caravan";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "caravan-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "card-club";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "card-diamond";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "card-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "card-spade";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cards"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cards-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "caret-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "caret-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "caret-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "caret-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "carrot"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "cars"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cart-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-circle-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-circle-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-flatbed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-flatbed-boxes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-flatbed-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-flatbed-suitcase";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-shopping";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-shopping-fast";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cart-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cash-register";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cassette-betamax";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cassette-tape";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cassette-vhs";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "castle"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "cat"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cat-space";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cauldron";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cc-amazon-pay"; type: "brands" }
  | { icon: "cc-amex"; type: "brands" }
  | { icon: "cc-apple-pay"; type: "brands" }
  | { icon: "cc-diners-club"; type: "brands" }
  | { icon: "cc-discover"; type: "brands" }
  | { icon: "cc-jcb"; type: "brands" }
  | { icon: "cc-mastercard"; type: "brands" }
  | { icon: "cc-paypal"; type: "brands" }
  | { icon: "cc-stripe"; type: "brands" }
  | { icon: "cc-visa"; type: "brands" }
  | {
      icon: "cedi-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cent-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "centercode"; type: "brands" }
  | { icon: "centos"; type: "brands" }
  | {
      icon: "certificate";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "chair"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "chair-office";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chalkboard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chalkboard-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "champagne-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "champagne-glasses";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "charging-station";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-area";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-bar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-bullet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-candlestick";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-column";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-gantt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-line-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-line-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-mixed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-network";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-pie";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-pie-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-pyramid";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-radar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-scatter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-scatter-3d";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-scatter-bubble";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-simple-horizontal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-tree-map";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chart-waterfall";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "check"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "check-double";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "check-to-slot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cheese"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cheese-swiss";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cherries";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "chess"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "chess-bishop";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-bishop-piece";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-board";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-clock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-clock-flip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-king";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-king-piece";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-knight";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-knight-piece";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-pawn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-pawn-piece";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-queen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-queen-piece";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-rook";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chess-rook-piece";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chestnut";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chevron-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chevron-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chevron-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chevron-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chevrons-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chevrons-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chevrons-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chevrons-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "child"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "child-dress";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "child-reaching";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "child-rifle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "children";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chimney";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "chopsticks";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "chrome"; type: "brands" }
  | { icon: "chromecast"; type: "brands" }
  | { icon: "church"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "circle"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "circle-0";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-1";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-2";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-3";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-4";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-5";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-6";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-7";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-8";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-9";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-a";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-ampersand";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-arrow-down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-arrow-down-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-arrow-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-arrow-up-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-arrow-up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-b";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-book-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-bookmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-c";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-calendar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-camera";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-caret-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-caret-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-caret-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-caret-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-chevron-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-chevron-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-chevron-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-chevron-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-d";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-dashed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-divide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-dollar-to-slot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-dot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-down-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-e";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-ellipsis";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-ellipsis-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-envelope";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-exclamation-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-f";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-g";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-h";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-half";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-half-stroke";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-i";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-info";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-j";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-k";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-l";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-location-arrow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-m";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-microphone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-microphone-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-n";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-nodes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-notch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-o";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-p";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-parking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-pause";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-phone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-phone-flip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-phone-hangup";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-play";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-q";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-quarter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-quarters";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-r";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-radiation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-s";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-small";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-sort";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-sort-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-sort-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-star";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-stop";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-t";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-three-quarters";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-trash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-u";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-up-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-v";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-video";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-w";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-waveform-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-x";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-y";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "circle-z";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "citrus"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "citrus-slice";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "city"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "clapperboard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clapperboard-play";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clarinet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "claw-marks";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clipboard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clipboard-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clipboard-list";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clipboard-list-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clipboard-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clipboard-prescription";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clipboard-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clipboard-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "clock"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "clock-desk";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-eight";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-eight-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-eleven";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-eleven-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-five";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-five-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-four-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-nine";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-nine-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-one";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-one-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-rotate-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-seven";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-seven-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-six";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-six-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-ten";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-ten-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-three";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-three-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-twelve";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-twelve-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-two";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clock-two-thirty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "clone"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "closed-captioning";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "closed-captioning-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clothes-hanger";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cloud"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cloud-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-bolt-moon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-bolt-sun";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-drizzle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-fog";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-hail";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-hail-mixed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-meatball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-moon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-moon-rain";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-music";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-rain";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-rainbow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-showers";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-showers-heavy";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-showers-water";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-sleet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-snow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-sun";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-sun-rain";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-word";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cloud-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cloudflare"; type: "brands" }
  | { icon: "clouds"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "clouds-moon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "clouds-sun";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cloudscale"; type: "brands" }
  | { icon: "cloudsmith"; type: "brands" }
  | { icon: "cloudversify"; type: "brands" }
  | { icon: "clover"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "club"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "cmplid"; type: "brands" }
  | {
      icon: "coconut";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "code"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "code-branch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "code-commit";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "code-compare";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "code-fork";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "code-merge";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "code-pull-request";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "code-pull-request-closed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "code-pull-request-draft";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "code-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "codepen"; type: "brands" }
  | { icon: "codiepie"; type: "brands" }
  | {
      icon: "coffee-bean";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "coffee-beans";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "coffee-pot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "coffin"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "coffin-cross";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "coin"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "coin-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "coin-front";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "coin-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "coins"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "colon"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "colon-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "columns-3";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "comet"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "comma"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "command";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-arrow-up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-captions";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-code";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-dots";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-image";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-middle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-middle-top";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-music";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-quote";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-smile";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-sms";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-text";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comment-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comments";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comments-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comments-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "comments-question-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "compact-disc";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "compass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "compass-drafting";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "compass-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "compress";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "compress-wide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "computer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "computer-classic";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "computer-mouse";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "computer-mouse-scrollwheel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "computer-speaker";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "confluence"; type: "brands" }
  | { icon: "connectdevelop"; type: "brands" }
  | {
      icon: "container-storage";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "contao"; type: "brands" }
  | {
      icon: "conveyor-belt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "conveyor-belt-boxes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "conveyor-belt-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cookie"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cookie-bite";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "copy"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "copyright";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "corn"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "corner"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "cotton-bureau"; type: "brands" }
  | { icon: "couch"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "cow"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cowbell";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cowbell-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cpanel"; type: "brands" }
  | { icon: "crab"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "crate-apple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "crate-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "creative-commons"; type: "brands" }
  | { icon: "creative-commons-by"; type: "brands" }
  | { icon: "creative-commons-nc"; type: "brands" }
  | { icon: "creative-commons-nc-eu"; type: "brands" }
  | { icon: "creative-commons-nc-jp"; type: "brands" }
  | { icon: "creative-commons-nd"; type: "brands" }
  | { icon: "creative-commons-pd"; type: "brands" }
  | { icon: "creative-commons-pd-alt"; type: "brands" }
  | { icon: "creative-commons-remix"; type: "brands" }
  | { icon: "creative-commons-sa"; type: "brands" }
  | { icon: "creative-commons-sampling"; type: "brands" }
  | { icon: "creative-commons-sampling-plus"; type: "brands" }
  | { icon: "creative-commons-share"; type: "brands" }
  | { icon: "creative-commons-zero"; type: "brands" }
  | {
      icon: "credit-card";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "credit-card-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "credit-card-front";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cricket-bat-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "critical-role"; type: "brands" }
  | {
      icon: "croissant";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "crop"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "crop-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cross"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "crosshairs";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "crow"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "crown"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "crutch"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "crutches";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cruzeiro-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "crystal-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "css3"; type: "brands" }
  | { icon: "css3-alt"; type: "brands" }
  | { icon: "cube"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "cubes"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "cubes-stacked";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cucumber";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cup-straw";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cup-straw-swoosh";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cup-togo";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "cupcake";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "curling-stone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "custard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "cuttlefish"; type: "brands" }
  | { icon: "d"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "d-and-d"; type: "brands" }
  | { icon: "d-and-d-beyond"; type: "brands" }
  | { icon: "dagger"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "dailymotion"; type: "brands" }
  | { icon: "dash"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "dashcube"; type: "brands" }
  | {
      icon: "database";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "deer"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "deer-rudolph";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "deezer"; type: "brands" }
  | {
      icon: "delete-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "delete-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "delicious"; type: "brands" }
  | {
      icon: "democrat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "deploydog"; type: "brands" }
  | { icon: "deskpro"; type: "brands" }
  | {
      icon: "desktop";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "desktop-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "dev"; type: "brands" }
  | { icon: "deviantart"; type: "brands" }
  | {
      icon: "dharmachakra";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "dhl"; type: "brands" }
  | {
      icon: "diagram-cells";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-lean-canvas";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-nested";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-next";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-predecessor";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-previous";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-project";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-sankey";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-subtask";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-successor";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diagram-venn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "dial"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "dial-high";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dial-low";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dial-max";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dial-med";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dial-med-low";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dial-min";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dial-off";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diamond";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diamond-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "diamond-turn-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "diaspora"; type: "brands" }
  | { icon: "dice"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "dice-d10";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-d12";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-d20";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-d4";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-d6";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-d8";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-five";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-four";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-one";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-six";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-three";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dice-two";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "digg"; type: "brands" }
  | { icon: "digital-ocean"; type: "brands" }
  | {
      icon: "diploma";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "disc-drive";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "discord"; type: "brands" }
  | { icon: "discourse"; type: "brands" }
  | {
      icon: "disease";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "display";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "display-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "display-code";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "display-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "display-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "distribute-spacing-horizontal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "distribute-spacing-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ditto"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "divide"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "dna"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "do-not-enter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "dochub"; type: "brands" }
  | { icon: "docker"; type: "brands" }
  | { icon: "dog"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "dog-leashed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dollar-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "dolly"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "dolly-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dolphin";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dong-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "donut"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "door-closed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "door-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "dove"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "down"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "down-from-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "down-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "down-left-and-up-right-to-center";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "down-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "down-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "down-to-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "down-to-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "down-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "download";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "draft2digital"; type: "brands" }
  | { icon: "dragon"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "draw-circle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "draw-polygon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "draw-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dreidel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "dribbble"; type: "brands" }
  | { icon: "dribbble-square"; type: "brands" }
  | { icon: "drone"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "drone-front";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "dropbox"; type: "brands" }
  | {
      icon: "droplet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "droplet-degree";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "droplet-percent";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "droplet-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "drum"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "drum-steelpan";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "drumstick";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "drumstick-bite";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "drupal"; type: "brands" }
  | { icon: "dryer"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "dryer-heat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "duck"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "dumbbell";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dumpster";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dumpster-fire";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "dungeon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "dyalog"; type: "brands" }
  | { icon: "e"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "ear"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "ear-deaf";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ear-listen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ear-muffs";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "earlybirds"; type: "brands" }
  | {
      icon: "earth-africa";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "earth-americas";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "earth-asia";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "earth-europe";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "earth-oceania";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ebay"; type: "brands" }
  | {
      icon: "eclipse";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "edge"; type: "brands" }
  | { icon: "edge-legacy"; type: "brands" }
  | { icon: "egg"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "egg-fried";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "eggplant";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "eject"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "elementor"; type: "brands" }
  | {
      icon: "elephant";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "elevator";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ellipsis";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ellipsis-stroke";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ellipsis-stroke-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ellipsis-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ello"; type: "brands" }
  | { icon: "ember"; type: "brands" }
  | { icon: "empire"; type: "brands" }
  | {
      icon: "empty-set";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "engine"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "engine-warning";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "envelope";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "envelope-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "envelope-dot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "envelope-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "envelope-open-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "envelope-open-text";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "envelopes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "envelopes-bulk";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "envira"; type: "brands" }
  | { icon: "equals"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "eraser"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "erlang"; type: "brands" }
  | {
      icon: "escalator";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ethereum"; type: "brands" }
  | {
      icon: "ethernet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "etsy"; type: "brands" }
  | {
      icon: "euro-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "evernote"; type: "brands" }
  | {
      icon: "exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "expand"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "expand-wide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "expeditedssl"; type: "brands" }
  | {
      icon: "explosion";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "eye"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "eye-dropper";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "eye-dropper-full";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "eye-dropper-half";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "eye-evil";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "eye-low-vision";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "eye-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "eyes"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "f"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "face-angry";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-angry-horns";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-anguished";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-anxious-sweat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-astonished";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-awesome";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-beam-hand-over-mouth";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-clouds";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-confounded";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-confused";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-cowboy-hat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-diagonal-mouth";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-disappointed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-disguise";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-dizzy";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-dotted";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-downcast-sweat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-drooling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-exhaling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-explode";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-expressionless";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-eyes-xmarks";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-fearful";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-flushed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-frown";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-frown-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-frown-slight";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-glasses";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grimace";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-beam";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-beam-sweat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-hearts";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-squint";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-squint-tears";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-stars";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-tears";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-tongue";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-tongue-squint";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-tongue-wink";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-wide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-grin-wink";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-hand-over-mouth";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-hand-peeking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-hand-yawn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-head-bandage";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-holding-back-tears";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-hushed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-icicles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-kiss";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-kiss-beam";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-kiss-closed-eyes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-kiss-wink-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-laugh";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-laugh-beam";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-laugh-squint";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-laugh-wink";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-lying";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-mask";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-meh";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-meh-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-melting";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-monocle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-nauseated";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-nose-steam";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-party";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-pensive";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-persevering";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-pleading";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-pouting";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-raised-eyebrow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-relieved";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-rolling-eyes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-sad-cry";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-sad-sweat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-sad-tear";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-saluting";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-scream";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-shush";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-sleeping";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-sleepy";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-beam";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-halo";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-hearts";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-horns";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-relaxed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-tear";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-tongue";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-upside-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smile-wink";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smiling-hands";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-smirking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-spiral-eyes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-sunglasses";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-surprise";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-swear";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-thermometer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-thinking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-tired";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-tissue";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-tongue-money";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-tongue-sweat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-unamused";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-viewfinder";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-vomit";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-weary";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-woozy";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-worried";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-zany";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "face-zipper";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "facebook"; type: "brands" }
  | { icon: "facebook-f"; type: "brands" }
  | { icon: "facebook-messenger"; type: "brands" }
  | { icon: "facebook-square"; type: "brands" }
  | {
      icon: "falafel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "family"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "family-dress";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "family-pants";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fan"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "fan-table";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fantasy-flight-games"; type: "brands" }
  | { icon: "farm"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "faucet"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "faucet-drip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fax"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "feather";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "feather-pointed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fedex"; type: "brands" }
  | { icon: "fedora"; type: "brands" }
  | { icon: "fence"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "ferris-wheel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ferry"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "field-hockey-stick-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "figma"; type: "brands" }
  | { icon: "file"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "file-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-audio";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-binary";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-certificate";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-chart-column";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-chart-pie";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-circle-info";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-circle-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-circle-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-code";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-contract";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-csv";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-dashed-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-excel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-export";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-image";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-import";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-invoice";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-invoice-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-magnifying-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-music";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-pdf";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-plus-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-powerpoint";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-prescription";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-shield";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-signature";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-spreadsheet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-video";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-waveform";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-word";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "file-zipper";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "files"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "files-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fill"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "fill-drip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "film"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "film-canister";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "film-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "film-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "films"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "filter"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "filter-circle-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "filter-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "filter-list";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "filter-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "filters";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fingerprint";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fire"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "fire-burner";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fire-extinguisher";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fire-flame";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fire-flame-curved";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fire-flame-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fire-hydrant";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fire-smoke";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "firefox"; type: "brands" }
  | { icon: "firefox-browser"; type: "brands" }
  | {
      icon: "fireplace";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "first-order"; type: "brands" }
  | { icon: "first-order-alt"; type: "brands" }
  | { icon: "firstdraft"; type: "brands" }
  | { icon: "fish"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "fish-bones";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fish-cooked";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fish-fins";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fishing-rod";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "flag"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "flag-checkered";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "flag-pennant";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "flag-swallowtail";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "flag-usa";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "flashlight";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "flask"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "flask-round-poison";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "flask-round-potion";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "flask-vial";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "flatbread";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "flatbread-stuffed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "flickr"; type: "brands" }
  | { icon: "flipboard"; type: "brands" }
  | {
      icon: "floppy-disk";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "floppy-disk-circle-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "floppy-disk-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "floppy-disk-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "floppy-disks";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "florin-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "flower"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "flower-daffodil";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "flower-tulip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "flute"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "flux-capacitor";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fly"; type: "brands" }
  | {
      icon: "flying-disc";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "folder"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "folder-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-bookmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-closed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-gear";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-grid";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-image";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-magnifying-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-music";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-tree";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folder-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "folders";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "fondue-pot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "font"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "font-awesome";
      type: "solid" | "regular" | "light" | "thin" | "duotone" | "brands";
    }
  | {
      icon: "font-case";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fonticons"; type: "brands" }
  | { icon: "fonticons-fi"; type: "brands" }
  | {
      icon: "football";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "football-helmet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fork"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "fork-knife";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "forklift";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "fort"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "fort-awesome"; type: "brands" }
  | { icon: "fort-awesome-alt"; type: "brands" }
  | { icon: "forumbee"; type: "brands" }
  | {
      icon: "forward";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "forward-fast";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "forward-step";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "foursquare"; type: "brands" }
  | { icon: "frame"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "franc-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "free-code-camp"; type: "brands" }
  | { icon: "freebsd"; type: "brands" }
  | {
      icon: "french-fries";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "frog"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "fulcrum"; type: "brands" }
  | {
      icon: "function";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "futbol"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "g"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "galactic-republic"; type: "brands" }
  | { icon: "galactic-senate"; type: "brands" }
  | { icon: "galaxy"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "gallery-thumbnails";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "game-board";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "game-board-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "game-console-handheld";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gamepad";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gamepad-modern";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "garage"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "garage-car";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "garage-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "garlic"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "gas-pump";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gas-pump-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "gauge"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "gauge-circle-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-circle-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-high";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-low";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-max";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-min";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-simple-high";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-simple-low";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-simple-max";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gauge-simple-min";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "gavel"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "gear"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "gears"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "gem"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "genderless";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "get-pocket"; type: "brands" }
  | { icon: "gg"; type: "brands" }
  | { icon: "gg-circle"; type: "brands" }
  | { icon: "ghost"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "gif"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "gift"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "gift-card";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "gifts"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "gingerbread-man";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "git"; type: "brands" }
  | { icon: "git-alt"; type: "brands" }
  | { icon: "git-square"; type: "brands" }
  | { icon: "github"; type: "brands" }
  | { icon: "github-alt"; type: "brands" }
  | { icon: "github-square"; type: "brands" }
  | { icon: "gitkraken"; type: "brands" }
  | { icon: "gitlab"; type: "brands" }
  | { icon: "gitter"; type: "brands" }
  | { icon: "glass"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "glass-citrus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "glass-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "glass-half";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "glass-water";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "glass-water-droplet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "glasses";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "glasses-round";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "glide"; type: "brands" }
  | { icon: "glide-g"; type: "brands" }
  | { icon: "globe"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "globe-snow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "globe-stand";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "goal-net";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "gofore"; type: "brands" }
  | { icon: "golang"; type: "brands" }
  | {
      icon: "golf-ball-tee";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "golf-club";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "golf-flag-hole";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "goodreads"; type: "brands" }
  | { icon: "goodreads-g"; type: "brands" }
  | { icon: "google"; type: "brands" }
  | { icon: "google-drive"; type: "brands" }
  | { icon: "google-pay"; type: "brands" }
  | { icon: "google-play"; type: "brands" }
  | { icon: "google-plus"; type: "brands" }
  | { icon: "google-plus-g"; type: "brands" }
  | { icon: "google-plus-square"; type: "brands" }
  | { icon: "google-wallet"; type: "brands" }
  | {
      icon: "gopuram";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "graduation-cap";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gramophone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "grapes"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "grate"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "grate-droplet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "gratipay"; type: "brands" }
  | { icon: "grav"; type: "brands" }
  | {
      icon: "greater-than";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "greater-than-equal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "grid"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "grid-2"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "grid-2-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "grid-4"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "grid-5"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "grid-dividers";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "grid-horizontal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "grip"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "grip-dots";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "grip-dots-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "grip-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "grip-lines-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "grip-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "gripfire"; type: "brands" }
  | {
      icon: "group-arrows-rotate";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "grunt"; type: "brands" }
  | {
      icon: "guarani-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "guilded"; type: "brands" }
  | { icon: "guitar"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "guitar-electric";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "guitars";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "gulp"; type: "brands" }
  | { icon: "gun"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "gun-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "gun-squirt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "h"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "h1"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "h2"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "h3"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "h4"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "h5"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "h6"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "hacker-news"; type: "brands" }
  | { icon: "hacker-news-square"; type: "brands" }
  | { icon: "hackerrank"; type: "brands" }
  | { icon: "hammer"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "hammer-crash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hammer-war";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "hamsa"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "hand"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "hand-back-fist";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-back-point-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-back-point-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-back-point-ribbon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-back-point-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-back-point-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-dots";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-fingers-crossed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-fist";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding-box";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding-droplet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding-hand";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding-magic";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding-seedling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-holding-skull";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-horns";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-lizard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-love";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-middle-finger";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-peace";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-point-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-point-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-point-ribbon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-point-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-point-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-pointer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-scissors";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-sparkles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-spock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hand-wave";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "handcuffs";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "hands"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "hands-asl-interpreting";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-bound";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-bubbles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-clapping";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-holding";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-holding-child";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-holding-circle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-holding-diamond";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-holding-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-holding-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hands-praying";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "handshake";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "handshake-angle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "handshake-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "handshake-simple-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "handshake-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hanukiah";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hard-drive";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "hashnode"; type: "brands" }
  | {
      icon: "hashtag";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hashtag-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hat-chef";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hat-cowboy";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hat-cowboy-side";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hat-santa";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hat-winter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hat-witch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hat-wizard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side-brain";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side-cough";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side-cough-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side-goggles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side-headphones";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side-mask";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "head-side-virus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heading";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "headphones";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "headphones-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "headset";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "heart"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "heart-circle-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heart-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heart-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heart-circle-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heart-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heart-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heart-crack";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heart-half";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heart-half-stroke";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "heart-pulse";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "heat"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "helicopter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "helicopter-symbol";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "helmet-battle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "helmet-safety";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "helmet-un";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon-divide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon-image";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon-vertical-nft";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon-vertical-nft-slanted";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hexagon-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "high-definition";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "highlighter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "highlighter-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hill-avalanche";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hill-rockslide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "hippo"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "hips"; type: "brands" }
  | { icon: "hire-a-helper"; type: "brands" }
  | { icon: "hive"; type: "brands" }
  | {
      icon: "hockey-mask";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hockey-puck";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hockey-stick-puck";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hockey-sticks";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "holly-berry";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "honey-pot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hood-cloak";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "hooli"; type: "brands" }
  | {
      icon: "horizontal-rule";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "hornbill"; type: "brands" }
  | { icon: "horse"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "horse-head";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "horse-saddle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "hose"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "hose-reel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hospital";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hospital-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hospitals";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hot-tub-person";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "hotdog"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "hotel"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "hotjar"; type: "brands" }
  | {
      icon: "hourglass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hourglass-clock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hourglass-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hourglass-end";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hourglass-start";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "house"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "house-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-building";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-chimney";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-chimney-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-chimney-crack";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-chimney-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-chimney-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-chimney-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-chimney-window";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-crack";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-day";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-fire";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-flag";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-flood-water";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-flood-water-circle-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-laptop";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-medical-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-medical-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-medical-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-medical-flag";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-night";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-person-leave";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-person-return";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-signal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-tree";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-tsunami";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-turret";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-water";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "house-window";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "houzz"; type: "brands" }
  | {
      icon: "hryvnia-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "html5"; type: "brands" }
  | { icon: "hubspot"; type: "brands" }
  | {
      icon: "hundred-points";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "hurricane";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "hyphen"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "i"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "i-cursor";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ice-cream";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ice-skate";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "icicles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "icons"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "id-badge";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "id-card";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "id-card-clip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ideal"; type: "brands" }
  | { icon: "igloo"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "image"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "image-landscape";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "image-polaroid";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "image-polaroid-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "image-portrait";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "image-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "image-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "images"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "images-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "imdb"; type: "brands" }
  | { icon: "inbox"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "inbox-full";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "inbox-in";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "inbox-out";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "inboxes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "indent"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "indian-rupee-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "industry";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "industry-windows";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "infinity";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "info"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "inhaler";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "input-numeric";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "input-pipe";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "input-text";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "instagram"; type: "brands" }
  | { icon: "instagram-square"; type: "brands" }
  | { icon: "instalod"; type: "brands" }
  | {
      icon: "integral";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "intercom"; type: "brands" }
  | { icon: "internet-explorer"; type: "brands" }
  | {
      icon: "intersection";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "invision"; type: "brands" }
  | { icon: "ioxhost"; type: "brands" }
  | {
      icon: "island-tropical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "italic"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "itch-io"; type: "brands" }
  | { icon: "itunes"; type: "brands" }
  | { icon: "itunes-note"; type: "brands" }
  | { icon: "j"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "jack-o-lantern";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "jar"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "jar-wheat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "java"; type: "brands" }
  | { icon: "jedi"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "jedi-order"; type: "brands" }
  | { icon: "jenkins"; type: "brands" }
  | {
      icon: "jet-fighter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "jet-fighter-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "jira"; type: "brands" }
  | { icon: "joget"; type: "brands" }
  | { icon: "joint"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "joomla"; type: "brands" }
  | {
      icon: "joystick";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "js"; type: "brands" }
  | { icon: "js-square"; type: "brands" }
  | { icon: "jsfiddle"; type: "brands" }
  | { icon: "jug"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "jug-detergent";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "k"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "kaaba"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "kaggle"; type: "brands" }
  | { icon: "kazoo"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "kerning";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "key"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "key-skeleton";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "key-skeleton-left-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "keybase"; type: "brands" }
  | {
      icon: "keyboard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "keyboard-brightness";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "keyboard-brightness-low";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "keyboard-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "keyboard-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "keycdn"; type: "brands" }
  | {
      icon: "keynote";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "khanda"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "kickstarter"; type: "brands" }
  | { icon: "kickstarter-k"; type: "brands" }
  | {
      icon: "kidneys";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "kip-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "kit-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "kitchen-set";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "kite"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "kiwi-bird";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "kiwi-fruit";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "knife"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "knife-kitchen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "korvue"; type: "brands" }
  | { icon: "l"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "lacrosse-stick";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lacrosse-stick-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "lambda"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "lamp"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "lamp-desk";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lamp-floor";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lamp-street";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "land-mine-on";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "landmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "landmark-dome";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "landmark-flag";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "language";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "laptop"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "laptop-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "laptop-code";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "laptop-file";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "laptop-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "laptop-mobile";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "laptop-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "laravel"; type: "brands" }
  | {
      icon: "lari-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "lasso"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "lasso-sparkles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "lastfm"; type: "brands" }
  | { icon: "lastfm-square"; type: "brands" }
  | {
      icon: "layer-group";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "layer-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "layer-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "leaf"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "leaf-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "leaf-maple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "leaf-oak";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "leafy-green";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "leanpub"; type: "brands" }
  | { icon: "left"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "left-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "left-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "left-long-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "left-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "left-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "lemon"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "less"; type: "brands" }
  | {
      icon: "less-than";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "less-than-equal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "life-ring";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "light-ceiling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "light-emergency";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "light-emergency-on";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "light-switch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "light-switch-off";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "light-switch-on";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lightbulb";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lightbulb-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lightbulb-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lightbulb-exclamation-on";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lightbulb-on";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lightbulb-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lights-holiday";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "line"; type: "brands" }
  | {
      icon: "line-columns";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "line-height";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lines-leaning";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "link"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "link-horizontal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "link-horizontal-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "link-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "link-simple-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "link-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "linkedin"; type: "brands" }
  | { icon: "linkedin-in"; type: "brands" }
  | { icon: "linode"; type: "brands" }
  | { icon: "linux"; type: "brands" }
  | { icon: "lips"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "lira-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "list"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "list-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "list-dropdown";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "list-music";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "list-ol";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "list-radio";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "list-timeline";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "list-tree";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "list-ul";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "litecoin-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "loader"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "lobster";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-arrow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-crosshairs";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-crosshairs-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-dot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-dot-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-pin";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-pin-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-pin-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-smile";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "location-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "lock"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "lock-a"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "lock-hashtag";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lock-keyhole";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lock-keyhole-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "lock-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "locust"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "lollipop";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "loveseat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "luchador-mask";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "lungs"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "lungs-virus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "lyft"; type: "brands" }
  | { icon: "m"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "mace"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "magento"; type: "brands" }
  | { icon: "magnet"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "magnifying-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "magnifying-glass-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "magnifying-glass-chart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "magnifying-glass-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "magnifying-glass-location";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "magnifying-glass-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "magnifying-glass-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mailbox";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mailchimp"; type: "brands" }
  | {
      icon: "manat-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mandalorian"; type: "brands" }
  | {
      icon: "mandolin";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mango"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "manhole";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "map"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "map-location";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "map-location-dot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "map-pin";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "markdown"; type: "brands" }
  | { icon: "marker"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "mars"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "mars-and-venus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mars-and-venus-burst";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mars-double";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mars-stroke";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mars-stroke-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mars-stroke-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "martini-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "martini-glass-citrus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "martini-glass-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mask"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "mask-face";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mask-snorkel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mask-ventilator";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "masks-theater";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mastodon"; type: "brands" }
  | {
      icon: "mattress-pillow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "maxcdn"; type: "brands" }
  | {
      icon: "maximize";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mdb"; type: "brands" }
  | { icon: "meat"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "medal"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "medapps"; type: "brands" }
  | { icon: "medium"; type: "brands" }
  | { icon: "medrt"; type: "brands" }
  | { icon: "meetup"; type: "brands" }
  | {
      icon: "megaphone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "megaport"; type: "brands" }
  | { icon: "melon"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "melon-slice";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "memo"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "memo-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "memo-circle-info";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "memo-pad";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "memory"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "mendeley"; type: "brands" }
  | {
      icon: "menorah";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mercury";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "merge"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "message";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-arrow-up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-bot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-captions";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-code";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-dots";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-image";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-middle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-middle-top";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-music";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-quote";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-smile";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-sms";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-text";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "message-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "messages";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "messages-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "messages-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "meta"; type: "brands" }
  | { icon: "meteor"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "meter"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "meter-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "meter-droplet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "meter-fire";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "microblog"; type: "brands" }
  | {
      icon: "microchip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "microchip-ai";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "microphone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "microphone-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "microphone-lines-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "microphone-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "microphone-stand";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "microscope";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "microsoft"; type: "brands" }
  | {
      icon: "microwave";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mill-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "minimize";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "minus"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "mistletoe";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mitten"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "mix"; type: "brands" }
  | { icon: "mixcloud"; type: "brands" }
  | { icon: "mixer"; type: "brands" }
  | { icon: "mizuni"; type: "brands" }
  | { icon: "mobile"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "mobile-button";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mobile-notch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mobile-retro";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mobile-screen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mobile-screen-button";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mobile-signal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mobile-signal-out";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "modx"; type: "brands" }
  | { icon: "monero"; type: "brands" }
  | {
      icon: "money-bill";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bill-1";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bill-1-wave";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bill-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bill-simple-wave";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bill-transfer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bill-trend-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bill-wave";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bill-wheat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bills";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-bills-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-check-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-check-dollar-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-check-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-from-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "money-simple-from-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "monitor-waveform";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "monkey"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "monument";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "moon"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "moon-cloud";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "moon-over-sun";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "moon-stars";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "moped"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "mortar-pestle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mosque"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "mosquito";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mosquito-net";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "motorcycle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mound"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "mountain";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mountain-city";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mountain-sun";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mountains";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mp3-player";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "mug"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "mug-hot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mug-marshmallows";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mug-saucer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mug-tea";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mug-tea-saucer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "mushroom";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "music"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "music-note";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "music-note-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "music-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "n"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "naira-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "napster"; type: "brands" }
  | {
      icon: "narwhal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "neos"; type: "brands" }
  | {
      icon: "nesting-dolls";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "network-wired";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "neuter"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "newspaper";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "nfc"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "nfc-directional"; type: "brands" }
  | {
      icon: "nfc-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "nfc-magnifying-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "nfc-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "nfc-signal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "nfc-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "nfc-symbol";
      type: "solid" | "regular" | "light" | "thin" | "duotone" | "brands";
    }
  | {
      icon: "nfc-trash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "nimblr"; type: "brands" }
  | { icon: "node"; type: "brands" }
  | { icon: "node-js"; type: "brands" }
  | {
      icon: "not-equal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "notdef"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "note"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "note-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "note-sticky";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "notebook";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "notes"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "notes-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "npm"; type: "brands" }
  | { icon: "ns8"; type: "brands" }
  | { icon: "nutritionix"; type: "brands" }
  | { icon: "o"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "object-exclude";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "object-group";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "object-intersect";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "object-subtract";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "object-ungroup";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "object-union";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "objects-align-bottom";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "objects-align-center-horizontal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "objects-align-center-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "objects-align-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "objects-align-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "objects-align-top";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "objects-column";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "octagon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "octagon-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "octagon-divide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "octagon-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "octagon-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "octagon-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "octagon-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "octopus-deploy"; type: "brands" }
  | { icon: "odnoklassniki"; type: "brands" }
  | { icon: "odnoklassniki-square"; type: "brands" }
  | {
      icon: "oil-can";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "oil-can-drip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "oil-temperature";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "oil-well";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "old-republic"; type: "brands" }
  | { icon: "olive"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "olive-branch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "om"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "omega"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "onion"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "opencart"; type: "brands" }
  | { icon: "openid"; type: "brands" }
  | { icon: "opera"; type: "brands" }
  | { icon: "optin-monster"; type: "brands" }
  | { icon: "option"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "orcid"; type: "brands" }
  | {
      icon: "ornament";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "osi"; type: "brands" }
  | { icon: "otter"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "outdent";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "outlet"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "oven"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "overline";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "p"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "padlet"; type: "brands" }
  | { icon: "page"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "page-caret-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "page-caret-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "page4"; type: "brands" }
  | { icon: "pagelines"; type: "brands" }
  | { icon: "pager"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "paint-roller";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paintbrush";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paintbrush-fine";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paintbrush-pencil";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "palette";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "palfed"; type: "brands" }
  | { icon: "pallet"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "pallet-box";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pallet-boxes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pan-food";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pan-frying";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pancakes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "panel-ews";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "panel-fire";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "panorama";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paper-plane";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paper-plane-top";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paperclip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paperclip-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "parachute-box";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paragraph";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paragraph-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "party-bell";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "party-horn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "passport";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "paste"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "patreon"; type: "brands" }
  | { icon: "pause"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "paw"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "paw-claws";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "paw-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "paypal"; type: "brands" }
  | { icon: "peace"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "peach"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "peanut"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "peanuts";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "peapod"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "pear"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "pedestal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pegasus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "pen"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "pen-circle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-clip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-clip-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-fancy";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-fancy-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-field";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-nib";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-nib-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-paintbrush";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-ruler";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-swirl";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pen-to-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "pencil"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "pencil-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "people"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "people-arrows-left-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-carry-box";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-dress";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-dress-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-group";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-pants";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-pants-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-pulling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-robbery";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-roof";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "people-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "pepper"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "pepper-hot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "perbyte"; type: "brands" }
  | {
      icon: "percent";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "period"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "periscope"; type: "brands" }
  | { icon: "person"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "person-arrow-down-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-arrow-up-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-biking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-biking-mountain";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-booth";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-breastfeeding";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-burst";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-cane";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-carry-box";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-chalkboard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-circle-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-circle-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-digging";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-dolly";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-dolly-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-dots-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-dress";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-dress-burst";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-dress-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-drowning";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-falling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-falling-burst";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-from-portal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-half-dress";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-harassing";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-hiking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-military-pointing";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-military-rifle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-military-to-person";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-pinball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-praying";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-pregnant";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-rays";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-rifle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-running";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-seat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-seat-reclined";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-shelter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-skating";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-ski-jumping";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-ski-lift";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-skiing";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-skiing-nordic";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-sledding";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-snowboarding";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-snowmobiling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-swimming";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-through-window";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-to-door";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-to-portal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-walking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-walking-arrow-loop-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-walking-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-walking-dashed-line-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-walking-luggage";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "person-walking-with-cane";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "peseta-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "peso-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "phabricator"; type: "brands" }
  | { icon: "phoenix-framework"; type: "brands" }
  | { icon: "phoenix-squadron"; type: "brands" }
  | { icon: "phone"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "phone-arrow-down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-arrow-up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-flip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-hangup";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-intercom";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-missed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-office";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-rotary";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-volume";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "phone-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "photo-film";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "photo-film-music";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "php"; type: "brands" }
  | { icon: "pi"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "piano"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "piano-keyboard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pickleball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "pie"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "pied-piper"; type: "brands" }
  | { icon: "pied-piper-alt"; type: "brands" }
  | { icon: "pied-piper-hat"; type: "brands" }
  | { icon: "pied-piper-pp"; type: "brands" }
  | { icon: "pied-piper-square"; type: "brands" }
  | { icon: "pig"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "piggy-bank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "pills"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "pinata"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "pinball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pineapple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "pinterest"; type: "brands" }
  | { icon: "pinterest-p"; type: "brands" }
  | { icon: "pinterest-square"; type: "brands" }
  | { icon: "pipe"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "pipe-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pipe-collar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pipe-section";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pipe-smoking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pipe-valve";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "pix"; type: "brands" }
  | { icon: "pizza"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "pizza-slice";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "place-of-worship";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "plane"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "plane-arrival";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-departure";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-engines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-prop";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-tail";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plane-up-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "planet-moon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "planet-ringed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plant-wilt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plate-utensils";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plate-wheat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "play"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "play-pause";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "playstation"; type: "brands" }
  | { icon: "plug"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "plug-circle-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plug-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plug-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plug-circle-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plug-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plug-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "plus"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "plus-large";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "plus-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "podcast";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "podium"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "podium-star";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "police-box";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "poll-people";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pompebled";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "poo"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "poo-storm";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pool-8-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "poop"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "popcorn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "popsicle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pot-food";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "potato"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "power-off";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "prescription";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "prescription-bottle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "prescription-bottle-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "presentation-screen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pretzel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "print"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "print-magnifying-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "print-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "product-hunt"; type: "brands" }
  | {
      icon: "projector";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "pump"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "pump-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pump-soap";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "pumpkin";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "pushed"; type: "brands" }
  | { icon: "puzzle"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "puzzle-piece";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "puzzle-piece-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "python"; type: "brands" }
  | { icon: "q"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "qq"; type: "brands" }
  | { icon: "qrcode"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "quinscape"; type: "brands" }
  | { icon: "quora"; type: "brands" }
  | {
      icon: "quote-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "quote-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "quotes"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "r"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "r-project"; type: "brands" }
  | { icon: "rabbit"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "rabbit-running";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "racquet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "radar"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "radiation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "radio"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "radio-tuner";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rainbow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "raindrops";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ram"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "ramp-loading";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ranking-star";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "raspberry-pi"; type: "brands" }
  | { icon: "ravelry"; type: "brands" }
  | { icon: "raygun"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "react"; type: "brands" }
  | { icon: "reacteurope"; type: "brands" }
  | { icon: "readme"; type: "brands" }
  | { icon: "rebel"; type: "brands" }
  | {
      icon: "receipt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "record-vinyl";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-ad";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-barcode";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-code";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-history";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-history-circle-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-history-circle-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-list";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-pro";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-terminal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-vertical-history";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-wide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rectangles-mixed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "recycle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "red-river"; type: "brands" }
  | { icon: "reddit"; type: "brands" }
  | { icon: "reddit-alien"; type: "brands" }
  | { icon: "reddit-square"; type: "brands" }
  | { icon: "redhat"; type: "brands" }
  | { icon: "reel"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "refrigerator";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "registered";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "renren"; type: "brands" }
  | { icon: "repeat"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "repeat-1";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "reply"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "reply-all";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "reply-clock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "replyd"; type: "brands" }
  | {
      icon: "republican";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "researchgate"; type: "brands" }
  | { icon: "resolving"; type: "brands" }
  | {
      icon: "restroom";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "restroom-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "retweet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "rev"; type: "brands" }
  | {
      icon: "rhombus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ribbon"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "right"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "right-from-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "right-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "right-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "right-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "right-long-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "right-to-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "right-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ring"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "rings-wedding";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "road"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "road-barrier";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "road-bridge";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "road-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "road-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "road-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "road-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "road-spikes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "robot"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "robot-astromech";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "rocket"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "rocket-launch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "rocketchat"; type: "brands" }
  | { icon: "rockrms"; type: "brands" }
  | {
      icon: "roller-coaster";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "rotate"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "rotate-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rotate-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rotate-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "route"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "route-highway";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "route-interstate";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "router"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "rss"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "ruble-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "rug"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "rugby-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ruler"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "ruler-combined";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ruler-horizontal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ruler-triangle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ruler-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rupee-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "rupiah-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "rust"; type: "brands" }
  | { icon: "rv"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "s"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "sack"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sack-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sack-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "safari"; type: "brands" }
  | {
      icon: "sailboat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "salad"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "salesforce"; type: "brands" }
  | {
      icon: "salt-shaker";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sandwich";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sass"; type: "brands" }
  | {
      icon: "satellite";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "satellite-dish";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sausage";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "saxophone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "saxophone-fire";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scale-balanced";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scale-unbalanced";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scale-unbalanced-flip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scalpel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scalpel-line-dashed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scanner";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scanner-gun";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scanner-keyboard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scanner-touchscreen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scarecrow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "scarf"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "schlix"; type: "brands" }
  | { icon: "school"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "school-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "school-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "school-circle-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "school-flag";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "school-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scissors";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "screen-users";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "screencast";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "screenpal"; type: "brands" }
  | {
      icon: "screwdriver";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "screwdriver-wrench";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scribble";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "scribd"; type: "brands" }
  | { icon: "scroll"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "scroll-old";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scroll-torah";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "scrubber";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "scythe"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sd-card";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sd-cards";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "seal"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "seal-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "seal-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "searchengin"; type: "brands" }
  | {
      icon: "seat-airline";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "section";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "seedling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sellcast"; type: "brands" }
  | { icon: "sellsy"; type: "brands" }
  | {
      icon: "semicolon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "send-back";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "send-backward";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sensor"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sensor-cloud";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sensor-fire";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sensor-on";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sensor-triangle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "server"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "servicestack"; type: "brands" }
  | { icon: "shapes"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "share"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "share-all";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "share-from-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "share-nodes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sheep"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sheet-plastic";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shekel-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shelves";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shelves-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "shield"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "shield-cat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-cross";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-dog";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-halved";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-keyhole";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-quartered";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-virus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shield-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "ship"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "shirt"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "shirt-long-sleeve";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shirt-running";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shirt-tank-top";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "shirtsinbulk"; type: "brands" }
  | {
      icon: "shish-kebab";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shoe-prints";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "shop"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "shop-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shop-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "shopify"; type: "brands" }
  | { icon: "shopware"; type: "brands" }
  | { icon: "shovel"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "shovel-snow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "shower"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "shower-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shredder";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "shrimp"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "shuffle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shutters";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shuttle-space";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "shuttlecock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sickle"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sidebar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sidebar-flip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sigma"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sign-hanging";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "signal"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "signal-bars";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-bars-fair";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-bars-good";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-bars-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-bars-weak";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-fair";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-good";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-stream";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-stream-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-strong";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signal-weak";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signature";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signature-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signature-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "signs-post";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sim-card";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sim-cards";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "simplybuilt"; type: "brands" }
  | { icon: "sink"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "siren"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "siren-on";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sistrix"; type: "brands" }
  | {
      icon: "sitemap";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sith"; type: "brands" }
  | { icon: "sitrox"; type: "brands" }
  | {
      icon: "skeleton";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sketch"; type: "brands" }
  | {
      icon: "ski-boot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ski-boot-ski";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "skull"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "skull-cow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "skull-crossbones";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "skyatlas"; type: "brands" }
  | { icon: "skype"; type: "brands" }
  | { icon: "slack"; type: "brands" }
  | { icon: "slash"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "slash-back";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "slash-forward";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sleigh"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "slider"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sliders";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sliders-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sliders-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "slideshare"; type: "brands" }
  | {
      icon: "slot-machine";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "smog"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "smoke"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "smoking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "snake"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "snapchat"; type: "brands" }
  | { icon: "snapchat-square"; type: "brands" }
  | { icon: "snooze"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "snow-blowing";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "snowflake";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "snowflakes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "snowman";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "snowman-head";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "snowplow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "soap"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "socks"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "soft-serve";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "solar-panel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "solar-system";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sort"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sort-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sort-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "soundcloud"; type: "brands" }
  | { icon: "sourcetree"; type: "brands" }
  | { icon: "spa"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "space-station-moon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "space-station-moon-construction";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "spade"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "spaghetti-monster-flying";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sparkles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "speakap"; type: "brands" }
  | {
      icon: "speaker";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "speaker-deck"; type: "brands" }
  | {
      icon: "speakers";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "spell-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "spider"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "spider-black-widow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "spider-web";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "spinner";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "spinner-third";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "split"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "splotch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "spoon"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sportsball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "spotify"; type: "brands" }
  | {
      icon: "spray-can";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "spray-can-sparkles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sprinkler";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sprinkler-ceiling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "square"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "square-0";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-1";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-2";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-3";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-4";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-5";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-6";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-7";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-8";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-9";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-a";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-a-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-ampersand";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-arrow-down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-arrow-down-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-arrow-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-arrow-up-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-arrow-up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-b";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-c";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-caret-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-caret-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-caret-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-caret-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-chevron-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-chevron-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-chevron-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-chevron-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-code";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-d";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-dashed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-divide";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-dollar";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-down-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-e";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-ellipsis";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-ellipsis-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-envelope";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-f";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "square-font-awesome"; type: "brands" }
  | { icon: "square-font-awesome-stroke"; type: "brands" }
  | {
      icon: "square-fragile";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-full";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-g";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-h";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-heart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-i";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-info";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-j";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-k";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-kanban";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-l";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-list";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-m";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-n";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-nfi";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-o";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-p";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-parking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-parking-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-person-confined";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-phone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-phone-flip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-phone-hangup";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-poll-horizontal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-poll-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-q";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-quarters";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-question";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-quote";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-r";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-ring";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-root";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-root-variable";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-rss";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-s";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-share-nodes";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-sliders";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-sliders-vertical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-small";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-star";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-t";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-terminal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-this-way-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-u";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-up-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-user";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-v";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-virus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-w";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-x";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-y";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "square-z";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "squarespace"; type: "brands" }
  | { icon: "squid"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "squirrel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "stack-exchange"; type: "brands" }
  | { icon: "stack-overflow"; type: "brands" }
  | { icon: "stackpath"; type: "brands" }
  | { icon: "staff"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "staff-aesculapius";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "stairs"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "stamp"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "standard-definition";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "star"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "star-and-crescent";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-christmas";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-half";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-half-stroke";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-of-david";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-of-life";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-sharp";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-sharp-half";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-sharp-half-stroke";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "star-shooting";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "starfighter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "starfighter-twin-ion-engine";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "starfighter-twin-ion-engine-advanced";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "stars"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "starship";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "starship-freighter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "staylinked"; type: "brands" }
  | { icon: "steak"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "steam"; type: "brands" }
  | { icon: "steam-square"; type: "brands" }
  | { icon: "steam-symbol"; type: "brands" }
  | {
      icon: "steering-wheel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sterling-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "stethoscope";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sticker-mule"; type: "brands" }
  | {
      icon: "stocking";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "stomach";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "stop"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "stopwatch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "stopwatch-20";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "store"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "store-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "store-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "strava"; type: "brands" }
  | {
      icon: "strawberry";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "street-view";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "stretcher";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "strikethrough";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "stripe"; type: "brands" }
  | { icon: "stripe-s"; type: "brands" }
  | {
      icon: "stroopwafel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "studiovinari"; type: "brands" }
  | { icon: "stumbleupon"; type: "brands" }
  | { icon: "stumbleupon-circle"; type: "brands" }
  | {
      icon: "subscript";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "suitcase";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "suitcase-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "suitcase-rolling";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sun"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sun-bright";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sun-cloud";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sun-dust";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sun-haze";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sun-plant-wilt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sunglasses";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sunrise";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "sunset"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "superpowers"; type: "brands" }
  | {
      icon: "superscript";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "supple"; type: "brands" }
  | { icon: "suse"; type: "brands" }
  | { icon: "sushi"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sushi-roll";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "swatchbook";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "swift"; type: "brands" }
  | { icon: "sword"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "sword-laser";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "sword-laser-alt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "swords"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "swords-laser";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "symbols";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "symfony"; type: "brands" }
  | {
      icon: "synagogue";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "syringe";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "t"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "table"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "table-cells";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "table-cells-large";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "table-columns";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "table-layout";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "table-list";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "table-picnic";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "table-pivot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "table-rows";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "table-tennis-paddle-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "table-tree";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tablet"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tablet-button";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tablet-rugged";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tablet-screen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tablet-screen-button";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tablets";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tachograph-digital";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "taco"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "tag"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "tags"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "tally"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tally-1";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tally-2";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tally-3";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tally-4";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tamale"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tank-water";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tape"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "tarp"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tarp-droplet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "taxi"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "taxi-bus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "teamspeak"; type: "brands" }
  | {
      icon: "teddy-bear";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "teeth"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "teeth-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "telegram"; type: "brands" }
  | {
      icon: "telescope";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-full";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-half";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-high";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-list";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-low";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-quarter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-snow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-sun";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "temperature-three-quarters";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tencent-weibo"; type: "brands" }
  | {
      icon: "tenge-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tennis-ball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tent"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tent-arrow-down-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tent-arrow-left-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tent-arrow-turn-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tent-arrows-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tents"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "terminal";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "text"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "text-height";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "text-size";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "text-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "text-width";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "the-red-yeti"; type: "brands" }
  | { icon: "themeco"; type: "brands" }
  | { icon: "themeisle"; type: "brands" }
  | {
      icon: "thermometer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "theta"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "think-peaks"; type: "brands" }
  | {
      icon: "thought-bubble";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "thumbs-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "thumbs-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "thumbtack";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tick"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "ticket"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "ticket-airline";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "ticket-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tickets-airline";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tiktok"; type: "brands" }
  | { icon: "tilde"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "timeline";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "timeline-arrow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "timer"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "tire"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tire-flat";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tire-pressure-warning";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tire-rugged";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toggle-off";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toggle-on";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "toilet"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "toilet-paper";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toilet-paper-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toilet-paper-blank-under";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toilet-paper-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toilet-paper-under";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toilet-paper-under-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toilet-portable";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toilets-portable";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tomato"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tombstone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tombstone-blank";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "toolbox";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tooth"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "toothbrush";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "torii-gate";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tornado";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tower-broadcast";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tower-cell";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tower-control";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tower-observation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tractor";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "trade-federation"; type: "brands" }
  | {
      icon: "trademark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "traffic-cone";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "traffic-light";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "traffic-light-go";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "traffic-light-slow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "traffic-light-stop";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trailer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "train"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "train-subway";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "train-subway-tunnel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "train-track";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "train-tram";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "train-tunnel";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transformer-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transgender";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transporter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transporter-1";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transporter-2";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transporter-3";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transporter-4";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transporter-5";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transporter-6";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transporter-7";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "transporter-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "trash"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "trash-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-can";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-can-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-can-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-can-clock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-can-list";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-can-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-can-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-can-undo";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-can-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-clock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-list";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-undo";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trash-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "treasure-chest";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tree"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tree-christmas";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tree-city";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tree-deciduous";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tree-decorated";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tree-large";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tree-palm";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "trees"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "trello"; type: "brands" }
  | {
      icon: "triangle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "triangle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "triangle-instrument";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "triangle-person-digging";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trillium";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "trophy"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "trophy-star";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "trowel"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "trowel-bricks";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "truck"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "truck-arrow-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-bolt";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-clock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-container";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-container-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-droplet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-fast";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-field";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-field-un";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-flatbed";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-front";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-monster";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-moving";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-pickup";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-plane";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-plow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-ramp";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-ramp-box";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-ramp-couch";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "truck-tow";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "trumpet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tty"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tty-answer";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tugrik-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "tumblr"; type: "brands" }
  | { icon: "tumblr-square"; type: "brands" }
  | { icon: "turkey"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "turkish-lira-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "turn-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "turn-down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "turn-down-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "turn-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "turntable";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "turtle"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "tv"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "tv-music";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "tv-retro";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "twitch"; type: "brands" }
  | { icon: "twitter"; type: "brands" }
  | { icon: "twitter-square"; type: "brands" }
  | {
      icon: "typewriter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "typo3"; type: "brands" }
  | { icon: "u"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "uber"; type: "brands" }
  | { icon: "ubuntu"; type: "brands" }
  | { icon: "ufo"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "ufo-beam";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "uikit"; type: "brands" }
  | { icon: "umbraco"; type: "brands" }
  | {
      icon: "umbrella";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "umbrella-beach";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "umbrella-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "uncharted"; type: "brands" }
  | {
      icon: "underline";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "unicorn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "uniform-martial-arts";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "union"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "uniregistry"; type: "brands" }
  | { icon: "unity"; type: "brands" }
  | {
      icon: "universal-access";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "unlock"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "unlock-keyhole";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "unsplash"; type: "brands" }
  | { icon: "untappd"; type: "brands" }
  | { icon: "up"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "up-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-down-left-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-from-bracket";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-from-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-from-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-right-and-down-left-from-center";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-right-from-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-to-dotted-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "up-to-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "upload"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "ups"; type: "brands" }
  | { icon: "usb"; type: "brands" }
  | {
      icon: "usb-drive";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "user"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "user-alien";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-astronaut";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-bounty-hunter";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-chef";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-clock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-cowboy";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-crown";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-doctor";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-doctor-hair";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-doctor-hair-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-doctor-message";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-gear";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-graduate";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-group";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-group-crown";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-hair";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-hair-buns";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-hair-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-hair-mullet";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-headset";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-helmet-safety";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-injured";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-large";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-large-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-lock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-minus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-music";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-ninja";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-nurse";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-nurse-hair";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-nurse-hair-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-pen";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-pilot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-pilot-tie";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-police";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-police-tie";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-robot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-robot-xmarks";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-secret";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-shakespeare";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-shield";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-tag";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-tie";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-tie-hair";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-tie-hair-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-unlock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-visor";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-vneck";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-vneck-hair";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-vneck-hair-long";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "user-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "users"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "users-between-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "users-gear";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "users-line";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "users-medical";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "users-rays";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "users-rectangle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "users-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "users-viewfinder";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "usps"; type: "brands" }
  | { icon: "ussunnah"; type: "brands" }
  | {
      icon: "utensils";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "utensils-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "utility-pole";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "utility-pole-double";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "v"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "vaadin"; type: "brands" }
  | { icon: "vacuum"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "vacuum-robot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "value-absolute";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "van-shuttle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "vault"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "vector-circle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "vector-polygon";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "vector-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "vent-damper";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "venus"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "venus-double";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "venus-mars";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "vest"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "vest-patches";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "viacoin"; type: "brands" }
  | { icon: "viadeo"; type: "brands" }
  | { icon: "viadeo-square"; type: "brands" }
  | { icon: "vial"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "vial-circle-check";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "vial-virus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "vials"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "viber"; type: "brands" }
  | { icon: "video"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "video-arrow-down-left";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "video-arrow-up-right";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "video-plus";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "video-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "vihara"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "vimeo"; type: "brands" }
  | { icon: "vimeo-square"; type: "brands" }
  | { icon: "vimeo-v"; type: "brands" }
  | { icon: "vine"; type: "brands" }
  | { icon: "violin"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "virus"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "virus-covid";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "virus-covid-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "virus-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "viruses";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "vk"; type: "brands" }
  | { icon: "vnv"; type: "brands" }
  | {
      icon: "voicemail";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "volcano";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "volleyball";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "volume"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "volume-high";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "volume-low";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "volume-off";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "volume-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "volume-xmark";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "vr-cardboard";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "vuejs"; type: "brands" }
  | { icon: "w"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "waffle"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "wagon-covered";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "walker"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "walkie-talkie";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "wallet"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "wand"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "wand-magic";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wand-magic-sparkles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wand-sparkles";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "warehouse";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "warehouse-full";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "washing-machine";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "watch"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "watch-apple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "watch-calculator";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "watch-fitness";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "watch-smart";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "watchman-monitoring"; type: "brands" }
  | { icon: "water"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "water-arrow-down";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "water-arrow-up";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "water-ladder";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "watermelon-slice";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wave-pulse";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wave-sine";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wave-square";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wave-triangle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "waveform";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "waveform-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "waze"; type: "brands" }
  | { icon: "weebly"; type: "brands" }
  | { icon: "weibo"; type: "brands" }
  | {
      icon: "weight-hanging";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "weight-scale";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "weixin"; type: "brands" }
  | { icon: "whale"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "whatsapp"; type: "brands" }
  | { icon: "whatsapp-square"; type: "brands" }
  | { icon: "wheat"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "wheat-awn";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wheat-awn-circle-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wheat-awn-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wheat-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wheelchair";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wheelchair-move";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "whiskey-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "whiskey-glass-ice";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "whistle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "whmcs"; type: "brands" }
  | { icon: "wifi"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "wifi-exclamation";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wifi-fair";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wifi-slash";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wifi-weak";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "wikipedia-w"; type: "brands" }
  | { icon: "wind"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "wind-turbine";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wind-warning";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "window"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "window-flip";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "window-frame";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "window-frame-open";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "window-maximize";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "window-minimize";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "window-restore";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "windows"; type: "brands" }
  | {
      icon: "windsock";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wine-bottle";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wine-glass";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wine-glass-crack";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "wine-glass-empty";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "wirsindhandwerk"; type: "brands" }
  | { icon: "wix"; type: "brands" }
  | { icon: "wizards-of-the-coast"; type: "brands" }
  | { icon: "wodu"; type: "brands" }
  | { icon: "wolf-pack-battalion"; type: "brands" }
  | {
      icon: "won-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "wordpress"; type: "brands" }
  | { icon: "wordpress-simple"; type: "brands" }
  | { icon: "worm"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "wpbeginner"; type: "brands" }
  | { icon: "wpexplorer"; type: "brands" }
  | { icon: "wpforms"; type: "brands" }
  | { icon: "wpressr"; type: "brands" }
  | { icon: "wreath"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "wrench"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "wrench-simple";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "x"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "x-ray"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "xbox"; type: "brands" }
  | { icon: "xing"; type: "brands" }
  | { icon: "xing-square"; type: "brands" }
  | { icon: "xmark"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | {
      icon: "xmark-large";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "xmark-to-slot";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "xmarks-lines";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "y"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "y-combinator"; type: "brands" }
  | { icon: "yahoo"; type: "brands" }
  | { icon: "yammer"; type: "brands" }
  | { icon: "yandex"; type: "brands" }
  | { icon: "yandex-international"; type: "brands" }
  | { icon: "yarn"; type: "brands" }
  | { icon: "yelp"; type: "brands" }
  | {
      icon: "yen-sign";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | {
      icon: "yin-yang";
      type: "solid" | "regular" | "light" | "thin" | "duotone";
    }
  | { icon: "yoast"; type: "brands" }
  | { icon: "youtube"; type: "brands" }
  | { icon: "youtube-square"; type: "brands" }
  | { icon: "z"; type: "solid" | "regular" | "light" | "thin" | "duotone" }
  | { icon: "zhihu"; type: "brands" };
